const icons = {
  reset_password: (
    <svg
      width="86"
      height="80"
      viewBox="0 0 86 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.6667 34.662H45.3333V26.662C45.3333 23.7233 42.9387 21.3286 40 21.3286C37.0613 21.3286 34.6667 23.7233 34.6667 26.662V34.662H29.3333V26.662C29.3333 20.7793 34.1173 15.9953 40 15.9953C45.8827 15.9953 50.6667 20.7793 50.6667 26.662V34.662Z"
        fill="#1D1952"
      />
      <path
        d="M83.6587 24.1873C82.2987 23.6433 80.7413 24.3046 80.1973 25.6753L78.6027 29.6646C74.0267 12.6033 58.48 -0.00469208 40 -0.00469208C17.9413 -0.00469208 0 17.9366 0 39.9953C0 62.054 17.9413 79.9953 40 79.9953C50.6827 79.9953 60.7307 75.8353 68.288 68.2833C69.328 67.2433 69.328 65.5526 68.288 64.5126C67.248 63.4726 65.5573 63.4726 64.5173 64.5126C57.9627 71.0566 49.2587 74.662 40 74.662C20.8853 74.662 5.33333 59.11 5.33333 39.9953C5.33333 20.8806 20.8853 5.32864 40 5.32864C56.6453 5.32864 70.5813 17.126 73.904 32.7953L68.5547 27.4406C67.5147 26.4006 65.824 26.4006 64.784 27.4406C63.744 28.4806 63.744 30.1713 64.784 31.2113L75.4507 41.878C75.952 42.39 76.6347 42.662 77.3333 42.662C77.5093 42.662 77.6907 42.646 77.872 42.6086C78.3039 42.5203 78.707 42.3258 79.045 42.0428C79.383 41.7597 79.6452 41.397 79.808 40.9873L85.1413 27.654C85.6853 26.2833 85.024 24.7313 83.6587 24.1873Z"
        fill="#1D1952"
      />
      <path
        d="M53.3333 31.9953H26.6667C25.1947 31.9953 24 33.19 24 34.662V55.9953C24 57.4673 25.1947 58.662 26.6667 58.662H53.3333C54.8053 58.662 56 57.4673 56 55.9953V34.662C56 33.19 54.8053 31.9953 53.3333 31.9953Z"
        fill="#3B65E3"
      />
    </svg>
  ),
  visible: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8983 7.68881C15.7553 7.49328 12.3496 2.90112 7.9999 2.90112C3.65018 2.90112 0.244309 7.49328 0.101528 7.68862C0.0355528 7.77901 0 7.88802 0 7.99992C0 8.11182 0.0355528 8.22083 0.101528 8.31122C0.244309 8.50675 3.65018 13.0989 7.9999 13.0989C12.3496 13.0989 15.7553 8.50672 15.8983 8.31137C15.9643 8.22103 16 8.11201 16 8.00009C16 7.88817 15.9643 7.77915 15.8983 7.68881ZM7.9999 12.044C4.79587 12.044 2.02084 8.99606 1.19937 7.99965C2.01978 7.00237 4.789 3.95606 7.9999 3.95606C11.2038 3.95606 13.9786 7.00344 14.8004 8.00037C13.98 8.99762 11.2108 12.044 7.9999 12.044Z"
        fill="#1D1952"
      />
      <path
        d="M7.9998 4.83521C6.25474 4.83521 4.83496 6.25498 4.83496 8.00004C4.83496 9.7451 6.25474 11.1649 7.9998 11.1649C9.74487 11.1649 11.1646 9.7451 11.1646 8.00004C11.1646 6.25498 9.74487 4.83521 7.9998 4.83521ZM7.9998 10.1099C6.83637 10.1099 5.88993 9.16345 5.88993 8.00004C5.88993 6.83663 6.8364 5.89017 7.9998 5.89017C9.16321 5.89017 10.1097 6.83663 10.1097 8.00004C10.1097 9.16345 9.16324 10.1099 7.9998 10.1099Z"
        fill="#1D1952"
      />
    </svg>
  ),
  not_visible: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_20)">
        <mask
          id="mask0_2_20"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={16}
          height={16}
        >
          <path d="M16 0H0V16H16V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2_20)">
          <path
            d="M9.98636 8.13478L10.8951 7.22603C10.9612 7.47341 11 7.73203 11 8.00003C11 9.65428 9.65424 11 7.99999 11C7.73199 11 7.47336 10.9613 7.22599 10.8952L8.13474 9.98641C8.61507 9.95378 9.06732 9.74823 9.40775 9.4078C9.74818 9.06736 9.95374 8.61512 9.98636 8.13478ZM15.937 7.75716C15.8755 7.64653 15.0032 6.11816 13.2982 4.82291L12.5706 5.55053C13.8139 6.46466 14.6016 7.53078 14.9117 8.00078C14.3191 8.90316 11.9944 12 7.99999 12C7.40099 12 6.84399 11.9234 6.31986 11.8012L5.49824 12.6228C6.25361 12.8544 7.08386 13 7.99999 13C13.2341 13 15.8291 8.43703 15.937 8.24291C15.9783 8.16863 16 8.08503 16 8.00003C16 7.91503 15.9783 7.83144 15.937 7.75716ZM13.8535 2.85353L2.85349 13.8535C2.75586 13.9512 2.62786 14 2.49999 14C2.37211 14 2.24411 13.9512 2.14649 13.8535C2.10003 13.8071 2.06317 13.752 2.03803 13.6914C2.01288 13.6307 1.99994 13.5657 1.99994 13.5C1.99994 13.4344 2.01288 13.3694 2.03803 13.3087C2.06317 13.248 2.10003 13.1929 2.14649 13.1465L3.54599 11.747C1.28349 10.3812 0.133861 8.37053 0.0629858 8.24291C0.0216782 8.1686 0 8.08499 0 7.99997C0 7.91495 0.0216782 7.83134 0.0629858 7.75703C0.170861 7.56303 2.76586 3.00003 7.99999 3.00003C9.35336 3.00003 10.5256 3.30878 11.5277 3.76528L13.1465 2.14653C13.3419 1.95116 13.6582 1.95116 13.8535 2.14653C14.0487 2.34191 14.0489 2.65828 13.8535 2.85353ZM4.29161 11.0014L5.55749 9.73553C5.20786 9.24503 4.99999 8.64691 4.99999 8.00003C4.99999 6.34578 6.34574 5.00003 7.99999 5.00003C8.64686 5.00003 9.24499 5.20791 9.73549 5.55741L10.7591 4.53378C9.95036 4.20991 9.03136 4.00003 7.99999 4.00003C4.00561 4.00003 1.68086 7.09691 1.08836 7.99928C1.46461 8.56953 2.54611 10.013 4.29161 11.0014ZM6.28336 9.00953L9.00949 6.28341C8.71211 6.10778 8.36974 6.00003 7.99999 6.00003C6.89724 6.00003 5.99999 6.89728 5.99999 8.00003C5.99999 8.36978 6.10774 8.71216 6.28336 9.00953Z"
            fill="#ABABAB"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2_20">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  search: (
    <svg
      width={16}
      height={16}
      className="position-absolute searchIcon"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="6.95455"
        cy="6.95455"
        r="5.95455"
        stroke="black"
        strokeWidth={2}
      />
      <path
        d="M12 12L15 15"
        stroke="black"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  ),
  close: (
    <svg
      width={16}
      height={16}
      className="position-absolute searchIcon"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.46602 8.00015L15.6963 1.76973C16.1018 1.36446 16.1018 0.709174 15.6963 0.303952C15.2911 -0.101317 14.6358 -0.101317 14.2306 0.303952L8.0001 6.53432L1.76987 0.303952C1.36441 -0.101317 0.709368 -0.101317 0.304098 0.303952C-0.101366 0.709222 -0.101366 1.36446 0.304098 1.76973L6.53427 8.00015L0.304147 14.2305C-0.101317 14.6358 -0.101317 15.2911 0.304147 15.6963C0.400279 15.7927 0.514513 15.8692 0.640285 15.9213C0.766058 15.9734 0.90089 16.0001 1.03703 16C1.30235 16 1.56777 15.8984 1.76992 15.6963L8.0001 9.46592L14.2306 15.6963C14.3267 15.7927 14.4409 15.8691 14.5667 15.9212C14.6925 15.9734 14.8273 16.0001 14.9635 16C15.2288 16 15.4942 15.8984 15.6963 15.6963C16.1018 15.291 16.1018 14.6358 15.6963 14.2305L9.46602 8.00015Z"
        fill="black"
      />
    </svg>
  ),
  openEye: (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_1781)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.98532 8.99977C4.98532 6.78702 6.78515 4.98645 9.00029 4.98645C11.2131 4.98645 13.0129 6.78698 13.0129 8.99977C13.0129 11.213 11.2131 13.0128 9.00029 13.0128C6.78511 13.0128 4.98532 11.213 4.98532 8.99977ZM0.103836 8.61689C-0.0346121 8.86731 -0.0346121 9.13224 0.103836 9.38289C1.90128 12.6106 5.30993 14.6157 9.00029 14.6157C12.6882 14.6157 16.0969 12.6107 17.8943 9.38289C18.0352 9.13224 18.0352 8.86731 17.8943 8.61689C16.0969 5.38916 12.6883 3.38428 9.00029 3.38428C5.30993 3.38428 1.90128 5.38916 0.103836 8.61689ZM9.00029 6.30171C7.51079 6.30171 6.30054 7.51192 6.30054 8.99977C6.30054 10.4876 7.51075 11.6978 9.00029 11.6978C10.4874 11.6978 11.6976 10.4876 11.6976 8.99977C11.6976 7.51192 10.4874 6.30171 9.00029 6.30171Z"
          fill="#46C064"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_1781">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  closeEye: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_946_3942)">
        <path
          d="M9.98636 8.13478L10.8951 7.22603C10.9612 7.47341 11 7.73203 11 8.00003C11 9.65428 9.65424 11 7.99999 11C7.73199 11 7.47336 10.9613 7.22599 10.8952L8.13474 9.98641C8.61507 9.95378 9.06732 9.74823 9.40775 9.4078C9.74818 9.06736 9.95374 8.61512 9.98636 8.13478ZM15.937 7.75716C15.8755 7.64653 15.0032 6.11816 13.2982 4.82291L12.5706 5.55053C13.8139 6.46466 14.6016 7.53078 14.9117 8.00078C14.3191 8.90316 11.9944 12 7.99999 12C7.40099 12 6.84399 11.9234 6.31986 11.8012L5.49824 12.6228C6.25361 12.8544 7.08386 13 7.99999 13C13.2341 13 15.8291 8.43703 15.937 8.24291C15.9783 8.16863 16 8.08503 16 8.00003C16 7.91503 15.9783 7.83144 15.937 7.75716ZM13.8535 2.85353L2.85349 13.8535C2.75586 13.9512 2.62786 14 2.49999 14C2.37211 14 2.24411 13.9512 2.14649 13.8535C2.10003 13.8071 2.06317 13.752 2.03803 13.6914C2.01288 13.6307 1.99994 13.5657 1.99994 13.5C1.99994 13.4344 2.01288 13.3694 2.03803 13.3087C2.06317 13.248 2.10003 13.1929 2.14649 13.1465L3.54599 11.747C1.28349 10.3812 0.133861 8.37053 0.0629858 8.24291C0.0216782 8.1686 0 8.08499 0 7.99997C0 7.91495 0.0216782 7.83134 0.0629858 7.75703C0.170861 7.56303 2.76586 3.00003 7.99999 3.00003C9.35336 3.00003 10.5256 3.30878 11.5277 3.76528L13.1465 2.14653C13.3419 1.95116 13.6582 1.95116 13.8535 2.14653C14.0487 2.34191 14.0489 2.65828 13.8535 2.85353ZM4.29161 11.0014L5.55749 9.73553C5.20786 9.24503 4.99999 8.64691 4.99999 8.00003C4.99999 6.34578 6.34574 5.00003 7.99999 5.00003C8.64686 5.00003 9.24499 5.20791 9.73549 5.55741L10.7591 4.53378C9.95036 4.20991 9.03136 4.00003 7.99999 4.00003C4.00561 4.00003 1.68086 7.09691 1.08836 7.99928C1.46461 8.56953 2.54611 10.013 4.29161 11.0014ZM6.28336 9.00953L9.00949 6.28341C8.71211 6.10778 8.36974 6.00003 7.99999 6.00003C6.89724 6.00003 5.99999 6.89728 5.99999 8.00003C5.99999 8.36978 6.10774 8.71216 6.28336 9.00953Z"
          fill="#ABABAB"
        />
      </g>
      <defs>
        <clipPath id="clip0_946_3942">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  downArrow: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_964)">
        <path
          d="M15.2282 3.61636H0.771767C0.0876698 3.61636 -0.260832 4.44244 0.229652 4.93293L7.45785 12.1611C7.75472 12.458 8.2452 12.458 8.54221 12.1611L15.7704 4.93293C16.2608 4.44244 15.9123 3.61636 15.2282 3.61636Z"
          fill="#46C064"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_964">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  energy: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0625 27.5C9.0625 26.9822 9.48224 26.5625 10 26.5625H20C20.5177 26.5625 20.9375 26.9822 20.9375 27.5C20.9375 28.0178 20.5177 28.4375 20 28.4375H10C9.48224 28.4375 9.0625 28.0178 9.0625 27.5Z"
        fill="#809FB3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.5625C15.5177 1.5625 15.9375 1.98224 15.9375 2.5V3.75C15.9375 4.26776 15.5177 4.6875 15 4.6875C14.4822 4.6875 14.0625 4.26776 14.0625 3.75V2.5C14.0625 1.98224 14.4822 1.5625 15 1.5625ZM1.5625 15C1.5625 14.4822 1.98224 14.0625 2.5 14.0625H3.75C4.26776 14.0625 4.6875 14.4822 4.6875 15C4.6875 15.5177 4.26776 15.9375 3.75 15.9375H2.5C1.98224 15.9375 1.5625 15.5177 1.5625 15ZM25.3125 15C25.3125 14.4822 25.7322 14.0625 26.25 14.0625H27.5C28.0177 14.0625 28.4375 14.4822 28.4375 15C28.4375 15.5177 28.0177 15.9375 27.5 15.9375H26.25C25.7322 15.9375 25.3125 15.5177 25.3125 15Z"
        fill="#809FB3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3966 19.0625H7.60334H2.5C1.98224 19.0625 1.5625 19.4822 1.5625 20C1.5625 20.5178 1.98224 20.9375 2.5 20.9375H27.5C28.0177 20.9375 28.4375 20.5178 28.4375 20C28.4375 19.4822 28.0177 19.0625 27.5 19.0625H22.3966Z"
        fill="#809FB3"
      />
      <path
        d="M5.3125 23.75C5.3125 23.2322 5.73224 22.8125 6.25 22.8125H23.75C24.2677 22.8125 24.6875 23.2322 24.6875 23.75C24.6875 24.2678 24.2677 24.6875 23.75 24.6875H6.25C5.73224 24.6875 5.3125 24.2678 5.3125 23.75Z"
        fill="#809FB3"
      />
      <path
        d="M6.5625 14.9998C6.5625 16.472 6.94013 17.857 7.60334 19.0623H22.3966C23.0599 17.857 23.4375 16.472 23.4375 14.9998C23.4375 10.6568 20.1562 7.08013 15.9375 6.61378H14.0625C9.8438 7.08013 6.5625 10.6568 6.5625 14.9998Z"
        fill="#809FB3"
      />
      <path
        d="M14.3371 16.0513C14.7032 16.4174 15.2967 16.4174 15.6629 16.0513L18.1629 13.5513C18.529 13.1851 18.529 12.5915 18.1629 12.2254C17.7967 11.8593 17.2032 11.8593 16.8371 12.2254L15.9375 13.125V6.61345C15.3785 6.52781 14.4546 6.57776 14.0625 6.61345V13.125L13.1629 12.2254C12.7967 11.8593 12.2032 11.8593 11.8371 12.2254C11.471 12.5915 11.471 13.1851 11.8371 13.5513L14.3371 16.0513Z"
        fill="#809FB3"
      />
      <path
        d="M5.49797 5.49798C5.86409 5.13186 6.45769 5.13186 6.8238 5.49798L7.31485 5.98903C7.68096 6.35514 7.68096 6.94873 7.31485 7.31485C6.94872 7.68096 6.35514 7.68096 5.98902 7.31485L5.49797 6.8238C5.13186 6.45769 5.13186 5.86409 5.49797 5.49798Z"
        fill="#809FB3"
      />
      <path
        d="M24.5011 5.4983C24.8672 5.86441 24.8672 6.45801 24.5011 6.82413L24.0101 7.31518C23.644 7.68129 23.0504 7.68129 22.6842 7.31518C22.3181 6.94905 22.3181 6.35546 22.6842 5.98935L23.1752 5.4983C23.5414 5.13219 24.135 5.13219 24.5011 5.4983Z"
        fill="#809FB3"
      />
    </svg>
  ),
  mudra: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0625 21.3747C11.7254 21.4103 11.1543 21.4561 10.4419 21.4561C8.62107 21.4561 5.88762 21.1553 3.83883 19.6187C2.04668 20.5271 0.627715 22.0252 0 22.7576C0.936504 23.8502 3.63416 26.6476 6.70512 26.6475C9.7858 26.6475 12.4769 23.851 13.4106 22.7582C13.1188 22.4176 12.6554 21.9108 12.0625 21.3747Z"
        fill="#9BD0B6"
      />
      <path
        d="M26.1472 19.6118C24.0975 21.1542 21.3587 21.4561 19.5352 21.4561C18.837 21.4561 18.2743 21.4121 17.9346 21.3768C17.3433 21.9117 16.881 22.4173 16.5894 22.7575C17.5258 23.8502 20.2232 26.6475 23.2942 26.6474C26.375 26.6475 29.0662 23.851 30 22.7583C29.3712 22.0245 27.9464 20.5199 26.1472 19.6118Z"
        fill="#9BD0B6"
      />
      <path
        d="M11.6259 19.9648C11.6292 19.9228 11.6323 19.8781 11.6355 19.8318C10.0263 17.9493 8.35987 15.2703 8.35987 12.2476C8.35987 12.0114 8.37094 11.7775 8.39051 11.5457C6.20555 10.3283 3.33334 10.391 2.14371 10.4824C2.03321 11.9173 1.96278 15.8029 4.13432 17.9743C6.30557 20.1456 10.1909 20.0752 11.6259 19.9648Z"
        fill="#9BD0B6"
      />
      <path
        d="M18.345 19.8813C18.347 19.9095 18.349 19.9384 18.351 19.9649C19.785 20.0753 23.6709 20.1461 25.8425 17.9743C28.0209 15.7961 27.9465 11.9156 27.8341 10.4826C26.6535 10.3915 23.8107 10.3286 21.6306 11.5211C21.6515 11.7609 21.6632 12.0029 21.6632 12.2475C21.6632 15.2969 19.9673 17.9964 18.345 19.8813Z"
        fill="#9BD0B6"
      />
      <path
        d="M15.0114 3.35256C13.6937 4.45916 9.80138 8.08113 9.80138 12.2476C9.80138 16.4142 13.6937 20.0363 15.0114 21.1428C16.3285 20.0368 20.2216 16.4145 20.2216 12.2476C20.2216 8.08113 16.3291 4.45904 15.0114 3.35256Z"
        fill="#9BD0B6"
      />
    </svg>
  ),
  chant: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.53432 24.6588C1.17753 21.8327 0 18.5789 0 14.901C0 12.4446 0.543607 10.1478 1.63082 8.01309C2.71804 5.87837 4.21252 4.10732 6.11341 2.70082C8.01343 1.2952 10.1297 0.393468 12.4622 0V9.55892C12.4622 12.8697 11.6389 15.8903 9.99074 18.6166C8.34255 21.3454 6.19157 23.3584 3.53432 24.6588ZM17.5292 23.9893C16.2587 22.3602 15.3964 20.5988 14.9414 18.7077C14.4985 20.5988 13.6423 22.3602 12.3727 23.9893C11.1031 25.6184 9.56957 27.0047 7.77289 28.1466C9.99942 29.3822 12.3883 30 14.9414 30C17.5075 30 19.9016 29.3822 22.129 28.1466C20.3314 27.0056 18.7996 25.6193 17.5292 23.9893ZM28.37 8.01309C27.2828 5.87749 25.7866 4.10732 23.8875 2.70082C21.9883 1.29433 19.8695 0.393468 17.5387 0V9.55892C17.5387 12.8697 18.3611 15.8903 20.0101 18.6166C21.6566 21.3428 23.8093 23.3557 26.4674 24.6588C28.8251 21.8327 30 18.5789 30 14.901C30 12.4455 29.4555 10.1487 28.37 8.01309Z"
        fill="#D68D96"
      />
    </svg>
  ),
  hongSue: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.7885 6.11538C27.5769 3.75 24.5192 -0.634616 18.8654 1.96154C15.3462 3.57692 13.3846 4.5 13.3846 4.5L8.3077 6.69231C6.86539 7.38461 3.75 6.40385 1.96154 5.76923C1.44231 5.59615 0.980773 6.11538 1.21154 6.63461C2.42308 9 5.48077 13.3846 11.1346 10.7885C14.6538 9.17308 21.6923 6.11538 21.6923 6.11538C23.1346 5.42308 26.25 6.40385 28.0385 7.03846C28.5577 7.15385 29.0192 6.63461 28.7885 6.11538ZM16.6154 13.5C15.9808 13.8462 13.4423 15 13.4423 15L10.9038 16.0962C9.63462 16.7885 6.92308 15.8654 5.3077 15.2308C4.84616 15 4.44231 15.5769 4.67308 16.0385C5.71154 18.3462 8.42308 22.5 13.3846 19.9615C16.5 18.4038 19.0962 17.3654 19.0962 17.3654C20.3654 16.6731 23.0769 17.5962 24.6923 18.2308C25.1539 18.4038 25.5577 17.8846 25.3269 17.3654C24.2885 15.1154 21.5769 10.9615 16.6154 13.5ZM14.7692 23.7115C14.25 24 13.3846 24.5192 13.3846 24.5192C12.4039 25.1538 10.3846 24.3462 9.17308 23.7692C8.82693 23.5962 8.53847 24.1154 8.71154 24.5769C9.46154 26.6538 11.4808 30.4038 15.2308 28.0962C16.6154 27.2308 16.6154 27.2885 16.6154 27.2885C17.6538 26.7692 19.6154 27.4615 20.8269 28.0385C21.1731 28.2115 21.4615 27.6923 21.2885 27.2308C20.5385 25.1538 18.6346 21.5769 14.7692 23.7115Z"
        fill="#986D9A"
      />
    </svg>
  ),
  aum: (
    <svg
      width={30}
      height={26}
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 16.7896C30 19.1965 29.0264 25.3895 23.7574 25.3895C18.7363 25.3895 16.9064 20.9543 17.2534 19.3497C17.5419 19.841 18.4569 22.3696 23.3968 22.3696C28.463 22.3696 28.5171 16.74 28.5171 16.74C28.5171 16.74 28.4315 12.7466 25.344 12.7466C21.5759 12.7466 21.4497 18.7367 17.6636 18.7367C15.766 18.7367 15.1305 17.7316 14.7474 17.4567C15.5632 19.9898 14.5986 25.8808 8.39662 25.8808C-0.455671 25.8808 0.00407057 16.3299 0.00407057 16.3299C0.00407057 16.3299 1.48697 22.2164 8.24337 22.2164C12.363 22.2164 12.9039 19.8636 12.9039 18.7863C12.9039 17.7136 12.0836 15.8205 8.39662 15.8205L7.58982 11.9939C7.58982 11.9939 8.68058 12.3499 10.0283 12.3499C11.8041 12.3499 12.2098 11.1645 12.2098 10.191C12.2098 9.22189 11.2587 8.2393 9.51893 8.2393C6.82358 8.2393 4.66009 11.0068 4.66009 11.0068L2.5642 7.11699C2.5642 7.11699 4.51135 4.60644 8.45522 4.60644C12.3946 4.60644 14.184 7.83365 14.184 9.7267C14.184 11.6198 13.3005 13.1883 11.6238 14.0762C13.8865 15.1399 13.2014 15.9197 14.6437 15.9197C17.0326 15.9197 17.3571 13.9681 18.4794 12.1967C19.5161 10.5696 20.99 9.11371 23.5997 9.11371C28.8236 9.11371 30 14.3872 30 16.7896ZM19.8136 8.5503C22.4683 8.5503 24.5237 7.01332 24.5237 7.01332L22.3196 3.12354C22.3196 3.12354 20.7871 5.27351 17.8168 5.27351C14.8465 5.27351 12.3901 2.56013 12.3901 2.56013C12.3901 2.56013 13.5169 8.5503 19.8136 8.5503ZM20.2237 2.3573L18.0197 0L15.5632 2.14997L17.7673 4.66052L20.2237 2.3573Z"
        fill="#D4CAA8"
      />
    </svg>
  ),
  kriya: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17_362)">
        <path
          d="M14.021 0.0140002C13.7032 -0.0513027 13.3847 0.116605 13.2577 0.414543L8.63377 11.2646C7.20823 14.4155 8.52378 18.1883 9.08581 19.5296L3.53746 24.1287C3.39573 24.2462 3.30761 24.416 3.29303 24.5994C3.27846 24.783 3.33877 24.9645 3.46017 25.1029L7.5546 29.7679C7.68444 29.9158 7.87123 29.9999 8.06676 29.9999C8.07827 29.9999 8.08977 29.9996 8.10128 29.999C8.30927 29.9885 8.50096 29.8835 8.62179 29.7139L14.4304 21.5616C14.5126 21.4463 14.5568 21.3081 14.5569 21.1665L14.5573 20.1942C14.5592 16.0523 14.5661 1.45018 14.5661 0.681508C14.5662 0.357871 14.3383 0.0787277 14.021 0.0140002Z"
          fill="#B0B38E"
        />
        <path
          d="M26.7069 24.5994C26.6925 24.4159 26.6042 24.2461 26.4625 24.1287L20.9141 19.5296C21.4762 18.1883 22.7917 14.4155 21.3661 11.2646L16.7422 0.414544C16.6153 0.116605 16.2962 -0.0512067 15.9789 0.0140003C15.6616 0.0787278 15.4337 0.357871 15.4337 0.681701C15.4337 1.45038 15.4406 16.0525 15.4425 20.1944L15.4429 21.1667C15.443 21.3083 15.4871 21.4464 15.5694 21.5618L21.378 29.7141C21.4988 29.8836 21.6905 29.9887 21.8985 29.9992C21.9101 29.9998 21.9216 30.0001 21.933 30.0001C22.1287 30.0001 22.3154 29.916 22.4452 29.7681L26.5396 25.1031C26.6612 24.9645 26.7215 24.783 26.7069 24.5994Z"
          fill="#B0B38E"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_362">
          <rect width={30} height={30} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  kriyaCount: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0625 27.5C9.0625 26.9822 9.48224 26.5625 10 26.5625H20C20.5177 26.5625 20.9375 26.9822 20.9375 27.5C20.9375 28.0178 20.5177 28.4375 20 28.4375H10C9.48224 28.4375 9.0625 28.0178 9.0625 27.5Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.5625C15.5177 1.5625 15.9375 1.98224 15.9375 2.5V3.75C15.9375 4.26776 15.5177 4.6875 15 4.6875C14.4822 4.6875 14.0625 4.26776 14.0625 3.75V2.5C14.0625 1.98224 14.4822 1.5625 15 1.5625ZM1.5625 15C1.5625 14.4822 1.98224 14.0625 2.5 14.0625H3.75C4.26776 14.0625 4.6875 14.4822 4.6875 15C4.6875 15.5177 4.26776 15.9375 3.75 15.9375H2.5C1.98224 15.9375 1.5625 15.5177 1.5625 15ZM25.3125 15C25.3125 14.4822 25.7322 14.0625 26.25 14.0625H27.5C28.0177 14.0625 28.4375 14.4822 28.4375 15C28.4375 15.5177 28.0177 15.9375 27.5 15.9375H26.25C25.7322 15.9375 25.3125 15.5177 25.3125 15Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3966 19.0625H7.60334H2.5C1.98224 19.0625 1.5625 19.4822 1.5625 20C1.5625 20.5178 1.98224 20.9375 2.5 20.9375H27.5C28.0177 20.9375 28.4375 20.5178 28.4375 20C28.4375 19.4822 28.0177 19.0625 27.5 19.0625H22.3966Z"
        fill="#000"
      />
      <path
        d="M5.3125 23.75C5.3125 23.2322 5.73224 22.8125 6.25 22.8125H23.75C24.2677 22.8125 24.6875 23.2322 24.6875 23.75C24.6875 24.2678 24.2677 24.6875 23.75 24.6875H6.25C5.73224 24.6875 5.3125 24.2678 5.3125 23.75Z"
        fill="#000"
      />
      <path
        d="M6.5625 14.9998C6.5625 16.472 6.94013 17.857 7.60334 19.0623H22.3966C23.0599 17.857 23.4375 16.472 23.4375 14.9998C23.4375 10.6568 20.1562 7.08013 15.9375 6.61378H14.0625C9.8438 7.08013 6.5625 10.6568 6.5625 14.9998Z"
        fill="#000"
      />
      <path
        d="M14.3371 16.0513C14.7032 16.4174 15.2967 16.4174 15.6629 16.0513L18.1629 13.5513C18.529 13.1851 18.529 12.5915 18.1629 12.2254C17.7967 11.8593 17.2032 11.8593 16.8371 12.2254L15.9375 13.125V6.61345C15.3785 6.52781 14.4546 6.57776 14.0625 6.61345V13.125L13.1629 12.2254C12.7967 11.8593 12.2032 11.8593 11.8371 12.2254C11.471 12.5915 11.471 13.1851 11.8371 13.5513L14.3371 16.0513Z"
        fill="#000"
      />
      <path
        d="M5.49797 5.49798C5.86409 5.13186 6.45769 5.13186 6.8238 5.49798L7.31485 5.98903C7.68096 6.35514 7.68096 6.94873 7.31485 7.31485C6.94872 7.68096 6.35514 7.68096 5.98902 7.31485L5.49797 6.8238C5.13186 6.45769 5.13186 5.86409 5.49797 5.49798Z"
        fill="#000"
      />
      <path
        d="M24.5011 5.4983C24.8672 5.86441 24.8672 6.45801 24.5011 6.82413L24.0101 7.31518C23.644 7.68129 23.0504 7.68129 22.6842 7.31518C22.3181 6.94905 22.3181 6.35546 22.6842 5.98935L23.1752 5.4983C23.5414 5.13219 24.135 5.13219 24.5011 5.4983Z"
        fill="#000"
      />
    </svg>
  ),
  readGood: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7148 2.31445C5.5957 2.90039 0 8.85352 0 16.125C0 23.7891 6.21094 30 13.875 30C21.1465 30 27.0996 24.4043 27.6914 17.2852H12.7148V2.31445ZM15.0293 0V14.9707H30C29.4316 6.95508 23.0449 0.568359 15.0293 0Z"
        fill="#E6A3C9"
      />
    </svg>
  ),
  readSrf: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.1036 27.4269V29.4994C25.1036 29.6318 25.051 29.7587 24.9575 29.8522C24.8639 29.9458 24.737 29.9984 24.6046 29.9984C18.9975 29.9984 19.43 30.0098 19.3181 29.9718C15.6588 28.7286 12.7272 26.4078 11.0299 22.8703C10.983 22.7723 10.9695 22.6616 10.9913 22.5552C11.0132 22.4487 11.0692 22.3523 11.1509 22.2807C11.3283 22.1249 11.4859 21.9479 11.6201 21.7536C11.7525 21.562 11.9962 21.4825 12.2134 21.5667C13.9893 22.2558 15.995 22.2641 17.7769 21.5602C17.9948 21.4742 18.2413 21.5516 18.3737 21.7448C18.7222 22.2538 19.2253 22.6371 19.8085 22.838L22.4909 23.7629C24.0539 24.3017 25.1036 25.7742 25.1036 27.4269ZM7.80277 29.9984H5.39531C5.26298 29.9984 5.13607 29.9458 5.0425 29.8522C4.94893 29.7587 4.89636 29.6318 4.89636 29.4994V27.4269C4.8962 26.5874 5.16884 25.7706 5.67322 25.0995C5.91901 24.7721 6.43928 24.8745 6.54755 25.2693C6.8196 26.2611 7.27963 27.1903 7.98701 27.9169C8.23355 28.1701 8.018 28.2625 8.28737 29.3814C8.36309 29.6956 8.12596 29.9984 7.80277 29.9984ZM15.798 29.9984H9.86684C9.75797 29.9983 9.6521 29.9627 9.56536 29.8969C9.47861 29.8311 9.41573 29.7388 9.3863 29.634C9.35576 29.5253 9.3267 29.4163 9.29911 29.3069C9.24959 29.1103 9.44349 28.9384 9.6319 29.0133C9.66184 29.0253 9.69196 29.0369 9.7224 29.0485C9.88044 29.1062 10.0415 29.0821 10.1665 29.0004C10.5064 28.7858 10.4626 28.2597 10.0723 28.1136C8.44442 27.504 7.6287 25.9619 7.34462 24.2597C7.32505 24.1435 7.34732 24.024 7.40747 23.9226C7.46762 23.8212 7.56176 23.7444 7.67317 23.7059C7.94291 23.6128 8.45396 23.4381 9.52731 23.0675C9.76755 22.9846 10.0309 23.0957 10.1411 23.3248C11.3906 25.9201 13.3359 28.036 15.9246 29.5339C16.1446 29.6612 16.0521 29.9984 15.798 29.9984ZM16.7301 1.9707C15.5876 1.75354 14.4145 1.75345 13.2719 1.97045C12.8366 2.05322 12.5165 1.57654 12.7608 1.20676C13.8247 -0.403708 16.1775 -0.400777 17.2393 1.20694C17.483 1.57598 17.1646 2.0534 16.7301 1.9707ZM23.2326 11.1291C23.2326 11.1291 23.2319 12.7484 23.2306 12.778C23.2147 13.1388 22.6712 13.1207 22.6712 12.7595V11.9965C22.6712 8.85139 19.7514 6.50479 16.7008 7.2166C15.4908 7.49856 14.4674 7.50474 13.3822 7.23656C11.1135 6.67543 8.89471 7.78858 7.88753 9.71444C7.88691 9.71506 7.88628 9.71506 7.88691 9.71568C7.52393 10.4086 7.32871 11.1869 7.32871 11.9965V12.7594C7.32871 13.1206 6.7853 13.1388 6.76934 12.7779C6.76659 12.7153 6.7674 12.8418 6.7674 11.0385C6.7674 6.48297 10.4859 2.7803 15.0473 2.80606C19.5903 2.83176 23.2326 6.58587 23.2326 11.1291Z"
        fill="#F2C6A1"
      />
      <path
        d="M16.9272 8.1883C15.5564 8.50762 14.3895 8.51324 13.1427 8.20514C10.6617 7.59156 8.32666 9.48961 8.32666 11.9965V14.4139C8.32666 18.0831 11.2797 21.0872 14.9994 21.0872C18.7211 21.0872 21.6734 17.9945 21.6734 14.3266V11.9965C21.6734 9.49267 19.3521 7.62505 16.9272 8.1883ZM14.5011 11.5998V11.0385C14.5011 10.7629 14.7244 10.5396 15 10.5396C15.2757 10.5396 15.499 10.7629 15.499 11.0385V11.5998C15.499 11.8755 15.2757 12.0988 15 12.0988C14.7244 12.0988 14.5011 11.8755 14.5011 11.5998Z"
        fill="#F2C6A1"
      />
    </svg>
  ),
  physicalExe: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_852_51)">
        <path
          d="M24.2961 0.00679526C19.4865 0.430669 15.9374 2.83133 13.8685 6.30186C12.4819 8.04003 9.7122 13.3467 8.7049 16.1247C6.87845 19.5792 5.28578 23.6894 4.03937 27.3947C3.27747 29.6605 6.69853 31.1387 7.4648 28.8627C8.39693 26.0906 9.52306 23.0934 10.7957 20.312C12.0585 23.1385 13.3418 25.9557 14.7196 28.7284C15.7876 30.8807 19.0011 28.9932 17.937 26.8481C16.5184 23.994 15.2007 21.0943 13.9024 18.1849C13.9189 18.1286 13.9398 18.0738 13.9572 18.018C14.1736 18.0796 14.4122 18.0986 14.675 18.0486L20.6359 16.9307C21.4851 16.7712 21.8106 15.8419 21.6767 15.098C21.2751 12.8685 20.005 11.3175 18.4239 9.84999C18.1892 9.05171 17.4064 8.34557 16.5378 7.6438C18.2988 4.79696 21.1738 3.25181 24.9159 2.92202C26.8258 2.7547 26.1895 -0.159553 24.2961 0.00679526ZM17.0582 12.6789C17.5495 13.1901 17.9676 13.7279 18.2833 14.3506L15.3991 14.8914C15.8841 14.1105 16.4423 13.3734 17.0582 12.6789Z"
          fill="#1B96B1"
        />
        <path
          d="M21.1708 10.141C22.5837 10.141 23.7291 8.99559 23.7291 7.58269C23.7291 6.16979 22.5837 5.02441 21.1708 5.02441C19.7579 5.02441 18.6125 6.16979 18.6125 7.58269C18.6125 8.99559 19.7579 10.141 21.1708 10.141Z"
          fill="#1B96B1"
        />
      </g>
      <defs>
        <clipPath id="clip0_852_51">
          <rect width={30} height={30} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  documentPreview: (
    <svg
      width={28}
      height={28}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={6} fill="#E58344" />
      <g clipPath="url(#clip0_14_661)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4314 17.9999C14.4314 16.033 16.0312 14.4325 18.0003 14.4325C19.9672 14.4325 21.567 16.0329 21.567 17.9999C21.567 19.9672 19.9672 21.567 18.0003 21.567C16.0312 21.567 14.4314 19.9672 14.4314 17.9999ZM10.0923 17.6595C9.96923 17.8821 9.96923 18.1176 10.0923 18.3404C11.69 21.2095 14.7199 22.9918 18.0003 22.9918C21.2784 22.9918 24.3084 21.2095 25.9061 18.3404C26.0313 18.1176 26.0313 17.8821 25.9061 17.6595C24.3084 14.7904 21.2784 13.0083 18.0003 13.0083C14.7199 13.0083 11.69 14.7904 10.0923 17.6595ZM18.0003 15.6016C16.6763 15.6016 15.6005 16.6773 15.6005 17.9999C15.6005 19.3224 16.6762 20.3981 18.0003 20.3981C19.3221 20.3981 20.3979 19.3224 20.3979 17.9999C20.3979 16.6773 19.3221 15.6016 18.0003 15.6016Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_661">
          <rect
            width={16}
            height={16}
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  deleteIcon: (
    <svg
      width={28}
      height={28}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={6} fill="#FF1C0D" />
      <g clipPath="url(#clip0_14_673)">
        <path
          d="M22.8257 11.6286H13.1743C12.7123 11.6294 12.2695 11.8133 11.9428 12.14C11.6161 12.4666 11.4322 12.9094 11.4314 13.3714V13.7771C11.4316 13.8528 11.4618 13.9254 11.5153 13.9789C11.5689 14.0325 11.6414 14.0626 11.7171 14.0629H24.2828C24.3585 14.0626 24.4311 14.0325 24.4846 13.9789C24.5381 13.9254 24.5683 13.8528 24.5685 13.7771V13.3714C24.5677 12.9094 24.3838 12.4666 24.0572 12.14C23.7305 11.8133 23.2877 11.6294 22.8257 11.6286ZM20.32 11.0571V10.8743C20.32 10.6424 20.2279 10.42 20.0639 10.2561C19.8999 10.0921 19.6776 10 19.4457 10H16.4771C16.2454 10.0005 16.0233 10.0927 15.8594 10.2566C15.6955 10.4204 15.6033 10.6425 15.6028 10.8743V11.0571H20.32ZM12.2771 14.6343L13.0657 24.5657C13.098 24.9555 13.2752 25.3191 13.5624 25.5846C13.8497 25.8501 14.226 25.9983 14.6171 26H21.3257C21.7168 25.9983 22.0931 25.8501 22.3803 25.5846C22.6676 25.3191 22.8448 24.9555 22.8771 24.5657L23.6685 14.6343H12.2771ZM20.1885 19.6971C20.1971 17.5114 20.2143 15.3286 20.2143 15.3286C20.2144 15.2912 20.2219 15.2543 20.2364 15.2198C20.2508 15.1854 20.2719 15.1542 20.2984 15.1279C20.325 15.1016 20.3564 15.0808 20.391 15.0667C20.4256 15.0526 20.4626 15.0455 20.5 15.0457H20.5028C20.5785 15.0467 20.6508 15.0776 20.7038 15.1317C20.7568 15.1857 20.7862 15.2586 20.7857 15.3343C20.76 18.5971 20.7371 23.5371 20.7743 24.0114C20.7861 24.0538 20.788 24.0984 20.7798 24.1416C20.7715 24.1849 20.7535 24.2256 20.7269 24.2608C20.7004 24.2959 20.6661 24.3244 20.6267 24.3441C20.5874 24.3638 20.544 24.3741 20.5 24.3743C20.4617 24.3739 20.4239 24.3661 20.3885 24.3514C20.1714 24.26 20.1714 24.26 20.1885 19.6971ZM17.6857 15.3314C17.6857 15.2557 17.7158 15.183 17.7694 15.1294C17.8229 15.0758 17.8956 15.0457 17.9714 15.0457C18.0472 15.0457 18.1198 15.0758 18.1734 15.1294C18.227 15.183 18.2571 15.2557 18.2571 15.3314V24.0886C18.2571 24.1643 18.227 24.237 18.1734 24.2906C18.1198 24.3442 18.0472 24.3743 17.9714 24.3743C17.8956 24.3743 17.8229 24.3442 17.7694 24.2906C17.7158 24.237 17.6857 24.1643 17.6857 24.0886V15.3314ZM15.1457 15.3314C15.1457 15.2557 15.1758 15.183 15.2294 15.1294C15.2829 15.0758 15.3556 15.0457 15.4314 15.0457C15.5072 15.0457 15.5798 15.0758 15.6334 15.1294C15.687 15.183 15.7171 15.2557 15.7171 15.3314V24.0886C15.7171 24.1643 15.687 24.237 15.6334 24.2906C15.5798 24.3442 15.5072 24.3743 15.4314 24.3743C15.3556 24.3743 15.2829 24.3442 15.2294 24.2906C15.1758 24.237 15.1457 24.1643 15.1457 24.0886V15.3314Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_673">
          <rect
            width={16}
            height={16}
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  restoreIcon: (
    <svg
      width="28"
      height="28"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="6" fill="#46C064" />
      <g clip-path="url(#clip0_967_2)">
        <path
          d="M25.321 18.679C25.3211 19.8634 25.0339 21.0301 24.4841 22.079C23.9342 23.128 23.1381 24.0279 22.164 24.7016C21.1899 25.3752 20.0669 25.8025 18.8914 25.9468C17.7158 26.0911 16.5229 25.948 15.4148 25.5299C14.3067 25.1118 13.3166 24.4311 12.5294 23.5462C11.7422 22.6614 11.1814 21.5988 10.8951 20.4495C10.6088 19.3003 10.6056 18.0988 10.8857 16.948C11.1659 15.7973 11.721 14.7317 12.5035 13.8426C12.5176 13.8252 12.5356 13.8111 12.5559 13.8015C12.5763 13.7919 12.5985 13.787 12.621 13.7871C12.6653 13.7883 12.7079 13.8044 12.7418 13.8328L13.6366 14.7276C13.6651 14.7572 13.6816 14.7963 13.6828 14.8374C13.684 14.8784 13.6699 14.9185 13.6432 14.9497C12.7988 15.9386 12.3156 17.1852 12.273 18.4848C12.2303 19.7845 12.6307 21.06 13.4084 22.1022C14.1862 23.1443 15.295 23.8912 16.5531 24.2201C17.8112 24.5491 19.1437 24.4407 20.332 23.9126C21.5203 23.3846 22.4938 22.4683 23.0928 21.3141C23.6918 20.1599 23.8807 18.8364 23.6285 17.5608C23.3763 16.2851 22.6979 15.133 21.7048 14.2937C20.7116 13.4543 19.4626 12.9774 18.1628 12.9413V14.0549C18.1626 14.0835 18.1549 14.1115 18.1405 14.1362C18.1261 14.1609 18.1055 14.1814 18.0807 14.1956C18.0559 14.2098 18.0278 14.2173 17.9992 14.2172C17.9707 14.2172 17.9426 14.2096 17.9178 14.1953L14.5477 12.249C14.523 12.2349 14.5024 12.2145 14.488 12.1898C14.4737 12.1651 14.4662 12.1371 14.4662 12.1086C14.4662 12.0801 14.4737 12.0521 14.488 12.0274C14.5024 12.0027 14.523 11.9823 14.5477 11.9682L17.9178 10.0219C17.9427 10.0075 17.9708 10 17.9995 10C18.0281 10 18.0563 10.0075 18.0811 10.0219C18.1058 10.0361 18.1263 10.0566 18.1406 10.0812C18.155 10.1058 18.1626 10.1338 18.1628 10.1623V11.3575C20.0752 11.4028 21.8943 12.1938 23.2316 13.5617C24.569 14.9296 25.3188 16.766 25.321 18.679Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_967_2">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  searchClear: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="clearSearch"
    >
      <path
        d="M15 8C15 4.13542 11.8646 1 8 1C4.13542 1 1 4.13542 1 8C1 11.8646 4.13542 15 8 15C11.8646 15 15 11.8646 15 8Z"
        stroke="#3AA61C"
        strokeMiterlimit={10}
      />
      <path
        d="M10.3327 10.3329L5.66602 5.66626M5.66602 10.3329L10.3327 5.66626"
        stroke="#3AA61C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  search: (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10_455)">
        <path
          d="M17.8128 16.8991L14.1489 13.2352C15.3445 11.8339 16.0709 10.0147 16.0709 8.03494C16.0709 3.60608 12.4648 0 8.03592 0C3.60706 0 0.000976562 3.60608 0.000976562 8.03494C0.000976562 12.4638 3.60706 16.0699 8.03592 16.0699C10.0222 16.0699 11.8348 15.3435 13.2361 14.1479L16.9001 17.8119C17.5107 18.4225 18.4042 17.4969 17.8064 16.9055L17.8128 16.8991ZM1.28657 8.03494C1.28657 4.31316 4.31413 1.28559 8.03592 1.28559C11.7577 1.28559 14.7853 4.31316 14.7853 8.03494C14.7853 11.7567 11.7577 14.7843 8.03592 14.7843C4.31413 14.7843 1.28657 11.7567 1.28657 8.03494Z"
          fill="#46C064"
        />
      </g>
      <defs>
        <clipPath id="clip0_10_455">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  profileAvatar: (
    <svg
      width={46}
      height={46}
      classname="pro_svg"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={23} cy={23} r={23} fill="#E1FCDB" />
      <path
        d="M30.0711 25.9289C28.9819 24.8398 27.6855 24.0335 26.2711 23.5454C27.786 22.502 28.7812 20.7558 28.7812 18.7812C28.7812 15.5935 26.1878 13 23 13C19.8122 13 17.2188 15.5935 17.2188 18.7812C17.2188 20.7558 18.214 22.502 19.729 23.5454C18.3145 24.0335 17.0181 24.8398 15.9289 25.9289C14.0402 27.8177 13 30.3289 13 33H14.5625C14.5625 28.3475 18.3475 24.5625 23 24.5625C27.6525 24.5625 31.4375 28.3475 31.4375 33H33C33 30.3289 31.9598 27.8177 30.0711 25.9289ZM23 23C20.6738 23 18.7812 21.1075 18.7812 18.7812C18.7812 16.455 20.6738 14.5625 23 14.5625C25.3262 14.5625 27.2188 16.455 27.2188 18.7812C27.2188 21.1075 25.3262 23 23 23Z"
        fill="black"
      />
    </svg>
  ),
  upArrow: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10_708)">
        <path
          d="M0.294971 13.9038L8.90777 4.75238C9.04798 4.60334 9.21721 4.48457 9.40505 4.40339C9.59288 4.3222 9.79535 4.28032 9.99998 4.28032C10.2046 4.28032 10.4071 4.3222 10.5949 4.40339C10.7827 4.48457 10.952 4.60334 11.0922 4.75238L19.705 13.9038C20.352 14.5915 19.8648 15.7201 18.9203 15.7201L1.0797 15.7201C0.135172 15.7201 -0.352078 14.5915 0.294971 13.9038Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_10_708">
          <rect
            width={20}
            height={20}
            fill="white"
            transform="translate(20 20) rotate(180)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  goBack: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10_1045)">
        <path
          d="M15.2 7.16419H2.73106L6.9655 2.6855C7.04191 2.60744 7.10286 2.51407 7.14479 2.41084C7.18671 2.3076 7.20878 2.19657 7.20971 2.08422C7.21063 1.97187 7.19039 1.86045 7.15016 1.75646C7.10994 1.65247 7.05053 1.55799 6.97542 1.47855C6.9003 1.3991 6.81098 1.33627 6.71266 1.29372C6.61435 1.25118 6.509 1.22977 6.40278 1.23074C6.29655 1.23172 6.19158 1.25506 6.09397 1.29941C5.99637 1.34376 5.90809 1.40822 5.83429 1.48903L0.234232 7.41211C0.0842531 7.57079 0 7.78597 0 8.01034C0 8.23471 0.0842531 8.44989 0.234232 8.60857L5.83429 14.5316C5.98517 14.6858 6.18726 14.7711 6.39702 14.7691C6.60678 14.7672 6.80743 14.6782 6.95576 14.5213C7.10409 14.3645 7.18822 14.1522 7.19004 13.9304C7.19187 13.7085 7.11123 13.4948 6.9655 13.3352L2.73106 8.8565H15.2C15.4122 8.8565 15.6157 8.76735 15.7657 8.60866C15.9157 8.44998 16 8.23476 16 8.01034C16 7.78593 15.9157 7.5707 15.7657 7.41202C15.6157 7.25334 15.4122 7.16419 15.2 7.16419Z"
          fill="#EE853A"
        />
      </g>
      <defs>
        <clipPath id="clip0_10_1045">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  dropDown: (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={6} fill="#46C064" />
      <g clipPath="url(#clip0_14_1010)">
        <path
          d="M16.1538 18C16.1538 19.0178 16.9821 19.8462 18 19.8462C19.0178 19.8462 19.8461 19.0178 19.8461 18C19.8461 16.9822 19.0178 16.1538 18 16.1538C16.9821 16.1538 16.1538 16.9822 16.1538 18ZM16.1538 24.1538C16.1538 25.1717 16.9821 26 18 26C19.0178 26 19.8461 25.1717 19.8461 24.1538C19.8461 23.136 19.0178 22.3077 18 22.3077C16.9821 22.3077 16.1538 23.136 16.1538 24.1538ZM16.1538 11.8462C16.1538 12.864 16.9821 13.6923 18 13.6923C19.0178 13.6923 19.8461 12.864 19.8461 11.8462C19.8461 10.8283 19.0178 10 18 10C16.9821 10 16.1538 10.8283 16.1538 11.8462Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_1010">
          <rect
            width={16}
            height={16}
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  phoneCall: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25084 10.36L5.76863 11.84C5.45616 12.152 4.95942 12.152 4.63894 11.848C4.5508 11.76 4.46267 11.68 4.37454 11.592C3.54931 10.76 2.80419 9.88798 2.1392 8.97598C1.48222 8.06398 0.953426 7.15199 0.568851 6.24799C0.192288 5.33599 0 4.46399 0 3.63199C0 3.08799 0.0961437 2.568 0.288431 2.088C0.480719 1.6 0.785174 1.152 1.20981 0.751999C1.72258 0.248 2.28341 0 2.8763 0C3.10064 0 3.32497 0.048 3.52527 0.144C3.73358 0.24 3.91786 0.383999 4.06207 0.591999L5.92085 3.20799C6.06507 3.40799 6.16922 3.59199 6.24133 3.76799C6.31344 3.93599 6.3535 4.10399 6.3535 4.25599C6.3535 4.44799 6.29742 4.63999 6.18525 4.82399C6.08109 5.00799 5.92886 5.19999 5.73658 5.39199L5.12767 6.02399C5.03953 6.11199 4.99948 6.21599 4.99948 6.34399C4.99948 6.40799 5.00749 6.46399 5.02351 6.52799C5.04755 6.59199 5.07158 6.63999 5.08761 6.68799C5.23182 6.95199 5.48019 7.29599 5.83272 7.71199C6.19326 8.12799 6.57783 8.55198 6.99446 8.97598C7.07458 9.05598 7.16271 9.13598 7.24283 9.21598C7.56331 9.52798 7.57132 10.04 7.25084 10.36Z"
        fill="#132F21"
      />
      <path
        d="M15.9999 13.0641C15.9999 13.2881 15.9599 13.5201 15.8797 13.7441C15.8557 13.8081 15.8317 13.8721 15.7996 13.9361C15.6634 14.2241 15.4872 14.4961 15.2548 14.7521C14.8622 15.1841 14.4296 15.4961 13.9409 15.6961C13.9328 15.6961 13.9248 15.7041 13.9168 15.7041C13.4441 15.8961 12.9313 16.0001 12.3785 16.0001C11.5613 16.0001 10.688 15.8081 9.76661 15.4161C8.84523 15.0241 7.92385 14.4961 7.01049 13.8321C6.69802 13.6001 6.38555 13.3681 6.08911 13.1201L8.70903 10.5041C8.93336 10.6721 9.13366 10.8001 9.30191 10.8881C9.34197 10.9041 9.39005 10.9281 9.44613 10.9521C9.51023 10.9761 9.57432 10.9841 9.64643 10.9841C9.78263 10.9841 9.88679 10.9361 9.97492 10.8481L10.5838 10.2481C10.7841 10.0481 10.9764 9.89608 11.1607 9.80008C11.345 9.68808 11.5292 9.63208 11.7295 9.63208C11.8818 9.63208 12.042 9.66408 12.2183 9.73608C12.3945 9.80808 12.5788 9.91208 12.7791 10.0481L15.4311 11.9281C15.6394 12.0721 15.7836 12.2401 15.8717 12.4401C15.9519 12.6401 15.9999 12.8401 15.9999 13.0641Z"
        fill="#132F21"
      />
    </svg>
  ),
  email: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1.45459H4C1.6 1.45459 0 2.60967 0 5.30486V10.6952C0 13.3904 1.6 14.5455 4 14.5455H12C14.4 14.5455 16 13.3904 16 10.6952V5.30486C16 2.60967 14.4 1.45459 12 1.45459ZM12.376 6.14422L9.872 8.06935C9.344 8.47748 8.672 8.67769 8 8.67769C7.328 8.67769 6.648 8.47748 6.128 8.06935L3.624 6.14422C3.368 5.944 3.328 5.57438 3.528 5.32796C3.736 5.08154 4.112 5.03534 4.368 5.23555L6.872 7.16069C7.48 7.63042 8.512 7.63042 9.12 7.16069L11.624 5.23555C11.88 5.03534 12.264 5.07384 12.464 5.32796C12.672 5.57438 12.632 5.944 12.376 6.14422Z"
        fill="#132F21"
      />
    </svg>
  ),
  devotee: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3577 0H4.65032C1.73687 0 0 1.736 0 4.648V11.344C0 14.264 1.73687 16 4.65032 16H11.3497C14.2631 16 16 14.264 16 11.352V4.648C16.008 1.736 14.2711 0 11.3577 0ZM11.7338 7.4L10.4372 8.216L10.5493 10.136C10.6533 11.208 10.2851 11.576 9.26862 11.696L5.2106 12.176C4.98794 12.2063 4.91238 11.9541 5.07132 11.7952L6.30714 10.56C6.53926 10.328 6.53926 9.944 6.30714 9.712C6.06702 9.48 5.69084 9.48 5.45072 9.712L4.22185 10.9465C4.06354 11.1055 3.81158 11.0303 3.84191 10.808L4.31415 6.752C4.44221 5.736 4.8104 5.408 5.88293 5.472L7.79588 5.584L8.6203 4.28C8.99648 3.688 9.76486 3.656 10.3251 4.216L11.8059 5.696C12.3341 6.216 12.3021 7.04 11.7338 7.4Z"
        fill="#132F21"
      />
    </svg>
  ),
  location: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6585 5.22927C13.839 1.62341 10.6936 0 7.93071 0C7.93071 0 7.93071 0 7.92291 0C5.16779 0 2.01462 1.61561 1.1951 5.22146C0.281934 9.24878 2.74828 12.6595 4.98047 14.8059C5.80779 15.6019 6.86925 16 7.93071 16C8.99218 16 10.0536 15.6019 10.8732 14.8059C13.1053 12.6595 15.5717 9.25659 14.6585 5.22927ZM7.93071 9.13951C6.57267 9.13951 5.47218 8.03902 5.47218 6.68098C5.47218 5.32293 6.57267 4.22244 7.93071 4.22244C9.28876 4.22244 10.3893 5.32293 10.3893 6.68098C10.3893 8.03902 9.28876 9.13951 7.93071 9.13951Z"
        fill="#132F21"
      />
    </svg>
  ),
  find: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.59911 15.1982C11.796 15.1982 15.1982 11.796 15.1982 7.59911C15.1982 3.40224 11.796 0 7.59911 0C3.40224 0 0 3.40224 0 7.59911C0 11.796 3.40224 15.1982 7.59911 15.1982Z"
        fill="#132F21"
      />
      <path
        d="M15.4381 15.9979C15.2941 15.9979 15.1502 15.9419 15.0462 15.838L13.5583 14.3501C13.3424 14.1342 13.3424 13.7822 13.5583 13.5582C13.7743 13.3422 14.1263 13.3422 14.3502 13.5582L15.8381 15.046C16.054 15.262 16.054 15.614 15.8381 15.838C15.7261 15.9419 15.5821 15.9979 15.4381 15.9979Z"
        fill="#132F21"
      />
      <circle cx="5.54197" cy="7.37657" r="3.98692" fill="white" />
    </svg>
  ),
  id: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17_114)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.87071 1.0769C5.54081 1.07955 5.2197 1.18348 4.9508 1.37462C4.68191 1.56576 4.47823 1.83489 4.36731 2.14559H11.6368C11.5258 1.83489 11.3222 1.56576 11.0533 1.37462C10.7844 1.18348 10.4633 1.07955 10.1334 1.0769H5.87071ZM1.60403 3.21024C1.17927 3.21236 0.772504 3.38203 0.472147 3.68239C0.171791 3.98275 0.00211592 4.38951 0 4.81427V13.3436C0 14.2211 0.72453 14.9476 1.60403 14.9476H14.4021C14.8259 14.9445 15.2315 14.7743 15.5306 14.474C15.8298 14.1737 15.9985 13.7675 16 13.3436V4.81427C15.9985 4.39039 15.8298 3.98422 15.5306 3.68392C15.2315 3.38363 14.8259 3.21342 14.4021 3.21024H1.60403ZM5.33335 5.34358C6.50668 5.34358 7.4687 6.30761 7.4687 7.47893C7.4687 7.87743 7.34996 8.24774 7.15675 8.56573C7.53771 8.61937 7.88665 8.80832 8.13978 9.09803C8.39291 9.38775 8.53333 9.75888 8.53537 10.1436V11.2103C8.53379 11.6341 8.36512 12.0403 8.06595 12.3406C7.76678 12.6409 7.36125 12.8111 6.93738 12.8143H3.73737C3.31244 12.8127 2.90538 12.6432 2.60491 12.3427C2.30444 12.0423 2.13493 11.6352 2.13334 11.2103V10.1456C2.13334 9.3446 2.73913 8.68246 3.51196 8.56975C3.31037 8.24217 3.20247 7.86558 3.20001 7.48095C3.20001 6.30962 4.16202 5.34761 5.33335 5.34761V5.34358ZM5.33335 6.41226C5.19297 6.41119 5.05378 6.43805 4.92389 6.49128C4.79399 6.5445 4.67597 6.62303 4.57671 6.7223C4.47745 6.82156 4.39892 6.93957 4.34569 7.06947C4.29247 7.19937 4.26561 7.33856 4.26668 7.47893C4.26668 8.07466 4.73964 8.5456 5.33335 8.5456C5.92907 8.5456 6.40203 8.07466 6.40203 7.47893C6.4031 7.33856 6.37624 7.19937 6.32302 7.06947C6.26979 6.93957 6.19126 6.82156 6.092 6.7223C5.99273 6.62303 5.87472 6.5445 5.74482 6.49128C5.61492 6.43805 5.47372 6.41119 5.33335 6.41226ZM10.1334 6.41226H13.3334C13.4748 6.41226 13.6105 6.46845 13.7105 6.56847C13.8105 6.66849 13.8667 6.80415 13.8667 6.9456C13.8667 7.08705 13.8105 7.2227 13.7105 7.32272C13.6105 7.42274 13.4748 7.47893 13.3334 7.47893H10.1354C9.99392 7.47893 9.85827 7.42274 9.75825 7.32272C9.65823 7.2227 9.60204 7.08705 9.60204 6.9456C9.60204 6.80415 9.65823 6.66849 9.75825 6.56847C9.85827 6.46845 9.99392 6.41226 10.1354 6.41226H10.1334ZM10.083 8.5456C10.0998 8.54481 10.1166 8.54481 10.1334 8.5456H13.3334C13.4748 8.5456 13.6105 8.60179 13.7105 8.70181C13.8105 8.80183 13.8667 8.93749 13.8667 9.07894C13.8667 9.22039 13.8105 9.35604 13.7105 9.45606C13.6105 9.55608 13.4748 9.61227 13.3334 9.61227H10.1354C9.99392 9.61894 9.85562 9.56915 9.75088 9.47385C9.64614 9.37855 9.58355 9.24554 9.57688 9.10409C9.57021 8.96265 9.62 8.82434 9.7153 8.7196C9.8106 8.61486 9.9416 8.55228 10.083 8.5456ZM3.73737 9.61227C3.66672 9.61007 3.59636 9.62227 3.53057 9.64812C3.46478 9.67396 3.40493 9.71292 3.35467 9.76262C3.3044 9.81232 3.26477 9.87172 3.23819 9.93721C3.2116 10.0027 3.19861 10.0729 3.20001 10.1436V11.2103C3.19807 11.2814 3.21064 11.3521 3.23696 11.4182C3.26327 11.4843 3.30279 11.5443 3.35308 11.5946C3.40337 11.6448 3.46338 11.6844 3.52946 11.7107C3.59553 11.737 3.66627 11.7496 3.73737 11.7476H6.93738C7.00805 11.749 7.07827 11.736 7.14376 11.7094C7.20925 11.6829 7.26866 11.6432 7.31835 11.593C7.36805 11.5427 7.40701 11.4829 7.43286 11.4171C7.4587 11.3513 7.4709 11.2809 7.4687 11.2103V10.1456C7.47064 10.0753 7.45823 10.0053 7.43221 9.94C7.4062 9.87466 7.36713 9.81531 7.3174 9.76558C7.26767 9.71585 7.20832 9.67679 7.14298 9.65077C7.07764 9.62476 7.00768 9.61234 6.93738 9.61428H5.33335L3.73737 9.61227ZM10.083 10.6789C10.0998 10.6782 10.1166 10.6782 10.1334 10.6789H13.3334C13.4748 10.6789 13.6105 10.7351 13.7105 10.8352C13.8105 10.9352 13.8667 11.0708 13.8667 11.2123C13.8667 11.3537 13.8105 11.4894 13.7105 11.5894C13.6105 11.6894 13.4748 11.7456 13.3334 11.7456H10.1354C9.99392 11.7523 9.85562 11.7025 9.75088 11.6072C9.64614 11.5119 9.58355 11.3789 9.57688 11.2374C9.57021 11.096 9.62 10.9577 9.7153 10.8529C9.8106 10.7482 9.9416 10.6856 10.083 10.6789Z"
          fill="#132F21"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_114">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  closeIcon: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_1939)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99999 0C15.5191 0 20 4.48093 20 9.99999C20 15.5191 15.5191 20 9.99999 20C4.48093 20 0 15.5191 0 9.99999C0 4.48093 4.48093 0 9.99999 0ZM9.01302 9.99999L6.25116 12.7628C6.18641 12.8275 6.13505 12.9044 6.10002 12.989C6.06498 13.0736 6.04694 13.1642 6.04694 13.2558C6.04694 13.3474 6.06498 13.438 6.10002 13.5226C6.13505 13.6072 6.18641 13.6841 6.25116 13.7488C6.3159 13.8136 6.39277 13.8649 6.47736 13.9C6.56195 13.935 6.65262 13.953 6.74418 13.953C6.83574 13.953 6.92641 13.935 7.011 13.9C7.09559 13.8649 7.17246 13.8136 7.2372 13.7488L9.99999 10.987L12.7628 13.7488C12.8275 13.8136 12.9044 13.8649 12.989 13.9C13.0736 13.935 13.1642 13.953 13.2558 13.953C13.3474 13.953 13.438 13.935 13.5226 13.9C13.6072 13.8649 13.6841 13.8136 13.7488 13.7488C13.8136 13.6841 13.8649 13.6072 13.9 13.5226C13.935 13.438 13.953 13.3474 13.953 13.2558C13.953 13.1642 13.935 13.0736 13.9 12.989C13.8649 12.9044 13.8136 12.8275 13.7488 12.7628L10.987 9.99999L13.7488 7.2372C13.8136 7.17246 13.8649 7.09559 13.9 7.011C13.935 6.92641 13.953 6.83574 13.953 6.74418C13.953 6.65262 13.935 6.56195 13.9 6.47736C13.8649 6.39277 13.8136 6.3159 13.7488 6.25116C13.6841 6.18641 13.6072 6.13505 13.5226 6.10002C13.438 6.06498 13.3474 6.04694 13.2558 6.04694C13.1642 6.04694 13.0736 6.06498 12.989 6.10002C12.9044 6.13505 12.8275 6.18641 12.7628 6.25116L9.99999 9.01302L7.2372 6.25116C7.17246 6.18641 7.09559 6.13505 7.011 6.10002C6.92641 6.06498 6.83574 6.04694 6.74418 6.04694C6.65262 6.04694 6.56195 6.06498 6.47736 6.10002C6.39277 6.13505 6.3159 6.18641 6.25116 6.25116C6.18641 6.3159 6.13505 6.39277 6.10002 6.47736C6.06498 6.56195 6.04694 6.65262 6.04694 6.74418C6.04694 6.83574 6.06498 6.92641 6.10002 7.011C6.13505 7.09559 6.18641 7.17246 6.25116 7.2372L9.01302 9.99999Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_1939">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  delete: (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_1938)">
        <path
          d="M51.303 6.51429H12.6973C10.8493 6.51761 9.07806 7.25316 7.77138 8.55984C6.46471 9.86652 5.72915 11.6378 5.72583 13.4857V15.1086C5.72673 15.4114 5.84743 15.7016 6.06156 15.9157C6.2757 16.1298 6.56586 16.2505 6.86869 16.2514H57.1315C57.4344 16.2505 57.7245 16.1298 57.9387 15.9157C58.1528 15.7016 58.2735 15.4114 58.2744 15.1086V13.4857C58.2711 11.6378 57.5355 9.86652 56.2288 8.55984C54.9222 7.25316 53.1509 6.51761 51.303 6.51429ZM41.2801 4.22857V3.49714C41.2801 2.56964 40.9117 1.68013 40.2558 1.02429C39.6 0.368448 38.7105 0 37.783 0H25.9087C24.9817 0.00181221 24.0933 0.370842 23.4378 1.02629C22.7824 1.68174 22.4134 2.5702 22.4115 3.49714V4.22857H41.2801ZM9.10869 18.5371L12.263 58.2629C12.3922 59.8221 13.1012 61.2762 14.25 62.3384C15.3989 63.4005 16.9041 63.9933 18.4687 64H45.303C46.8675 63.9933 48.3728 63.4005 49.5216 62.3384C50.6705 61.2762 51.3795 59.8221 51.5087 58.2629L54.6744 18.5371H9.10869ZM40.7544 38.7886C40.7887 30.0457 40.8573 21.3143 40.8573 21.3143C40.8579 21.1649 40.8879 21.0171 40.9457 20.8794C41.0035 20.7416 41.0879 20.6166 41.194 20.5115C41.3002 20.4064 41.426 20.3233 41.5643 20.2669C41.7027 20.2105 41.8507 20.182 42.0001 20.1829H42.0115C42.3144 20.1868 42.6033 20.3104 42.8153 20.5266C43.0273 20.7429 43.1451 21.0343 43.143 21.3371C43.0401 34.3886 42.9487 54.1486 43.0973 56.0457C43.1446 56.2153 43.1521 56.3935 43.1193 56.5665C43.0864 56.7395 43.0141 56.9025 42.9079 57.043C42.8018 57.1835 42.6646 57.2975 42.5072 57.3763C42.3497 57.455 42.1762 57.4964 42.0001 57.4971C41.8471 57.4955 41.6957 57.4644 41.5544 57.4057C40.6858 57.04 40.6858 57.04 40.7544 38.7886ZM30.743 21.3257C30.743 21.0226 30.8634 20.7319 31.0777 20.5176C31.292 20.3033 31.5827 20.1829 31.8858 20.1829C32.1889 20.1829 32.4796 20.3033 32.6939 20.5176C32.9083 20.7319 33.0287 21.0226 33.0287 21.3257V56.3543C33.0287 56.6574 32.9083 56.9481 32.6939 57.1624C32.4796 57.3767 32.1889 57.4971 31.8858 57.4971C31.5827 57.4971 31.292 57.3767 31.0777 57.1624C30.8634 56.9481 30.743 56.6574 30.743 56.3543V21.3257ZM20.583 21.3257C20.583 21.0226 20.7034 20.7319 20.9177 20.5176C21.132 20.3033 21.4227 20.1829 21.7258 20.1829C22.0289 20.1829 22.3196 20.3033 22.5339 20.5176C22.7483 20.7319 22.8687 21.0226 22.8687 21.3257V56.3543C22.8687 56.6574 22.7483 56.9481 22.5339 57.1624C22.3196 57.3767 22.0289 57.4971 21.7258 57.4971C21.4227 57.4971 21.132 57.3767 20.9177 57.1624C20.7034 56.9481 20.583 56.6574 20.583 56.3543V21.3257Z"
          fill="#FF1C0D"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_1938">
          <rect width={64} height={64} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  editPage: (
    <svg
      width={28}
      height={28}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={6} fill="#46C064" />
      <path
        d="M19.6982 11.2616L19.9382 11.0213C21.3786 9.65957 23.6193 9.65957 24.9797 11.0213C26.3401 12.383 26.3401 14.7059 24.9797 16.0676L24.7396 16.3079L19.6982 11.2616ZM12.0159 18.9512C11.6158 19.3517 11.2957 19.9124 11.1357 20.4731L10.0153 25.0388C9.93531 25.4393 10.1754 25.9199 10.5755 26H10.8956L15.3769 24.8786C15.9371 24.7184 16.4972 24.4781 16.8973 23.9975L12.0159 18.9512ZM18.4978 12.383L13.1362 17.7497L18.1777 22.796L23.5393 17.4293L18.4978 12.383Z"
        fill="white"
      />
    </svg>
  ),
  myProfileIcon: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={10} cy={10} r={10} fill="#E58344" />
      <g clipPath="url(#clip0_19_807)">
        <path
          d="M13.0744 11.2734C12.6008 10.7999 12.0372 10.4493 11.4222 10.2371C12.0808 9.78346 12.5136 9.02424 12.5136 8.16575C12.5136 6.77976 11.386 5.65216 9.99999 5.65216C8.614 5.65216 7.4864 6.77976 7.4864 8.16575C7.4864 9.02424 7.91913 9.78346 8.57781 10.2371C7.96283 10.4493 7.39917 10.7999 6.92562 11.2734C6.10442 12.0946 5.65216 13.1865 5.65216 14.3478H6.33151C6.33151 12.325 7.97718 10.6793 9.99999 10.6793C12.0228 10.6793 13.6685 12.325 13.6685 14.3478H14.3478C14.3478 13.1865 13.8956 12.0946 13.0744 11.2734ZM9.99999 9.99999C8.98859 9.99999 8.16575 9.17716 8.16575 8.16575C8.16575 7.15433 8.98859 6.33151 9.99999 6.33151C11.0114 6.33151 11.8342 7.15433 11.8342 8.16575C11.8342 9.17716 11.0114 9.99999 9.99999 9.99999Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_807">
          <rect
            width="8.69565"
            height="8.69565"
            fill="white"
            transform="translate(5.65216 5.65216)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  changePassword: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 15.625C3.00272 15.625 2.52581 15.4275 2.17417 15.0758C1.82254 14.7242 1.625 14.2473 1.625 13.75V7.5C1.625 7.00272 1.82254 6.52581 2.17417 6.17418C2.52581 5.82255 3.00272 5.625 3.5 5.625H13.5C13.9973 5.625 14.4742 5.82255 14.8258 6.17418C15.1775 6.52581 15.375 7.00272 15.375 7.5V9.375C15.0897 9.3755 14.8066 9.4241 14.5375 9.51875C14.0207 9.70932 13.5812 10.0653 13.2875 10.5313C13.1087 10.4934 12.9265 10.4745 12.7438 10.475C12.369 10.4745 11.9988 10.5582 11.6608 10.72C11.3227 10.8818 11.0254 11.1176 10.7907 11.4098C10.5561 11.7021 10.3901 12.0434 10.3052 12.4084C10.2203 12.7735 10.2185 13.1529 10.3 13.5188C9.834 13.8125 9.47807 14.2519 9.2875 14.7688C9.18362 15.0425 9.12862 15.3323 9.125 15.625H3.5ZM7.25 9.85C6.96696 10.1032 6.76746 10.4363 6.6779 10.8053C6.58834 11.1743 6.61293 11.5618 6.74843 11.9166C6.88392 12.2713 7.12394 12.5766 7.43671 12.7919C7.74948 13.0072 8.12027 13.1225 8.5 13.1225C8.87973 13.1225 9.25052 13.0072 9.56329 12.7919C9.87606 12.5766 10.1161 12.2713 10.2516 11.9166C10.3871 11.5618 10.4117 11.1743 10.3221 10.8053C10.2325 10.4363 10.033 10.1032 9.75 9.85V8.75C9.75 8.41848 9.6183 8.10054 9.38388 7.86612C9.14946 7.6317 8.83152 7.5 8.5 7.5C8.16848 7.5 7.85054 7.6317 7.61612 7.86612C7.3817 8.10054 7.25 8.41848 7.25 8.75V9.85Z"
        fill="#E58344"
      />
      <path
        d="M13.5 6.25C13.8315 6.25 14.1495 6.3817 14.3839 6.61612C14.6183 6.85054 14.75 7.16848 14.75 7.5V8.8125C14.6106 8.84258 14.4729 8.88013 14.3375 8.925C13.8119 9.11145 13.3458 9.43514 12.9875 9.8625H12.725C12.0484 9.85976 11.3896 10.0794 10.85 10.4875C10.7521 10.1631 10.5906 9.86143 10.375 9.6V8.75C10.375 8.25272 10.1775 7.77581 9.82583 7.42418C9.4742 7.07255 8.99728 6.875 8.5 6.875C8.00272 6.875 7.52581 7.07255 7.17418 7.42418C6.82255 7.77581 6.625 8.25272 6.625 8.75V9.6C6.30791 9.96094 6.10154 10.4056 6.03058 10.8808C5.95962 11.356 6.02709 11.8415 6.2249 12.2793C6.42272 12.7172 6.7425 13.0887 7.14598 13.3495C7.54947 13.6104 8.01956 13.7494 8.5 13.75C8.73885 13.7487 8.97643 13.7151 9.20625 13.65C8.97541 13.9255 8.79743 14.2412 8.68125 14.5813C8.63221 14.718 8.59254 14.8579 8.5625 15H3.5C3.16848 15 2.85054 14.8683 2.61612 14.6339C2.3817 14.3995 2.25 14.0815 2.25 13.75V7.5C2.25 7.16848 2.3817 6.85054 2.61612 6.61612C2.85054 6.3817 3.16848 6.25 3.5 6.25H13.5ZM8.5 0C7.50544 0 6.55161 0.395088 5.84835 1.09835C5.14509 1.80161 4.75 2.75544 4.75 3.75V5H3.5C2.83696 5 2.20107 5.26339 1.73223 5.73223C1.26339 6.20108 1 6.83696 1 7.5V13.75C1 14.413 1.26339 15.0489 1.73223 15.5178C2.20107 15.9866 2.83696 16.25 3.5 16.25H9.85625C9.7724 16.013 9.73705 15.7616 9.75231 15.5107C9.76756 15.2598 9.83312 15.0145 9.94506 14.7895C10.057 14.5644 10.2131 14.3642 10.404 14.2006C10.5949 14.0371 10.8167 13.9136 11.0563 13.8375C10.8739 13.4836 10.8089 13.0809 10.8707 12.6876C10.9325 12.2943 11.1179 11.9309 11.4 11.65C11.6809 11.3679 12.0443 11.1825 12.4376 11.1207C12.8309 11.0589 13.2336 11.1239 13.5875 11.3063C13.6753 11.03 13.826 10.7778 14.0277 10.5696C14.2294 10.3614 14.4767 10.2028 14.75 10.1063C15.1544 9.96327 15.5956 9.96327 16 10.1063V7.5C16 6.83696 15.7366 6.20108 15.2678 5.73223C14.7989 5.26339 14.163 5 13.5 5H12.25V3.75C12.25 2.75544 11.8549 1.80161 11.1517 1.09835C10.4484 0.395088 9.49456 0 8.5 0ZM6 5V3.75C6 3.08696 6.26339 2.45107 6.73223 1.98223C7.20108 1.51339 7.83696 1.25 8.5 1.25C9.16304 1.25 9.79893 1.51339 10.2678 1.98223C10.7366 2.45107 11 3.08696 11 3.75V5H6ZM8.5 12.5C8.22524 12.4995 7.9583 12.4085 7.74045 12.2411C7.52261 12.0736 7.366 11.8391 7.29485 11.5737C7.2237 11.3083 7.24197 11.0269 7.34684 10.7729C7.45171 10.519 7.63733 10.3066 7.875 10.1688V8.75C7.875 8.58424 7.94085 8.42527 8.05806 8.30806C8.17527 8.19085 8.33424 8.125 8.5 8.125C8.66576 8.125 8.82473 8.19085 8.94194 8.30806C9.05915 8.42527 9.125 8.58424 9.125 8.75V10.1688C9.36267 10.3066 9.54829 10.519 9.65316 10.7729C9.75803 11.0269 9.7763 11.3083 9.70515 11.5737C9.634 11.8391 9.4774 12.0736 9.25955 12.2411C9.04171 12.4085 8.77476 12.4995 8.5 12.5Z"
        fill="#E58344"
      />
      <path
        d="M15.375 18.175L14.875 18.075C14.7516 18.0491 14.6303 18.0136 14.5125 17.9687C14.7885 18.0712 15.0805 18.1241 15.375 18.125C15.7166 18.123 16.0545 18.0529 16.3687 17.9187C16.2106 17.9895 16.045 18.0419 15.875 18.075L15.375 18.175ZM17.175 17.4312L16.8125 17.6687C17.0588 17.5022 17.2709 17.29 17.4375 17.0437L17.2 17.4062L18.0437 18.2562L17.175 17.4312ZM13.5687 17.4312L13.325 17.0625C13.4959 17.3051 13.7073 17.5165 13.95 17.6875L13.5875 17.45L12.7375 18.2937L13.5687 17.4312ZM13.1625 16.8062C13.0513 16.5982 12.9712 16.375 12.925 16.1437L12.825 15.6437L12.925 15.1437C12.9909 14.8312 13.116 14.5342 13.2937 14.2687L13.5687 13.8437L12.725 12.9937L13.575 13.8375L13.95 13.5937C13.5138 13.8986 13.189 14.3375 13.025 14.8437C12.9282 15.0929 12.8774 15.3576 12.875 15.625C12.8718 15.9157 12.9249 16.2044 13.0312 16.475C13.0685 16.5817 13.1123 16.6861 13.1625 16.7875V16.8062ZM17.6562 16.6562C17.792 16.3458 17.8621 16.0107 17.8621 15.6719C17.8621 15.333 17.792 14.9979 17.6562 14.6875C17.7191 14.8344 17.7673 14.9873 17.8 15.1437L17.9 15.6437L17.8 16.1437C17.7686 16.3127 17.7204 16.4781 17.6562 16.6375V16.6562ZM17.45 14.25C17.1471 13.805 16.7087 13.4696 16.2 13.2937C15.9383 13.1852 15.6582 13.1279 15.375 13.125C15.0842 13.1218 14.7956 13.1749 14.525 13.2812C14.4234 13.3137 14.3251 13.3556 14.2312 13.4062C14.4275 13.2998 14.6379 13.2219 14.8562 13.175L15.3562 13.075L15.8562 13.175C16.1688 13.2409 16.4658 13.366 16.7312 13.5437L17.1562 13.8187L18.0062 12.975L17.1625 13.825L17.45 14.25Z"
        fill="#E58344"
      />
      <path
        d="M15.375 11.25C15.2092 11.25 15.0503 11.3158 14.9331 11.4331C14.8158 11.5503 14.75 11.7092 14.75 11.875V12.5625C14.3597 12.6434 13.9884 12.7983 13.6563 13.0188L13.1625 12.5312C13.0461 12.4158 12.889 12.3507 12.725 12.35C12.6427 12.3495 12.5612 12.3653 12.4851 12.3964C12.4089 12.4275 12.3396 12.4733 12.2812 12.5312C12.1648 12.6484 12.0995 12.8068 12.0995 12.9719C12.0995 13.137 12.1648 13.2954 12.2812 13.4125L12.7688 13.9063C12.5483 14.2384 12.3934 14.6097 12.3125 15H11.625C11.4592 15 11.3003 15.0658 11.1831 15.1831C11.0658 15.3003 11 15.4592 11 15.625C11 15.7908 11.0658 15.9497 11.1831 16.0669C11.3003 16.1842 11.4592 16.25 11.625 16.25H12.3125C12.3934 16.6403 12.5483 17.0116 12.7688 17.3438L12.2812 17.8375C12.1648 17.9546 12.0995 18.113 12.0995 18.2781C12.0995 18.4432 12.1648 18.6017 12.2812 18.7188C12.3396 18.7767 12.4089 18.8225 12.4851 18.8536C12.5612 18.8847 12.6427 18.9005 12.725 18.9C12.889 18.8993 13.0461 18.8342 13.1625 18.7188L13.6563 18.2313C13.9884 18.4517 14.3597 18.6066 14.75 18.6875V19.375C14.75 19.5408 14.8158 19.6997 14.9331 19.8169C15.0503 19.9342 15.2092 20 15.375 20C15.5408 20 15.6997 19.9342 15.8169 19.8169C15.9342 19.6997 16 19.5408 16 19.375V18.6875C16.3903 18.6066 16.7616 18.4517 17.0938 18.2313L17.5875 18.7188C17.6459 18.7767 17.7152 18.8225 17.7913 18.8536C17.8675 18.8847 17.949 18.9005 18.0313 18.9C18.1536 18.8983 18.2727 18.8607 18.3739 18.7919C18.4751 18.7231 18.5538 18.6262 18.6004 18.513C18.647 18.3999 18.6593 18.2756 18.6359 18.1555C18.6125 18.0354 18.5544 17.9249 18.4688 17.8375L17.9813 17.3438C18.2017 17.0116 18.3566 16.6403 18.4375 16.25H19.125C19.2908 16.25 19.4497 16.1842 19.5669 16.0669C19.6842 15.9497 19.75 15.7908 19.75 15.625C19.75 15.4592 19.6842 15.3003 19.5669 15.1831C19.4497 15.0658 19.2908 15 19.125 15H18.4375C18.3566 14.6097 18.2017 14.2384 17.9813 13.9063L18.4688 13.4125C18.5852 13.2954 18.6505 13.137 18.6505 12.9719C18.6505 12.8068 18.5852 12.6484 18.4688 12.5312C18.3523 12.4158 18.1952 12.3507 18.0313 12.35C17.949 12.3495 17.8675 12.3653 17.7913 12.3964C17.7152 12.4275 17.6459 12.4733 17.5875 12.5312L17.0938 13.0188C16.7616 12.7983 16.3903 12.6434 16 12.5625V11.875C16 11.7092 15.9342 11.5503 15.8169 11.4331C15.6997 11.3158 15.5408 11.25 15.375 11.25ZM15.375 17.5C14.9882 17.4989 14.6111 17.3782 14.2956 17.1544C13.98 16.9306 13.7414 16.6147 13.6125 16.25C13.4626 15.8468 13.4626 15.4032 13.6125 15C13.7058 14.7379 13.8563 14.4998 14.0531 14.3031C14.2498 14.1063 14.4879 13.9558 14.75 13.8625C15.1532 13.7126 15.5968 13.7126 16 13.8625C16.4134 14.0125 16.7608 14.303 16.9817 14.6832C17.2026 15.0634 17.2828 15.5092 17.2084 15.9426C17.1339 16.3759 16.9095 16.7694 16.5744 17.0541C16.2392 17.3387 15.8147 17.4966 15.375 17.5Z"
        fill="#E58344"
      />
    </svg>
  ),
  logout: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_825)">
        <path
          d="M19.9364 8.84817C19.8939 8.74649 19.833 8.65399 19.7555 8.57649L17.2564 6.07731C16.9305 5.75231 16.4039 5.75231 16.078 6.07731C15.7522 6.40313 15.7522 6.93063 16.078 7.25563L17.1555 8.33313H12.5005C12.0397 8.33313 11.6672 8.70645 11.6672 9.16645C11.6672 9.62645 12.0397 9.99977 12.5005 9.99977H17.1555L16.078 11.0773C15.7522 11.4031 15.7522 11.9306 16.078 12.2556C16.2405 12.4189 16.4538 12.4998 16.6672 12.4998C16.8805 12.4998 17.0939 12.4189 17.2564 12.2556L19.7555 9.75641C19.833 9.67973 19.8939 9.58723 19.9364 9.48473C20.0205 9.28088 20.0205 9.05201 19.9364 8.84817Z"
          fill="#E58344"
        />
        <path
          d="M14.1673 11.6667C13.7064 11.6667 13.3339 12.04 13.3339 12.5V16.6667H10.0006V3.33332C10.0006 2.96582 9.75893 2.64082 9.40643 2.535L6.51225 1.66668H13.3339V5.83336C13.3339 6.29336 13.7064 6.66668 14.1673 6.66668C14.6281 6.66668 15.0006 6.29336 15.0006 5.83336V0.833359C15.0006 0.37332 14.6281 0 14.1673 0H0.833931C0.803931 0 0.777251 0.0125 0.74811 0.0158203C0.708931 0.02 0.67311 0.0266406 0.63561 0.0358203C0.55042 0.0574329 0.469156 0.0922983 0.39479 0.139141C0.37647 0.15082 0.35397 0.151641 0.33647 0.164961C0.329751 0.17 0.327251 0.17918 0.320571 0.18418C0.229751 0.25582 0.153931 0.34332 0.0989307 0.4475C0.087251 0.47 0.084751 0.49418 0.0756103 0.5175C0.0489307 0.58082 0.01979 0.6425 0.00979004 0.7125C0.00561035 0.7375 0.0131104 0.76082 0.01229 0.785C0.0114697 0.80168 0.000610352 0.81668 0.000610352 0.83332V17.5C0.000610352 17.8975 0.281431 18.2392 0.67061 18.3167L9.00393 19.9834C9.05811 19.995 9.11311 20 9.16725 20C9.35995 20 9.54667 19.9332 9.69557 19.8109C9.79084 19.7327 9.8676 19.6344 9.92034 19.523C9.97307 19.4116 10.0005 19.2899 10.0006 19.1667V18.3334H14.1673C14.6281 18.3334 15.0006 17.96 15.0006 17.5V12.5C15.0006 12.04 14.6281 11.6667 14.1673 11.6667Z"
          fill="#E58344"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_825">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  energyLarge: (
    <svg
      width={30}
      height={30}
      className="dash_svg"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0625 27.5C9.0625 26.9822 9.48224 26.5625 10 26.5625H20C20.5177 26.5625 20.9375 26.9822 20.9375 27.5C20.9375 28.0178 20.5177 28.4375 20 28.4375H10C9.48224 28.4375 9.0625 28.0178 9.0625 27.5Z"
        fill="#809FB3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.5625C15.5177 1.5625 15.9375 1.98224 15.9375 2.5V3.75C15.9375 4.26776 15.5177 4.6875 15 4.6875C14.4822 4.6875 14.0625 4.26776 14.0625 3.75V2.5C14.0625 1.98224 14.4822 1.5625 15 1.5625ZM1.5625 15C1.5625 14.4822 1.98224 14.0625 2.5 14.0625H3.75C4.26776 14.0625 4.6875 14.4822 4.6875 15C4.6875 15.5177 4.26776 15.9375 3.75 15.9375H2.5C1.98224 15.9375 1.5625 15.5177 1.5625 15ZM25.3125 15C25.3125 14.4822 25.7322 14.0625 26.25 14.0625H27.5C28.0177 14.0625 28.4375 14.4822 28.4375 15C28.4375 15.5177 28.0177 15.9375 27.5 15.9375H26.25C25.7322 15.9375 25.3125 15.5177 25.3125 15Z"
        fill="#809FB3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3966 19.0625H7.60334H2.5C1.98224 19.0625 1.5625 19.4822 1.5625 20C1.5625 20.5178 1.98224 20.9375 2.5 20.9375H27.5C28.0177 20.9375 28.4375 20.5178 28.4375 20C28.4375 19.4822 28.0177 19.0625 27.5 19.0625H22.3966Z"
        fill="#809FB3"
      />
      <path
        d="M5.3125 23.75C5.3125 23.2322 5.73224 22.8125 6.25 22.8125H23.75C24.2677 22.8125 24.6875 23.2322 24.6875 23.75C24.6875 24.2678 24.2677 24.6875 23.75 24.6875H6.25C5.73224 24.6875 5.3125 24.2678 5.3125 23.75Z"
        fill="#809FB3"
      />
      <path
        d="M6.5625 14.9998C6.5625 16.472 6.94013 17.857 7.60334 19.0623H22.3966C23.0599 17.857 23.4375 16.472 23.4375 14.9998C23.4375 10.6568 20.1562 7.08013 15.9375 6.61378H14.0625C9.8438 7.08013 6.5625 10.6568 6.5625 14.9998Z"
        fill="#809FB3"
      />
      <path
        d="M14.3371 16.0513C14.7032 16.4174 15.2967 16.4174 15.6629 16.0513L18.1629 13.5513C18.529 13.1851 18.529 12.5915 18.1629 12.2254C17.7967 11.8593 17.2032 11.8593 16.8371 12.2254L15.9375 13.125V6.61345C15.3785 6.52781 14.4546 6.57776 14.0625 6.61345V13.125L13.1629 12.2254C12.7967 11.8593 12.2032 11.8593 11.8371 12.2254C11.471 12.5915 11.471 13.1851 11.8371 13.5513L14.3371 16.0513Z"
        fill="#809FB3"
      />
      <path
        d="M5.49797 5.49798C5.86409 5.13186 6.45769 5.13186 6.8238 5.49798L7.31485 5.98903C7.68096 6.35514 7.68096 6.94873 7.31485 7.31485C6.94872 7.68096 6.35514 7.68096 5.98902 7.31485L5.49797 6.8238C5.13186 6.45769 5.13186 5.86409 5.49797 5.49798Z"
        fill="#809FB3"
      />
      <path
        d="M24.5011 5.4983C24.8672 5.86441 24.8672 6.45801 24.5011 6.82413L24.0101 7.31518C23.644 7.68129 23.0504 7.68129 22.6842 7.31518C22.3181 6.94905 22.3181 6.35546 22.6842 5.98935L23.1752 5.4983C23.5414 5.13219 24.135 5.13219 24.5011 5.4983Z"
        fill="#809FB3"
      />
    </svg>
  ),
  mahaMudraLarge: (
    <svg
      width={30}
      height={30}
      className="dash_svg"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0625 21.3747C11.7254 21.4103 11.1543 21.4561 10.4419 21.4561C8.62107 21.4561 5.88762 21.1553 3.83883 19.6187C2.04668 20.5271 0.627715 22.0252 0 22.7576C0.936504 23.8502 3.63416 26.6476 6.70512 26.6475C9.7858 26.6475 12.4769 23.851 13.4106 22.7582C13.1188 22.4176 12.6554 21.9108 12.0625 21.3747Z"
        fill="#9BD0B6"
      />
      <path
        d="M26.1472 19.6118C24.0975 21.1542 21.3587 21.4561 19.5352 21.4561C18.837 21.4561 18.2743 21.4121 17.9346 21.3768C17.3433 21.9117 16.881 22.4173 16.5894 22.7575C17.5258 23.8502 20.2232 26.6475 23.2942 26.6474C26.375 26.6475 29.0662 23.851 30 22.7583C29.3712 22.0245 27.9464 20.5199 26.1472 19.6118Z"
        fill="#9BD0B6"
      />
      <path
        d="M11.6259 19.9648C11.6292 19.9228 11.6323 19.8781 11.6355 19.8318C10.0263 17.9493 8.35987 15.2703 8.35987 12.2476C8.35987 12.0114 8.37094 11.7775 8.39051 11.5457C6.20555 10.3283 3.33334 10.391 2.14371 10.4824C2.03321 11.9173 1.96278 15.8029 4.13432 17.9743C6.30557 20.1456 10.1909 20.0752 11.6259 19.9648Z"
        fill="#9BD0B6"
      />
      <path
        d="M18.345 19.8813C18.347 19.9095 18.349 19.9384 18.351 19.9649C19.785 20.0753 23.6709 20.1461 25.8425 17.9743C28.0209 15.7961 27.9465 11.9156 27.8341 10.4826C26.6535 10.3915 23.8107 10.3286 21.6306 11.5211C21.6515 11.7609 21.6632 12.0029 21.6632 12.2475C21.6632 15.2969 19.9673 17.9964 18.345 19.8813Z"
        fill="#9BD0B6"
      />
      <path
        d="M15.0114 3.35256C13.6937 4.45916 9.80138 8.08113 9.80138 12.2476C9.80138 16.4142 13.6937 20.0363 15.0114 21.1428C16.3285 20.0368 20.2216 16.4145 20.2216 12.2476C20.2216 8.08113 16.3291 4.45904 15.0114 3.35256Z"
        fill="#9BD0B6"
      />
    </svg>
  ),
  chantLarge: (
    <svg
      width={30}
      height={30}
      className="dash_svg"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.53432 24.6588C1.17753 21.8327 0 18.5789 0 14.901C0 12.4446 0.543607 10.1478 1.63082 8.01309C2.71804 5.87837 4.21252 4.10732 6.11341 2.70082C8.01343 1.2952 10.1297 0.393468 12.4622 0V9.55892C12.4622 12.8697 11.6389 15.8903 9.99074 18.6166C8.34255 21.3454 6.19157 23.3584 3.53432 24.6588ZM17.5292 23.9893C16.2587 22.3602 15.3964 20.5988 14.9414 18.7077C14.4985 20.5988 13.6423 22.3602 12.3727 23.9893C11.1031 25.6184 9.56957 27.0047 7.77289 28.1466C9.99942 29.3822 12.3883 30 14.9414 30C17.5075 30 19.9016 29.3822 22.129 28.1466C20.3314 27.0056 18.7996 25.6193 17.5292 23.9893ZM28.37 8.01309C27.2828 5.87749 25.7866 4.10732 23.8875 2.70082C21.9883 1.29433 19.8695 0.393468 17.5387 0V9.55892C17.5387 12.8697 18.3611 15.8903 20.0101 18.6166C21.6566 21.3428 23.8093 23.3557 26.4674 24.6588C28.8251 21.8327 30 18.5789 30 14.901C30 12.4455 29.4555 10.1487 28.37 8.01309Z"
        fill="#D68D96"
      />
    </svg>
  ),
  hongSauLarge: (
    <svg
      width={30}
      height={30}
      className="dash_svg"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.7885 6.11538C27.5769 3.75 24.5192 -0.634616 18.8654 1.96154C15.3462 3.57692 13.3846 4.5 13.3846 4.5L8.3077 6.69231C6.86539 7.38461 3.75 6.40385 1.96154 5.76923C1.44231 5.59615 0.980773 6.11538 1.21154 6.63461C2.42308 9 5.48077 13.3846 11.1346 10.7885C14.6538 9.17308 21.6923 6.11538 21.6923 6.11538C23.1346 5.42308 26.25 6.40385 28.0385 7.03846C28.5577 7.15385 29.0192 6.63461 28.7885 6.11538ZM16.6154 13.5C15.9808 13.8462 13.4423 15 13.4423 15L10.9038 16.0962C9.63462 16.7885 6.92308 15.8654 5.3077 15.2308C4.84616 15 4.44231 15.5769 4.67308 16.0385C5.71154 18.3462 8.42308 22.5 13.3846 19.9615C16.5 18.4038 19.0962 17.3654 19.0962 17.3654C20.3654 16.6731 23.0769 17.5962 24.6923 18.2308C25.1539 18.4038 25.5577 17.8846 25.3269 17.3654C24.2885 15.1154 21.5769 10.9615 16.6154 13.5ZM14.7692 23.7115C14.25 24 13.3846 24.5192 13.3846 24.5192C12.4039 25.1538 10.3846 24.3462 9.17308 23.7692C8.82693 23.5962 8.53847 24.1154 8.71154 24.5769C9.46154 26.6538 11.4808 30.4038 15.2308 28.0962C16.6154 27.2308 16.6154 27.2885 16.6154 27.2885C17.6538 26.7692 19.6154 27.4615 20.8269 28.0385C21.1731 28.2115 21.4615 27.6923 21.2885 27.2308C20.5385 25.1538 18.6346 21.5769 14.7692 23.7115Z"
        fill="#986D9A"
      />
    </svg>
  ),
  aumLarge: (
    <svg
      width={30}
      height={30}
      className="dash_svg"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 18.7896C30 21.1965 29.0264 27.3895 23.7574 27.3895C18.7363 27.3895 16.9064 22.9543 17.2534 21.3497C17.5419 21.841 18.4569 24.3696 23.3968 24.3696C28.463 24.3696 28.5171 18.74 28.5171 18.74C28.5171 18.74 28.4315 14.7466 25.344 14.7466C21.5759 14.7466 21.4497 20.7367 17.6636 20.7367C15.766 20.7367 15.1305 19.7316 14.7474 19.4567C15.5632 21.9898 14.5986 27.8808 8.39662 27.8808C-0.455671 27.8808 0.00407057 18.3299 0.00407057 18.3299C0.00407057 18.3299 1.48697 24.2164 8.24337 24.2164C12.363 24.2164 12.9039 21.8636 12.9039 20.7863C12.9039 19.7136 12.0836 17.8205 8.39662 17.8205L7.58982 13.9939C7.58982 13.9939 8.68058 14.3499 10.0283 14.3499C11.8041 14.3499 12.2098 13.1645 12.2098 12.191C12.2098 11.2219 11.2587 10.2393 9.51893 10.2393C6.82358 10.2393 4.66009 13.0068 4.66009 13.0068L2.5642 9.11699C2.5642 9.11699 4.51135 6.60644 8.45521 6.60644C12.3946 6.60644 14.184 9.83365 14.184 11.7267C14.184 13.6198 13.3005 15.1883 11.6238 16.0762C13.8865 17.1399 13.2014 17.9197 14.6437 17.9197C17.0326 17.9197 17.3571 15.9681 18.4794 14.1967C19.5161 12.5696 20.99 11.1137 23.5997 11.1137C28.8236 11.1137 30 16.3872 30 18.7896ZM19.8136 10.5503C22.4683 10.5503 24.5237 9.01332 24.5237 9.01332L22.3196 5.12354C22.3196 5.12354 20.7871 7.27351 17.8168 7.27351C14.8465 7.27351 12.3901 4.56013 12.3901 4.56013C12.3901 4.56013 13.5169 10.5503 19.8136 10.5503ZM20.2237 4.3573L18.0197 2L15.5632 4.14997L17.7672 6.66052L20.2237 4.3573Z"
        fill="#D4CAA8"
      />
    </svg>
  ),
  kriyaLarge: (
    <svg
      width={30}
      height={30}
      className="dash_svg"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.021 0.0140002C13.7032 -0.0513027 13.3847 0.116605 13.2577 0.414543L8.63377 11.2646C7.20823 14.4155 8.52378 18.1883 9.08581 19.5296L3.53746 24.1287C3.39573 24.2462 3.30761 24.416 3.29303 24.5994C3.27846 24.783 3.33877 24.9645 3.46017 25.1029L7.5546 29.7679C7.68444 29.9158 7.87123 29.9999 8.06676 29.9999C8.07827 29.9999 8.08977 29.9996 8.10128 29.999C8.30927 29.9885 8.50096 29.8835 8.62179 29.7139L14.4304 21.5616C14.5126 21.4463 14.5568 21.3081 14.5569 21.1665L14.5573 20.1942C14.5592 16.0523 14.5661 1.45018 14.5661 0.681508C14.5662 0.357871 14.3383 0.0787277 14.021 0.0140002Z"
        fill="#B0B38E"
      />
      <path
        d="M26.7069 24.5994C26.6925 24.4159 26.6042 24.2461 26.4625 24.1287L20.9141 19.5296C21.4762 18.1883 22.7917 14.4155 21.3661 11.2646L16.7422 0.414544C16.6153 0.116605 16.2962 -0.0512067 15.9789 0.0140003C15.6616 0.0787278 15.4337 0.357871 15.4337 0.681701C15.4337 1.45038 15.4406 16.0525 15.4425 20.1944L15.4429 21.1667C15.443 21.3083 15.4871 21.4464 15.5694 21.5618L21.378 29.7141C21.4988 29.8836 21.6905 29.9887 21.8985 29.9992C21.9101 29.9998 21.9216 30.0001 21.933 30.0001C22.1287 30.0001 22.3154 29.916 22.4452 29.7681L26.5396 25.1031C26.6612 24.9645 26.7215 24.783 26.7069 24.5994Z"
        fill="#B0B38E"
      />
    </svg>
  ),
  kriyaCountLarge: (
    <svg
      width={30}
      height={30}
      className="dash_svg"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0625 27.5C9.0625 26.9822 9.48224 26.5625 10 26.5625H20C20.5177 26.5625 20.9375 26.9822 20.9375 27.5C20.9375 28.0178 20.5177 28.4375 20 28.4375H10C9.48224 28.4375 9.0625 28.0178 9.0625 27.5Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.5625C15.5177 1.5625 15.9375 1.98224 15.9375 2.5V3.75C15.9375 4.26776 15.5177 4.6875 15 4.6875C14.4822 4.6875 14.0625 4.26776 14.0625 3.75V2.5C14.0625 1.98224 14.4822 1.5625 15 1.5625ZM1.5625 15C1.5625 14.4822 1.98224 14.0625 2.5 14.0625H3.75C4.26776 14.0625 4.6875 14.4822 4.6875 15C4.6875 15.5177 4.26776 15.9375 3.75 15.9375H2.5C1.98224 15.9375 1.5625 15.5177 1.5625 15ZM25.3125 15C25.3125 14.4822 25.7322 14.0625 26.25 14.0625H27.5C28.0177 14.0625 28.4375 14.4822 28.4375 15C28.4375 15.5177 28.0177 15.9375 27.5 15.9375H26.25C25.7322 15.9375 25.3125 15.5177 25.3125 15Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3966 19.0625H7.60334H2.5C1.98224 19.0625 1.5625 19.4822 1.5625 20C1.5625 20.5178 1.98224 20.9375 2.5 20.9375H27.5C28.0177 20.9375 28.4375 20.5178 28.4375 20C28.4375 19.4822 28.0177 19.0625 27.5 19.0625H22.3966Z"
        fill="#000"
      />
      <path
        d="M5.3125 23.75C5.3125 23.2322 5.73224 22.8125 6.25 22.8125H23.75C24.2677 22.8125 24.6875 23.2322 24.6875 23.75C24.6875 24.2678 24.2677 24.6875 23.75 24.6875H6.25C5.73224 24.6875 5.3125 24.2678 5.3125 23.75Z"
        fill="#000"
      />
      <path
        d="M6.5625 14.9998C6.5625 16.472 6.94013 17.857 7.60334 19.0623H22.3966C23.0599 17.857 23.4375 16.472 23.4375 14.9998C23.4375 10.6568 20.1562 7.08013 15.9375 6.61378H14.0625C9.8438 7.08013 6.5625 10.6568 6.5625 14.9998Z"
        fill="#000"
      />
      <path
        d="M14.3371 16.0513C14.7032 16.4174 15.2967 16.4174 15.6629 16.0513L18.1629 13.5513C18.529 13.1851 18.529 12.5915 18.1629 12.2254C17.7967 11.8593 17.2032 11.8593 16.8371 12.2254L15.9375 13.125V6.61345C15.3785 6.52781 14.4546 6.57776 14.0625 6.61345V13.125L13.1629 12.2254C12.7967 11.8593 12.2032 11.8593 11.8371 12.2254C11.471 12.5915 11.471 13.1851 11.8371 13.5513L14.3371 16.0513Z"
        fill="#000"
      />
      <path
        d="M5.49797 5.49798C5.86409 5.13186 6.45769 5.13186 6.8238 5.49798L7.31485 5.98903C7.68096 6.35514 7.68096 6.94873 7.31485 7.31485C6.94872 7.68096 6.35514 7.68096 5.98902 7.31485L5.49797 6.8238C5.13186 6.45769 5.13186 5.86409 5.49797 5.49798Z"
        fill="#000"
      />
      <path
        d="M24.5011 5.4983C24.8672 5.86441 24.8672 6.45801 24.5011 6.82413L24.0101 7.31518C23.644 7.68129 23.0504 7.68129 22.6842 7.31518C22.3181 6.94905 22.3181 6.35546 22.6842 5.98935L23.1752 5.4983C23.5414 5.13219 24.135 5.13219 24.5011 5.4983Z"
        fill="#000"
      />
    </svg>
  ),
  readGoodStepLarge: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dash_svg"
    >
      <path
        d="M25.4297 4.62891C11.1914 5.80078 0 17.707 0 32.25C0 47.5781 12.4219 60 27.75 60C42.293 60 54.1992 48.8086 55.3828 34.5703H25.4297V4.62891ZM30.0586 0V29.9414H60C58.8633 13.9102 46.0898 1.13672 30.0586 0Z"
        fill="#E6A3C9"
      />
    </svg>
  ),
  readSRFLarge: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dash_svg"
    >
      <path
        d="M50.2072 54.8538V58.9988C50.2072 59.2635 50.1021 59.5173 49.915 59.7044C49.7278 59.8916 49.474 59.9967 49.2094 59.9967C37.9951 59.9967 38.86 60.0195 38.6362 59.9436C31.3176 57.4571 25.4544 52.8155 22.0598 45.7406C21.9661 45.5445 21.939 45.3232 21.9827 45.1103C22.0264 44.8973 22.1385 44.7046 22.3019 44.5612C22.6568 44.2497 22.9719 43.8957 23.2402 43.5072C23.505 43.1239 23.9925 42.9649 24.4269 43.1334C27.9787 44.5115 31.9901 44.5281 35.5539 43.1204C35.9896 42.9483 36.4827 43.1031 36.7474 43.4895C37.4444 44.5075 38.4506 45.2741 39.617 45.6759L44.9819 47.5257C48.1079 48.6033 50.2072 51.5483 50.2072 54.8538ZM15.6056 59.9967H10.7907C10.526 59.9967 10.2722 59.8916 10.0851 59.7044C9.89792 59.5173 9.79279 59.2635 9.79279 58.9988V54.8538C9.79247 53.1748 10.3378 51.5411 11.3465 50.1989C11.8381 49.5441 12.8786 49.7489 13.0952 50.5386C13.6393 52.5221 14.5593 54.3806 15.9741 55.8338C16.4672 56.3402 16.0361 56.5249 16.5748 58.7628C16.7262 59.3912 16.252 59.9967 15.6056 59.9967ZM31.5961 59.9967H19.7337C19.516 59.9966 19.3043 59.9253 19.1308 59.7937C18.9573 59.6622 18.8315 59.4775 18.7727 59.2679C18.7116 59.0506 18.6535 58.8326 18.5983 58.6137C18.4992 58.2206 18.887 57.8768 19.2639 58.0266C19.3237 58.0504 19.384 58.0738 19.4449 58.0968C19.7609 58.2123 20.0831 58.1641 20.333 58.0008C21.0128 57.5716 20.9252 56.5193 20.1446 56.2271C16.8889 55.008 15.2575 51.9238 14.6893 48.5194C14.6502 48.2868 14.6947 48.048 14.815 47.8452C14.9353 47.6424 15.1236 47.4888 15.3464 47.4117C15.8859 47.2255 16.908 46.8762 19.0547 46.135C19.5352 45.9691 20.0618 46.1914 20.2823 46.6494C22.7813 51.8402 26.6719 56.072 31.8492 59.0678C32.2892 59.3224 32.1043 59.9967 31.5961 59.9967ZM33.4603 3.94135C31.1753 3.50701 28.829 3.50684 26.544 3.94085C25.6732 4.10637 25.0332 3.15301 25.5217 2.41345C27.6494 -0.807478 32.355 -0.801615 34.4787 2.41383C34.966 3.15189 34.3292 4.10675 33.4603 3.94135ZM46.4652 22.2581C46.4652 22.2581 46.4638 25.4967 46.4613 25.5558C46.4295 26.2776 45.3425 26.2413 45.3425 25.5189V23.9929C45.3425 17.7027 39.5028 13.0095 33.4016 14.4331C30.9817 14.9971 28.9348 15.0094 26.7644 14.4731C22.2271 13.3508 17.7895 15.5771 15.7751 19.4288C15.7739 19.4301 15.7726 19.4301 15.7739 19.4313C15.0479 20.8171 14.6575 22.3738 14.6575 23.9929V25.5188C14.6575 26.2411 13.5707 26.2774 13.5387 25.5557C13.5332 25.4305 13.5349 25.6835 13.5349 22.077C13.5349 12.9659 20.9719 5.56054 30.0946 5.61206C39.1807 5.66345 46.4652 13.1717 46.4652 22.2581Z"
        fill="#F2C6A1"
      />
      <path
        d="M33.8543 16.3765C31.1127 17.0152 28.7788 17.0264 26.2854 16.4102C21.3232 15.1831 16.6533 18.9792 16.6533 23.9929V28.8277C16.6533 36.1662 22.5594 42.1744 29.9988 42.1744C37.4421 42.1744 43.3468 35.989 43.3468 28.6531V23.9929C43.3468 18.9853 38.7042 15.25 33.8543 16.3765ZM29.0021 23.1996V22.077C29.0021 21.5256 29.4487 21.0791 30 21.0791C30.5513 21.0791 30.9979 21.5256 30.9979 22.077V23.1996C30.9979 23.7509 30.5513 24.1975 30 24.1975C29.4487 24.1975 29.0021 23.7509 29.0021 23.1996Z"
        fill="#F2C6A1"
      />
    </svg>
  ),
  physicalExeLarge: (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="dash_svg"
    >
      <g clipPath="url(#clip0_852_26)">
        <path
          d="M48.5922 0.0137126C38.9731 0.861461 31.8749 5.66278 27.7371 12.6038C24.9639 16.0802 19.4245 26.6935 17.4099 32.2495C13.757 39.1585 10.5716 47.379 8.07881 54.7895C6.55499 59.3212 13.3971 62.2776 14.9297 57.7256C16.7939 52.1813 19.0462 46.1869 21.5914 40.6241C24.1172 46.2771 26.6837 51.9116 29.4393 57.4569C31.5752 61.7616 38.0022 57.9865 35.8741 53.6963C33.0369 47.9881 30.4015 42.1887 27.805 36.3699C27.8379 36.2574 27.8796 36.1478 27.9146 36.0362C28.3472 36.1594 28.8244 36.1972 29.3501 36.0973L41.2719 33.8616C42.9703 33.5424 43.6212 31.684 43.3535 30.1961C42.5503 25.7371 40.01 22.6352 36.8479 19.7001C36.3785 18.1035 34.8129 16.6913 33.0757 15.2877C36.5977 9.59404 42.3476 6.50374 49.8319 5.84416C53.6516 5.50953 52.379 -0.318985 48.5922 0.0137126ZM34.1165 25.3579C35.0991 26.3802 35.9352 27.4559 36.5666 28.7014L30.7983 29.7829C31.7682 28.2212 32.8847 26.7469 34.1165 25.3579Z"
          fill="#1B96B1"
        />
        <path
          d="M42.3418 20.2819C45.1676 20.2819 47.4583 17.9912 47.4583 15.1654C47.4583 12.3396 45.1676 10.0488 42.3418 10.0488C39.516 10.0488 37.2252 12.3396 37.2252 15.1654C37.2252 17.9912 39.516 20.2819 42.3418 20.2819Z"
          fill="#1B96B1"
        />
      </g>
      <defs>
        <clipPath id="clip0_852_26">
          <rect width={60} height={60} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  energyExerciseDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="#809FB3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.814 39.0231C19.814 38.4837 20.2513 38.0464 20.7907 38.0464H31.2092C31.7486 38.0464 32.186 38.4837 32.186 39.0231C32.186 39.5625 31.7486 39.9999 31.2092 39.9999H20.7907C20.2513 39.9999 19.814 39.5625 19.814 39.0231Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9999 12C26.5393 12 26.9766 12.4373 26.9766 12.9767V14.2791C26.9766 14.8185 26.5393 15.2558 25.9999 15.2558C25.4605 15.2558 25.0232 14.8185 25.0232 14.2791V12.9767C25.0232 12.4373 25.4605 12 25.9999 12ZM12 25.9999C12 25.4605 12.4373 25.0232 12.9767 25.0232H14.2791C14.8185 25.0232 15.2558 25.4605 15.2558 25.9999C15.2558 26.5393 14.8185 26.9766 14.2791 26.9766H12.9767C12.4373 26.9766 12 26.5393 12 25.9999ZM36.744 25.9999C36.744 25.4605 37.1813 25.0232 37.7207 25.0232H39.023C39.5625 25.0232 39.9998 25.4605 39.9998 25.9999C39.9998 26.5393 39.5625 26.9766 39.023 26.9766H37.7207C37.1813 26.9766 36.744 26.5393 36.744 25.9999Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.7061 30.2327H18.2937H12.9767C12.4373 30.2327 12 30.67 12 31.2094C12 31.7488 12.4373 32.1861 12.9767 32.1861H39.023C39.5625 32.1861 39.9998 31.7488 39.9998 31.2094C39.9998 30.67 39.5625 30.2327 39.023 30.2327H33.7061Z"
        fill="white"
      />
      <path
        d="M15.9067 35.1161C15.9067 34.5767 16.344 34.1394 16.8835 34.1394H35.1159C35.6553 34.1394 36.0926 34.5767 36.0926 35.1161C36.0926 35.6556 35.6553 36.0929 35.1159 36.0929H16.8835C16.344 36.0929 15.9067 35.6556 15.9067 35.1161Z"
        fill="white"
      />
      <path
        d="M17.2095 25.9996C17.2095 27.5335 17.6029 28.9765 18.2939 30.2322H33.7063C34.3973 28.9765 34.7907 27.5335 34.7907 25.9996C34.7907 21.4749 31.3722 17.7486 26.9768 17.2627H25.0234C20.6281 17.7486 17.2095 21.4749 17.2095 25.9996Z"
        fill="white"
      />
      <path
        d="M16.1005 16.1003C16.482 15.7189 17.1004 15.7189 17.4818 16.1003L17.9934 16.6119C18.3749 16.9933 18.3749 17.6118 17.9934 17.9932C17.612 18.3746 16.9936 18.3746 16.6121 17.9932L16.1005 17.4816C15.7191 17.1002 15.7191 16.4817 16.1005 16.1003Z"
        fill="white"
      />
      <path
        d="M35.8992 16.1008C36.2807 16.4822 36.2807 17.1007 35.8992 17.4821L35.3877 17.9937C35.0062 18.3751 34.3877 18.3751 34.0063 17.9937C33.6249 17.6122 33.6249 16.9938 34.0063 16.6124L34.5178 16.1008C34.8993 15.7193 35.5178 15.7193 35.8992 16.1008Z"
        fill="white"
      />
    </svg>
  ),
  mahaMudraDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="#9BD0B6" />
      <path
        d="M23.2584 31.9498C22.9437 31.983 22.4106 32.0257 21.7458 32.0257C20.0463 32.0257 17.4951 31.745 15.5829 30.3108C13.9102 31.1587 12.5859 32.5569 12 33.2405C12.8741 34.2603 15.3919 36.8711 18.2581 36.871C21.1334 36.871 23.6451 34.261 24.5166 33.2411C24.2442 32.9231 23.8117 32.4502 23.2584 31.9498Z"
        fill="white"
      />
      <path
        d="M36.404 30.3044C34.491 31.744 31.9348 32.0258 30.2328 32.0258C29.5812 32.0258 29.056 31.9848 28.739 31.9518C28.1871 32.451 27.7556 32.9229 27.4834 33.2404C28.3574 34.2603 30.875 36.8711 33.7413 36.871C36.6166 36.8711 39.1284 34.261 40 33.2412C39.4131 32.5563 38.0833 31.152 36.404 30.3044Z"
        fill="white"
      />
      <path
        d="M22.8511 30.6339C22.8541 30.5946 22.857 30.553 22.86 30.5098C21.358 28.7528 19.8027 26.2523 19.8027 23.4311C19.8027 23.2107 19.8131 22.9924 19.8313 22.776C17.792 21.6398 15.1113 21.6983 14.001 21.7837C13.8978 23.1229 13.8321 26.7494 15.8589 28.7761C17.8854 30.8027 21.5117 30.7369 22.8511 30.6339Z"
        fill="white"
      />
      <path
        d="M29.1221 30.556C29.1239 30.5822 29.1258 30.6093 29.1276 30.634C30.4661 30.7371 34.0929 30.8031 36.1197 28.7761C38.1529 26.7431 38.0834 23.1213 37.9785 21.7838C36.8766 21.6989 34.2234 21.6401 32.1886 22.7531C32.2081 22.9769 32.219 23.2028 32.219 23.4311C32.219 26.2772 30.6362 28.7968 29.1221 30.556Z"
        fill="white"
      />
      <path
        d="M26.0106 15.1292C24.7808 16.162 21.1479 19.5425 21.1479 23.4312C21.1479 27.32 24.7808 30.7006 26.0106 31.7334C27.2399 30.7011 30.8735 27.3203 30.8735 23.4312C30.8735 19.5425 27.2405 16.1619 26.0106 15.1292Z"
        fill="white"
      />
    </svg>
  ),
  chantDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="#D68D96" />
      <path
        d="M15.2987 35.0149C13.099 32.3772 12 29.3403 12 25.9076C12 23.615 12.5074 21.4713 13.5221 19.4789C14.5368 17.4865 15.9317 15.8335 17.7058 14.5208C19.4792 13.2089 21.4544 12.3672 23.6313 12V20.9217C23.6313 24.0117 22.863 26.831 21.3247 29.3755C19.7864 31.9224 17.7788 33.8011 15.2987 35.0149ZM28.3606 34.39C27.1748 32.8695 26.37 31.2256 25.9453 29.4605C25.5319 31.2256 24.7328 32.8695 23.5479 34.39C22.3629 35.9105 20.9316 37.2044 19.2547 38.2701C21.3328 39.4234 23.5625 40 25.9453 40C28.3403 40 30.5748 39.4234 32.6537 38.2701C30.976 37.2052 29.5463 35.9113 28.3606 34.39ZM38.4787 19.4789C37.464 17.4857 36.0675 15.8335 34.295 14.5208C32.5224 13.208 30.5448 12.3672 28.3695 12V20.9217C28.3695 24.0117 29.137 26.831 30.6761 29.3755C32.2128 31.92 34.222 33.7987 36.7029 35.0149C38.9034 32.3772 40 29.3403 40 25.9076C40 23.6158 39.4918 21.4721 38.4787 19.4789Z"
        fill="white"
      />
    </svg>
  ),
  hongSauDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="#986D9A" />
      <g clipPath="url(#clip0_769_3182)">
        <path
          d="M39.9385 17.0192C38.7138 14.6281 35.6229 10.1958 29.9075 12.8202C26.35 14.4532 24.3672 15.3863 24.3672 15.3863L19.235 17.6024C17.777 18.3023 14.6278 17.3108 12.8199 16.6693C12.295 16.4943 11.8284 17.0192 12.0617 17.5441C13.2864 19.9352 16.3774 24.3675 22.0927 21.7431C25.6502 20.1102 32.7652 17.0192 32.7652 17.0192C34.2232 16.3194 37.3725 17.3108 39.1804 17.9523C39.7052 18.069 40.1718 17.5441 39.9385 17.0192ZM27.6331 24.4841C26.9915 24.8341 24.4255 26.0005 24.4255 26.0005L21.8594 27.1085C20.5764 27.8084 17.8353 26.8753 16.2024 26.2337C15.7358 26.0005 15.3276 26.5837 15.5609 27.0502C16.6106 29.383 19.3517 33.582 24.3672 31.016C27.5164 29.4413 30.1408 28.3916 30.1408 28.3916C31.4238 27.6917 34.1649 28.6249 35.7978 29.2664C36.2644 29.4413 36.6726 28.9165 36.4393 28.3916C35.3896 26.1171 32.6486 21.9181 27.6331 24.4841ZM25.7668 34.8067C25.242 35.0983 24.3672 35.6232 24.3672 35.6232C23.3757 36.2647 21.3345 35.4483 20.1098 34.8651C19.7599 34.6901 19.4683 35.215 19.6433 35.6815C20.4014 37.781 22.4426 41.5718 26.2334 39.239C27.6331 38.3642 27.6331 38.4226 27.6331 38.4226C28.6828 37.8977 30.6657 38.5975 31.8904 39.1807C32.2403 39.3557 32.5319 38.8308 32.357 38.3642C31.5988 36.2647 29.6743 32.6489 25.7668 34.8067Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_769_3182">
          <rect
            width={28}
            height={28}
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  aumDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="#D4CAA8" />
      <path
        d="M40 29.6703C40 31.9167 39.0913 37.6969 34.1736 37.6969C29.4872 37.6969 27.7793 33.5574 28.1032 32.0598C28.3724 32.5183 29.2264 34.8783 33.8371 34.8783C38.5655 34.8783 38.616 29.624 38.616 29.624C38.616 29.624 38.536 25.8968 35.6544 25.8968C32.1375 25.8968 32.0197 31.4876 28.486 31.4876C26.715 31.4876 26.1218 30.5495 25.7642 30.2929C26.5256 32.6571 25.6254 38.1554 19.8368 38.1554C11.5747 38.1554 12.0038 29.2412 12.0038 29.2412C12.0038 29.2412 13.3878 34.7353 19.6938 34.7353C23.5388 34.7353 24.0436 32.5393 24.0436 31.5339C24.0436 30.5327 23.278 28.7658 19.8368 28.7658L19.0838 25.1943C19.0838 25.1943 20.1019 25.5266 21.3597 25.5266C23.0172 25.5266 23.3958 24.4202 23.3958 23.5116C23.3958 22.6071 22.5082 21.69 20.8843 21.69C18.3687 21.69 16.3494 24.273 16.3494 24.273L14.3933 20.6425C14.3933 20.6425 16.2106 18.2993 19.8915 18.2993C23.5683 18.2993 25.2384 21.3114 25.2384 23.0783C25.2384 24.8451 24.4138 26.3091 22.8489 27.1378C24.9607 28.1306 24.3213 28.8584 25.6675 28.8584C27.8971 28.8584 28.1999 27.0368 29.2474 25.3836C30.215 23.8649 31.5906 22.5061 34.0264 22.5061C38.902 22.5061 40 27.4281 40 29.6703ZM30.4927 21.9803C32.9705 21.9803 34.8887 20.5458 34.8887 20.5458L32.8316 16.9153C32.8316 16.9153 31.4013 18.9219 28.629 18.9219C25.8568 18.9219 23.5641 16.3895 23.5641 16.3895C23.5641 16.3895 24.6158 21.9803 30.4927 21.9803ZM30.8755 16.2002L28.8183 14L26.5256 16.0066L28.5828 18.3498L30.8755 16.2002Z"
        fill="white"
      />
    </svg>
  ),
  kriyaDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="#B0B38E" />
      <g clipPath="url(#clip0_769_3206)">
        <path
          d="M25.0861 12.0131C24.7895 11.9521 24.4922 12.1088 24.3737 12.3869L20.058 22.5136C18.7275 25.4545 19.9553 28.9758 20.4799 30.2276L15.3014 34.5201C15.1691 34.6298 15.0869 34.7883 15.0733 34.9595C15.0597 35.1308 15.116 35.3002 15.2293 35.4293L19.0507 39.7834C19.1719 39.9214 19.3463 39.9999 19.5288 39.9999C19.5395 39.9999 19.5502 39.9996 19.561 39.9991C19.7551 39.9893 19.934 39.8913 20.0468 39.7329L25.4681 32.1242C25.5448 32.0165 25.5861 31.8876 25.5862 31.7554L25.5866 30.8479C25.5883 26.9822 25.5948 13.3535 25.5948 12.6361C25.5949 12.334 25.3822 12.0735 25.0861 12.0131Z"
          fill="white"
        />
        <path
          d="M36.9265 34.9594C36.913 34.7881 36.8306 34.6296 36.6983 34.5201L31.5198 30.2276C32.0444 28.9758 33.2723 25.4545 31.9417 22.5136L27.626 12.3869C27.5076 12.1088 27.2097 11.9522 26.9136 12.013C26.6174 12.0735 26.4048 12.334 26.4048 12.6362C26.4048 13.3537 26.4112 26.9823 26.413 30.8481L26.4134 31.7555C26.4135 31.8877 26.4546 32.0166 26.5314 32.1244L31.9528 39.7331C32.0656 39.8913 32.2445 39.9894 32.4386 39.9993C32.4494 39.9998 32.4602 40.0001 32.4708 40.0001C32.6534 40.0001 32.8277 39.9216 32.9488 39.7836L36.7703 35.4295C36.8838 35.3002 36.9401 35.1307 36.9265 34.9594Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_769_3206">
          <rect
            width={28}
            height={28}
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  kriyaCountDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.814 39.0231C19.814 38.4837 20.2513 38.0464 20.7907 38.0464H31.2092C31.7486 38.0464 32.186 38.4837 32.186 39.0231C32.186 39.5625 31.7486 39.9999 31.2092 39.9999H20.7907C20.2513 39.9999 19.814 39.5625 19.814 39.0231Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.9999 12C26.5393 12 26.9766 12.4373 26.9766 12.9767V14.2791C26.9766 14.8185 26.5393 15.2558 25.9999 15.2558C25.4605 15.2558 25.0232 14.8185 25.0232 14.2791V12.9767C25.0232 12.4373 25.4605 12 25.9999 12ZM12 25.9999C12 25.4605 12.4373 25.0232 12.9767 25.0232H14.2791C14.8185 25.0232 15.2558 25.4605 15.2558 25.9999C15.2558 26.5393 14.8185 26.9766 14.2791 26.9766H12.9767C12.4373 26.9766 12 26.5393 12 25.9999ZM36.744 25.9999C36.744 25.4605 37.1813 25.0232 37.7207 25.0232H39.023C39.5625 25.0232 39.9998 25.4605 39.9998 25.9999C39.9998 26.5393 39.5625 26.9766 39.023 26.9766H37.7207C37.1813 26.9766 36.744 26.5393 36.744 25.9999Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.7061 30.2327H18.2937H12.9767C12.4373 30.2327 12 30.67 12 31.2094C12 31.7488 12.4373 32.1861 12.9767 32.1861H39.023C39.5625 32.1861 39.9998 31.7488 39.9998 31.2094C39.9998 30.67 39.5625 30.2327 39.023 30.2327H33.7061Z"
        fill="white"
      />
      <path
        d="M15.9067 35.1161C15.9067 34.5767 16.344 34.1394 16.8835 34.1394H35.1159C35.6553 34.1394 36.0926 34.5767 36.0926 35.1161C36.0926 35.6556 35.6553 36.0929 35.1159 36.0929H16.8835C16.344 36.0929 15.9067 35.6556 15.9067 35.1161Z"
        fill="white"
      />
      <path
        d="M17.2095 25.9996C17.2095 27.5335 17.6029 28.9765 18.2939 30.2322H33.7063C34.3973 28.9765 34.7907 27.5335 34.7907 25.9996C34.7907 21.4749 31.3722 17.7486 26.9768 17.2627H25.0234C20.6281 17.7486 17.2095 21.4749 17.2095 25.9996Z"
        fill="white"
      />
      <path
        d="M16.1005 16.1003C16.482 15.7189 17.1004 15.7189 17.4818 16.1003L17.9934 16.6119C18.3749 16.9933 18.3749 17.6118 17.9934 17.9932C17.612 18.3746 16.9936 18.3746 16.6121 17.9932L16.1005 17.4816C15.7191 17.1002 15.7191 16.4817 16.1005 16.1003Z"
        fill="white"
      />
      <path
        d="M35.8992 16.1008C36.2807 16.4822 36.2807 17.1007 35.8992 17.4821L35.3877 17.9937C35.0062 18.3751 34.3877 18.3751 34.0063 17.9937C33.6249 17.6122 33.6249 16.9938 34.0063 16.6124L34.5178 16.1008C34.8993 15.7193 35.5178 15.7193 35.8992 16.1008Z"
        fill="white"
      />
    </svg>
  ),
  readGoodDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="#E6A3C9" />
      <path
        d="M23.8672 14.1602C17.2227 14.707 12 20.2633 12 27.05C12 34.2031 17.7969 40 24.95 40C31.7367 40 37.293 34.7773 37.8453 28.1328H23.8672V14.1602ZM26.0273 12V25.9727H40C39.4695 18.4914 33.5086 12.5305 26.0273 12Z"
        fill="white"
      />
    </svg>
  ),
  readSRFDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="#F2C6A1" />
      <path
        d="M35.4299 37.5985V39.5328C35.4299 39.6563 35.3808 39.7747 35.2935 39.8621C35.2062 39.9494 35.0877 39.9985 34.9642 39.9985C29.7309 39.9985 30.1345 40.0091 30.0301 39.9737C26.6147 38.8133 23.8786 36.6472 22.2944 33.3456C22.2507 33.2541 22.2381 33.1508 22.2585 33.0515C22.2789 32.9521 22.3312 32.8621 22.4074 32.7952C22.573 32.6499 22.7201 32.4847 22.8453 32.3034C22.9689 32.1245 23.1963 32.0503 23.3991 32.1289C25.0566 32.772 26.9285 32.7798 28.5917 32.1229C28.795 32.0425 29.0251 32.1148 29.1486 32.2951C29.4739 32.7702 29.9435 33.1279 30.4878 33.3154L32.9914 34.1787C34.4502 34.6815 35.4299 36.0559 35.4299 37.5985ZM19.2825 39.9985H17.0355C16.912 39.9985 16.7936 39.9494 16.7062 39.8621C16.6189 39.7747 16.5698 39.6563 16.5698 39.5328V37.5985C16.5697 36.8149 16.8241 36.0525 17.2949 35.4262C17.5243 35.1206 18.0099 35.2161 18.1109 35.5847C18.3648 36.5103 18.7942 37.3776 19.4544 38.0558C19.6845 38.2921 19.4834 38.3783 19.7348 39.4226C19.8054 39.7159 19.5841 39.9985 19.2825 39.9985ZM26.7447 39.9985H21.2089C21.1073 39.9984 21.0085 39.9651 20.9276 39.9037C20.8466 39.8423 20.7879 39.7562 20.7604 39.6583C20.7319 39.557 20.7048 39.4552 20.6791 39.3531C20.6328 39.1696 20.8138 39.0092 20.9897 39.0791C21.0176 39.0902 21.0457 39.1011 21.0741 39.1119C21.2216 39.1658 21.372 39.1432 21.4886 39.067C21.8058 38.8667 21.765 38.3757 21.4007 38.2393C19.8813 37.6704 19.12 36.2311 18.8549 34.6424C18.8366 34.5339 18.8574 34.4224 18.9135 34.3278C18.9697 34.2331 19.0575 34.1615 19.1615 34.1255C19.4133 34.0386 19.8902 33.8756 20.892 33.5297C21.1163 33.4523 21.362 33.556 21.4649 33.7697C22.6311 36.1921 24.4468 38.1669 26.8628 39.565C27.0681 39.6838 26.9819 39.9985 26.7447 39.9985ZM27.6147 13.8393C26.5483 13.6366 25.4534 13.6365 24.387 13.8391C23.9807 13.9163 23.682 13.4714 23.91 13.1263C24.9029 11.6232 27.0989 11.6259 28.0899 13.1265C28.3173 13.4709 28.0202 13.9165 27.6147 13.8393ZM33.6836 22.3871C33.6836 22.3871 33.683 23.8985 33.6818 23.9261C33.667 24.2629 33.1597 24.2459 33.1597 23.9088V23.1967C33.1597 20.2613 30.4345 18.0711 27.5873 18.7355C26.458 18.9986 25.5028 19.0044 24.4899 18.7541C22.3725 18.2304 20.3016 19.2693 19.3616 21.0668C19.361 21.0674 19.3604 21.0674 19.361 21.0679C19.0222 21.7147 18.84 22.4411 18.84 23.1967V23.9088C18.84 24.2459 18.3328 24.2628 18.3179 23.926C18.3154 23.8676 18.3161 23.9856 18.3161 22.3026C18.3161 18.0507 21.7867 14.5949 26.044 14.619C30.2842 14.6429 33.6836 18.1468 33.6836 22.3871Z"
        fill="white"
      />
      <path
        d="M27.7987 19.6425C26.5192 19.9405 25.4301 19.9458 24.2665 19.6582C21.9508 19.0855 19.7715 20.857 19.7715 23.1968V25.453C19.7715 28.8776 22.5277 31.6815 25.9994 31.6815C29.473 31.6815 32.2285 28.795 32.2285 25.3715V23.1968C32.2285 20.8599 30.0619 19.1168 27.7987 19.6425ZM25.5343 22.8266V22.3027C25.5343 22.0454 25.7427 21.837 26 21.837C26.2573 21.837 26.4656 22.0454 26.4656 22.3027V22.8266C26.4656 23.0839 26.2573 23.2923 26 23.2923C25.7427 23.2923 25.5343 23.0839 25.5343 22.8266Z"
        fill="white"
      />
    </svg>
  ),
  physicalExeDetail: (
    <svg
      width={52}
      height={52}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={26} cy={26} r={26} fill="#1B96B1" />
      <g clipPath="url(#clip0_852_73)">
        <path
          d="M34.6764 12.0064C30.1874 12.402 26.8749 14.6426 24.9439 17.8818C23.6498 19.5041 21.0647 24.457 20.1246 27.0498C18.4199 30.274 16.9334 34.1102 15.7701 37.5684C15.059 39.6832 18.252 41.0629 18.9671 38.9386C19.8371 36.3513 20.8882 33.5539 22.0759 30.9579C23.2546 33.596 24.4524 36.2254 25.7383 38.8132C26.7351 40.8221 29.7343 39.0604 28.7412 37.0583C27.4172 34.3945 26.1874 31.6881 24.9756 28.9726C24.991 28.9201 25.0105 28.869 25.0268 28.8169C25.2286 28.8744 25.4514 28.892 25.6967 28.8454L31.2602 27.8021C32.0528 27.6531 32.3565 26.7859 32.2316 26.0915C31.8568 24.0107 30.6713 22.5631 29.1957 21.1934C28.9766 20.4483 28.246 19.7893 27.4353 19.1343C29.0789 16.4772 31.7622 15.0351 35.2548 14.7273C37.0374 14.5711 36.4435 11.8511 34.6764 12.0064ZM27.921 23.8337C28.3795 24.3108 28.7697 24.8128 29.0644 25.394L26.3725 25.8987C26.8251 25.1699 27.3461 24.4819 27.921 23.8337Z"
          fill="white"
        />
        <path
          d="M31.7593 21.4649C33.078 21.4649 34.147 20.3959 34.147 19.0772C34.147 17.7585 33.078 16.6895 31.7593 16.6895C30.4406 16.6895 29.3716 17.7585 29.3716 19.0772C29.3716 20.3959 30.4406 21.4649 31.7593 21.4649Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_852_73">
          <rect
            width={28}
            height={28}
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  logo: (
    <svg
      width="105"
      height="100"
      viewBox="0 0 105 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 97.915V2H14.9016V46.264L35.2013 2H48.6957L29.9664 40.4474L52.3602 97.915H37.9351L22.0559 55.396L14.9016 68.8322V97.915H1Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M73.0087 97.915L53.2324 2H68.2391L79.2906 69.5302L90.4584 2H105L85.1071 97.915H73.0087Z"
        fill="black"
      />
    </svg>
  ),
  navLogo: (
    <svg
      width="39"
      height="36"
      viewBox="0 0 39 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 36V0H5.21771V16.6137L12.8369 0H17.9018L10.872 14.4306L19.2771 36H13.8629L7.90297 20.0412L5.21771 25.0843V36H0Z"
        fill="black"
      />
      <path
        d="M27.0273 36L19.6046 0H25.2371L29.3851 25.3463L33.5767 0H39.0346L31.5682 36H27.0273Z"
        fill="black"
      />
    </svg>
  ),
  energySmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_17_368"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17_368)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6 71.3915 22.4218 68.1937C17.1142 64.916 13.0186 59.5954 10.7379 53.4917C8.514 47.5397 8.71415 40.9497 9.8928 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4092C21.0467 13.6492 25.5779 9.5921 31.0788 7.64128C36.6888 5.65178 42.8601 5.28918 48.4412 7.37056C53.8928 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7232 64.347C50.1735 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#809FB3"
        />
      </g>
    </svg>
  ),
  mahaMudraSmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_37_66"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_37_66)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6 71.3915 22.4217 68.1937C17.1142 64.916 13.0186 59.5954 10.7379 53.4917C8.51399 47.5397 8.71414 40.9497 9.89279 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4092C21.0466 13.6492 25.5779 9.5921 31.0788 7.64128C36.6888 5.65178 42.8601 5.28918 48.4412 7.37056C53.8928 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7232 64.347C50.1735 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#9BD0B6"
        />
      </g>
    </svg>
  ),
  chantSmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_17_372"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17_372)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6001 71.3915 22.4218 68.1937C17.1143 64.916 13.0186 59.5954 10.738 53.4917C8.51402 47.5397 8.71417 40.9497 9.89282 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4092C21.0467 13.6492 25.5779 9.5921 31.0788 7.64128C36.6888 5.65178 42.8602 5.28918 48.4412 7.37056C53.8929 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7233 64.347C50.1736 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#D68D96"
        />
      </g>
    </svg>
  ),
  hongSauSmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_17_375"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17_375)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6001 71.3915 22.4218 68.1937C17.1143 64.916 13.0186 59.5954 10.738 53.4917C8.51402 47.5397 8.71417 40.9497 9.89282 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4092C21.0467 13.6492 25.5779 9.5921 31.0788 7.64128C36.6888 5.65178 42.8602 5.28918 48.4412 7.37056C53.8929 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7233 64.347C50.1736 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#986D9A"
        />
      </g>
    </svg>
  ),
  aumSmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_17_378"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17_378)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6001 71.3915 22.4218 68.1937C17.1143 64.916 13.0186 59.5954 10.738 53.4917C8.51402 47.5397 8.71417 40.9497 9.89282 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4092C21.0467 13.6492 25.5779 9.5921 31.0788 7.64128C36.6888 5.65178 42.8602 5.28918 48.4412 7.37056C53.8929 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7233 64.347C50.1736 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#D4CAA8"
        />
      </g>
    </svg>
  ),
  kriyaSmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_17_381"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17_381)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6001 71.3915 22.4218 68.1937C17.1143 64.916 13.0186 59.5954 10.738 53.4917C8.51402 47.5397 8.71417 40.9497 9.89282 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4092C21.0467 13.6492 25.5779 9.5921 31.0788 7.64128C36.6888 5.65178 42.8602 5.28918 48.4412 7.37056C53.8929 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7233 64.347C50.1736 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#B0B38E"
        />
      </g>
    </svg>
  ),
  kriyaCountSmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_17_368"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17_368)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6 71.3915 22.4218 68.1937C17.1142 64.916 13.0186 59.5954 10.7379 53.4917C8.514 47.5397 8.71415 40.9497 9.8928 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4092C21.0467 13.6492 25.5779 9.5921 31.0788 7.64128C36.6888 5.65178 42.8601 5.28918 48.4412 7.37056C53.8928 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7232 64.347C50.1735 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#000"
        />
      </g>
    </svg>
  ),
  readGoodSmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_17_368"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17_368)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6 71.3915 22.4218 68.1937C17.1142 64.916 13.0186 59.5954 10.7379 53.4917C8.514 47.5397 8.71415 40.9497 9.8928 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4092C21.0467 13.6492 25.5779 9.5921 31.0788 7.64128C36.6888 5.65178 42.8601 5.28918 48.4412 7.37056C53.8928 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7232 64.347C50.1735 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#E6A3C9"
        />
      </g>
    </svg>
  ),
  readSRFSmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_17_368"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_17_368)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6 71.3915 22.4218 68.1937C17.1142 64.916 13.0186 59.5954 10.7379 53.4917C8.514 47.5397 8.71415 40.9497 9.8928 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4092C21.0467 13.6492 25.5779 9.5921 31.0788 7.64128C36.6888 5.65178 42.8601 5.28918 48.4412 7.37056C53.8928 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7232 64.347C50.1735 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#F2C6A1"
        />
      </g>
    </svg>
  ),
  physicalSmall: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_852_79"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={50}
        height={50}
      >
        <path d="M0 0H50V40C50 45.5228 45.5228 50 40 50H0V0Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_852_79)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.723 71.3915C33.7866 72.0984 27.6001 71.3915 22.4218 68.1937C17.1143 64.916 13.0186 59.5954 10.738 53.4917C8.51402 47.5397 8.71417 40.9497 9.89282 34.6623C11.0247 28.6242 13.6211 23.1199 17.3146 18.4091C21.0467 13.6492 25.5779 9.59209 31.0788 7.64127C36.6888 5.65177 42.8602 5.28917 48.4412 7.37055C53.8929 9.40368 57.7668 14.2689 61.508 18.9895C65.2201 23.6733 69.2861 28.4894 70.0143 34.5911C70.7385 40.6589 68.1863 46.5299 65.4342 51.8854C62.838 56.9375 59.111 61.0182 54.7233 64.347C50.1736 67.7987 45.2588 70.7322 39.723 71.3915Z"
          fill="#1B96B1"
        />
      </g>
    </svg>
  ),
  deleteSmall: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8257 1.62857H3.17425C2.71227 1.6294 2.26945 1.81329 1.94279 2.13996C1.61612 2.46663 1.43223 2.90945 1.4314 3.37143V3.77714C1.43162 3.85285 1.4618 3.92539 1.51533 3.97892C1.56886 4.03246 1.6414 4.06263 1.71711 4.06286H14.2828C14.3585 4.06263 14.4311 4.03246 14.4846 3.97892C14.5381 3.92539 14.5683 3.85285 14.5685 3.77714V3.37143C14.5677 2.90945 14.3838 2.46663 14.0572 2.13996C13.7305 1.81329 13.2877 1.6294 12.8257 1.62857ZM10.32 1.05714V0.874286C10.32 0.642411 10.2279 0.420033 10.0639 0.256072C9.89994 0.092112 9.67756 0 9.44568 0H6.47711C6.24538 0.000453053 6.02326 0.0927105 5.8594 0.256573C5.69554 0.420435 5.60328 0.64255 5.60283 0.874286V1.05714H10.32ZM2.27711 4.63429L3.06568 14.5657C3.09799 14.9555 3.27524 15.3191 3.56245 15.5846C3.84966 15.8501 4.22597 15.9983 4.61711 16H11.3257C11.7168 15.9983 12.0931 15.8501 12.3803 15.5846C12.6676 15.3191 12.8448 14.9555 12.8771 14.5657L13.6685 4.63429H2.27711ZM10.1885 9.69714C10.1971 7.51143 10.2143 5.32857 10.2143 5.32857C10.2144 5.29123 10.2219 5.25428 10.2364 5.21984C10.2508 5.18541 10.2719 5.15416 10.2984 5.12788C10.325 5.10161 10.3564 5.08083 10.391 5.06673C10.4256 5.05263 10.4626 5.04549 10.5 5.04571H10.5028C10.5785 5.04669 10.6508 5.07759 10.7038 5.13166C10.7568 5.18573 10.7862 5.25858 10.7857 5.33429C10.76 8.59714 10.7371 13.5371 10.7743 14.0114C10.7861 14.0538 10.788 14.0984 10.7798 14.1416C10.7715 14.1849 10.7535 14.2256 10.7269 14.2608C10.7004 14.2959 10.6661 14.3244 10.6267 14.3441C10.5874 14.3638 10.544 14.3741 10.5 14.3743C10.4617 14.3739 10.4239 14.3661 10.3885 14.3514C10.1714 14.26 10.1714 14.26 10.1885 9.69714ZM7.68568 5.33143C7.68568 5.25565 7.71578 5.18298 7.76937 5.1294C7.82295 5.07582 7.89562 5.04571 7.9714 5.04571C8.04717 5.04571 8.11984 5.07582 8.17343 5.1294C8.22701 5.18298 8.25711 5.25565 8.25711 5.33143V14.0886C8.25711 14.1643 8.22701 14.237 8.17343 14.2906C8.11984 14.3442 8.04717 14.3743 7.9714 14.3743C7.89562 14.3743 7.82295 14.3442 7.76937 14.2906C7.71578 14.237 7.68568 14.1643 7.68568 14.0886V5.33143ZM5.14568 5.33143C5.14568 5.25565 5.17578 5.18298 5.22937 5.1294C5.28295 5.07582 5.35562 5.04571 5.4314 5.04571C5.50717 5.04571 5.57984 5.07582 5.63343 5.1294C5.68701 5.18298 5.71711 5.25565 5.71711 5.33143V14.0886C5.71711 14.1643 5.68701 14.237 5.63343 14.2906C5.57984 14.3442 5.50717 14.3743 5.4314 14.3743C5.35562 14.3743 5.28295 14.3442 5.22937 14.2906C5.17578 14.237 5.14568 14.1643 5.14568 14.0886V5.33143Z"
        fill="#FF1C0D"
      />
    </svg>
  ),
  toggleSvg: (
    <svg
      width={32}
      height={33}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32 16.2472C32 25.1319 24.8365 32.3333 15.9986 32.3333C7.16078 32.3333 0 25.1319 0 16.2472C0 7.36256 7.16349 0.161133 15.9986 0.161133C24.8338 0.161133 32 7.36256 32 16.2472Z"
        fill="#F0F7FB"
      />
      <g clipPath="url(#clip0_1_16)">
        <path
          d="M9.33333 10.9997H22.6667"
          stroke="#0E344B"
          strokeWidth="0.833333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3333 15.9997H22.6667"
          stroke="#0E344B"
          strokeWidth="0.833333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 20.9997H22.6667"
          stroke="#0E344B"
          strokeWidth="0.833333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_16">
          <rect
            width={20}
            height={20}
            fill="white"
            transform="translate(6 5.9997)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  headerClose: (
    <svg
      width={32}
      height={33}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16.0861C0 24.9708 7.16349 32.1722 16.0014 32.1722C24.8392 32.1722 32 24.9708 32 16.0861C32 7.20143 24.8365 0 16.0014 0C7.1662 0 0 7.20143 0 16.0861Z"
        fill="#F0F7FB"
        fillOpacity="1"
      />
      <path
        d="M12 20.4854L20.4853 12.0001"
        stroke="black"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12L20.4853 20.4853"
        stroke="black"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dashboard: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9999 10.68V2.52C23.9999 0.72 23.1915 0 21.183 0H16.0799C14.0715 0 13.263 0.72 13.263 2.52V10.68C13.263 12.48 14.0715 13.2 16.0799 13.2H21.183C23.1915 13.2 23.9999 12.48 23.9999 10.68Z"
        fill="#292D32"
      />
      <path
        d="M10.7368 13.3198V21.4798C10.7368 23.2798 9.92842 23.9998 7.92 23.9998H2.81684C0.808421 23.9998 0 23.2798 0 21.4798V13.3198C0 11.5198 0.808421 10.7998 2.81684 10.7998H7.92C9.92842 10.7998 10.7368 11.5198 10.7368 13.3198Z"
        fill="#292D32"
      />
      <path
        d="M23.9998 21.4799V18.1199C23.9998 16.3199 23.1914 15.5999 21.183 15.5999H16.0798C14.0714 15.5999 13.263 16.3199 13.263 18.1199V21.4799C13.263 23.2799 14.0714 23.9999 16.0798 23.9999H21.183C23.1914 23.9999 23.9998 23.2799 23.9998 21.4799Z"
        fill="#292D32"
      />
      <path
        d="M10.7368 5.88V2.52C10.7368 0.72 9.92842 0 7.92 0H2.81684C0.808421 0 0 0.72 0 2.52V5.88C0 7.68 0.808421 8.4 2.81684 8.4H7.92C9.92842 8.4 10.7368 7.68 10.7368 5.88Z"
        fill="#292D32"
      />
    </svg>
  ),
  users: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4481 0C9.30406 0 6.74805 2.55602 6.74805 5.70003C6.74805 8.78405 9.16006 11.2801 12.3041 11.3881C12.4001 11.3761 12.4961 11.3761 12.5681 11.3881C12.5921 11.3881 12.6041 11.3881 12.6281 11.3881C12.6401 11.3881 12.6401 11.3881 12.6521 11.3881C15.7241 11.2801 18.1361 8.78405 18.1481 5.70003C18.1481 2.55602 15.5921 0 12.4481 0Z"
        fill="#292D32"
      />
      <path
        d="M18.5441 14.58C15.1961 12.348 9.73603 12.348 6.36401 14.58C4.84 15.6 4 16.98 4 18.456C4 19.932 4.84 21.3001 6.35201 22.3081C8.03202 23.4361 10.24 24.0001 12.448 24.0001C14.6561 24.0001 16.8641 23.4361 18.5441 22.3081C20.0561 21.2881 20.8961 19.92 20.8961 18.432C20.8841 16.956 20.0561 15.588 18.5441 14.58Z"
        fill="#292D32"
      />
    </svg>
  ),
  introspection: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_891)">
        <path
          d="M17.0365 0H6.97548C2.6053 0 0 2.604 0 6.972V17.016C0 21.396 2.6053 24 6.97548 24H17.0245C21.3947 24 24 21.396 24 17.028V6.972C24.012 2.604 21.4067 0 17.0365 0ZM12.006 19.212C8.20009 19.212 5.10254 16.116 5.10254 12.312C5.10254 10.944 5.49874 9.612 6.26712 8.484C6.54326 8.064 7.10754 7.956 7.51575 8.232C7.92395 8.508 8.04401 9.072 7.75586 9.48C7.20359 10.32 6.90344 11.304 6.90344 12.312C6.90344 15.12 9.19658 17.412 12.006 17.412C14.8154 17.412 17.1085 15.12 17.1085 12.312C17.1085 9.504 14.8154 7.212 12.006 7.212C11.7779 7.212 11.5618 7.236 11.3336 7.26L12.006 7.752C12.4022 8.04 12.4982 8.604 12.1981 9.012C12.018 9.252 11.7419 9.384 11.4657 9.384C11.2856 9.384 11.0935 9.324 10.9374 9.216L8.60829 7.5C8.60829 7.5 8.59628 7.488 8.58428 7.476C8.57227 7.464 8.56027 7.464 8.54826 7.452C8.51224 7.428 8.50024 7.38 8.46422 7.344C8.4282 7.296 8.39218 7.26 8.35616 7.2C8.33215 7.152 8.32015 7.092 8.29613 7.044C8.28413 6.984 8.26012 6.936 8.26012 6.876C8.26012 6.816 8.26012 6.768 8.27212 6.708C8.27212 6.648 8.27212 6.6 8.29613 6.54C8.29613 6.48 8.33215 6.432 8.35616 6.372C8.38018 6.336 8.38018 6.288 8.41619 6.24C8.4282 6.24 8.44021 6.228 8.45221 6.216C8.46422 6.204 8.46422 6.192 8.47622 6.18L10.4812 3.888C10.8054 3.516 11.3817 3.468 11.7539 3.804C12.126 4.128 12.1621 4.704 11.8379 5.076L11.5017 5.46C11.6698 5.448 11.8379 5.424 12.018 5.424C15.8239 5.424 18.9214 8.52 18.9214 12.324C18.9214 16.128 15.8119 19.212 12.006 19.212Z"
          fill="#292D32"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_891">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  staticPage: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_856)">
        <path
          d="M14.1835 18.6242C14.1835 18.4945 14.2686 18.3852 14.3901 18.3487L15.0869 18.1461C15.1801 17.822 15.3057 17.5141 15.4678 17.2224L15.1193 16.5904C15.0586 16.477 15.0788 16.3392 15.168 16.246L16.2375 15.1765C16.3267 15.0873 16.4685 15.0671 16.5819 15.1278L17.2139 15.4763C17.5056 15.3142 17.8176 15.1846 18.1376 15.0954L18.3402 14.3986C18.3767 14.2771 18.4901 14.192 18.6157 14.192H19.1788V3.43555H-0.000427246V18.1785C-0.000427246 19.2724 0.886827 20.1597 1.9807 20.1597H14.1875V18.6242H14.1835ZM11.7891 5.65571H17.457C17.615 5.65571 17.7446 5.78535 17.7446 5.94335C17.7446 6.10136 17.615 6.231 17.457 6.231H11.7891C11.6311 6.231 11.5015 6.10136 11.5015 5.94335C11.5015 5.78535 11.6311 5.65571 11.7891 5.65571ZM11.7891 7.49909H17.457C17.615 7.49909 17.7446 7.62873 17.7446 7.78674C17.7446 7.94474 17.615 8.07438 17.457 8.07438H11.7891C11.6311 8.07438 11.5015 7.94474 11.5015 7.78674C11.5015 7.62873 11.6311 7.49909 11.7891 7.49909ZM11.7891 9.34247H17.457C17.615 9.34247 17.7446 9.47211 17.7446 9.63012C17.7446 9.78812 17.615 9.91777 17.457 9.91777H11.7891C11.6311 9.91777 11.5015 9.78812 11.5015 9.63012C11.5015 9.47211 11.6311 9.34247 11.7891 9.34247ZM1.30412 5.9393C1.30412 5.3559 1.77813 4.88189 2.36153 4.88189H8.43051C9.01391 4.88189 9.48792 5.3559 9.48792 5.9393V9.63417C9.48792 10.2176 9.01391 10.6916 8.43051 10.6916H2.36153C1.77813 10.6916 1.30412 10.2176 1.30412 9.63417V5.9393ZM1.59177 12.0974H15.3462C15.5042 12.0974 15.6339 12.2271 15.6339 12.3851C15.6339 12.5431 15.5042 12.6727 15.3462 12.6727H1.59177C1.43376 12.6727 1.30412 12.5431 1.30412 12.3851C1.30412 12.2271 1.43376 12.0974 1.59177 12.0974ZM1.59177 13.9408H15.3462C15.5042 13.9408 15.6339 14.0704 15.6339 14.2284C15.6339 14.3864 15.5042 14.5161 15.3462 14.5161H1.59177C1.43376 14.5161 1.30412 14.3864 1.30412 14.2284C1.30412 14.0704 1.43376 13.9408 1.59177 13.9408ZM11.0599 18.3406H1.59177C1.43376 18.3406 1.30412 18.211 1.30412 18.0529C1.30412 17.8949 1.43376 17.7653 1.59177 17.7653H11.0558C11.2138 17.7653 11.3435 17.8949 11.3435 18.0529C11.3435 18.211 11.2179 18.3406 11.0599 18.3406ZM11.0599 16.3595H1.59177C1.43376 16.3595 1.30412 16.2298 1.30412 16.0718C1.30412 15.9138 1.43376 15.7842 1.59177 15.7842H11.0558C11.2138 15.7842 11.3435 15.9138 11.3435 16.0718C11.3435 16.2298 11.2179 16.3595 11.0599 16.3595Z"
          fill="#292D32"
        />
        <path
          d="M2.36159 10.1163H8.43057C8.69391 10.1163 8.90863 9.90159 8.90863 9.63825V5.94338C8.90863 5.68004 8.69391 5.46532 8.43057 5.46532H2.36159C2.09825 5.46532 1.88353 5.68004 1.88353 5.94338V9.63825C1.87948 9.89754 2.09825 10.1163 2.36159 10.1163ZM19.3815 17.4615C18.3241 17.4615 17.4611 18.3244 17.4611 19.3818C17.4611 20.4392 18.3241 21.3022 19.3815 21.3022C20.4389 21.3022 21.3018 20.4392 21.3018 19.3818C21.3018 18.3244 20.4389 17.4615 19.3815 17.4615ZM19.187 2.85623V1.98113C19.187 0.891305 18.2997 0 17.2059 0H1.98076C0.890939 0 -0.000366211 0.887254 -0.000366211 1.98113V2.85623H19.187ZM11.068 1.14249H16.9142C17.0722 1.14249 17.2018 1.27214 17.2018 1.43014C17.2018 1.58814 17.0722 1.71779 16.9142 1.71779H11.068C10.91 1.71779 10.7804 1.58814 10.7804 1.43014C10.7804 1.27214 10.91 1.14249 11.068 1.14249ZM5.7445 1.04526C5.82062 1.04526 5.89504 1.06783 5.95833 1.11012C6.02162 1.15241 6.07095 1.21252 6.10008 1.28285C6.12922 1.35318 6.13684 1.43057 6.12199 1.50523C6.10714 1.57989 6.07048 1.64847 6.01665 1.70229C5.96283 1.75612 5.89425 1.79278 5.81959 1.80763C5.74493 1.82248 5.66754 1.81485 5.59721 1.78572C5.52688 1.75659 5.46677 1.70726 5.42448 1.64397C5.38219 1.58067 5.35962 1.50626 5.35962 1.43014C5.36367 1.21542 5.53383 1.04526 5.7445 1.04526ZM4.20092 1.04526C4.25147 1.04526 4.30151 1.05521 4.34821 1.07456C4.39491 1.0939 4.43733 1.12225 4.47307 1.15799C4.50881 1.19373 4.53716 1.23616 4.55651 1.28285C4.57585 1.32955 4.5858 1.3796 4.5858 1.43014C4.5858 1.48068 4.57585 1.53073 4.55651 1.57743C4.53716 1.62412 4.50881 1.66655 4.47307 1.70229C4.43733 1.73803 4.39491 1.76638 4.34821 1.78572C4.30151 1.80507 4.25147 1.81502 4.20092 1.81502C3.9862 1.81502 3.81604 1.64486 3.81604 1.43014C3.82009 1.21542 3.99025 1.04526 4.20092 1.04526ZM2.65734 1.04526C2.70789 1.04526 2.75794 1.05521 2.80463 1.07456C2.85133 1.0939 2.89376 1.12225 2.9295 1.15799C2.96524 1.19373 2.99359 1.23616 3.01293 1.28285C3.03227 1.32955 3.04223 1.3796 3.04223 1.43014C3.04223 1.48068 3.03227 1.53073 3.01293 1.57743C2.99359 1.62412 2.96524 1.66655 2.9295 1.70229C2.89376 1.73803 2.85133 1.76638 2.80463 1.78572C2.75794 1.80507 2.70789 1.81502 2.65734 1.81502C2.44667 1.81502 2.27651 1.64081 2.27651 1.43014C2.27651 1.21542 2.44667 1.04526 2.65734 1.04526Z"
          fill="#292D32"
        />
        <path
          d="M23.1573 18.4418C23.0641 18.061 22.9142 17.7004 22.7157 17.3723C22.6896 17.3291 22.6751 17.2799 22.6737 17.2295C22.6723 17.1791 22.684 17.1292 22.7076 17.0846L23.0317 16.4972L22.266 15.7315L21.6785 16.0556C21.5894 16.1042 21.476 16.1042 21.3909 16.0475C21.0587 15.8449 20.7022 15.6991 20.3213 15.6059C20.2724 15.594 20.2275 15.5694 20.1912 15.5345C20.1549 15.4996 20.1285 15.4557 20.1147 15.4074L19.9243 14.7632H18.8426L18.6522 15.4074C18.6377 15.4554 18.6111 15.499 18.5749 15.5337C18.5387 15.5685 18.4941 15.5934 18.4455 15.6059C18.0647 15.6991 17.7041 15.8449 17.376 16.0475C17.3328 16.0736 17.2836 16.088 17.2332 16.0895C17.1828 16.0909 17.1329 16.0792 17.0883 16.0556L16.5009 15.7315L15.7352 16.4972L16.0593 17.0846C16.1079 17.1738 16.1079 17.2831 16.0512 17.3723C15.8486 17.7045 15.7027 18.061 15.6096 18.4418C15.5853 18.5431 15.5083 18.6201 15.411 18.6485L14.7669 18.8389V19.9206L15.411 20.111C15.5123 20.1394 15.5893 20.2245 15.6136 20.3257L15.6298 20.3906C15.719 20.7309 15.8607 21.0712 16.0552 21.3872C16.1079 21.4763 16.1119 21.5857 16.0633 21.6748L15.7392 22.2623L16.5049 23.028L17.0924 22.7039C17.1856 22.6553 17.2949 22.6553 17.38 22.712C17.7122 22.9146 18.0688 23.0604 18.4496 23.1536C18.5509 23.1779 18.6278 23.2549 18.6562 23.3521L18.8466 23.9963H19.9283L20.1188 23.3521C20.1332 23.3041 20.1598 23.2605 20.196 23.2257C20.2322 23.191 20.2768 23.1661 20.3254 23.1536C20.7062 23.0604 21.0668 22.9146 21.3949 22.712C21.4381 22.6859 21.4873 22.6714 21.5377 22.67C21.5881 22.6686 21.638 22.6803 21.6826 22.7039L22.27 23.028L23.0358 22.2623L22.7116 21.6748C22.687 21.6306 22.6748 21.5805 22.6762 21.5299C22.6777 21.4793 22.6927 21.43 22.7197 21.3872C22.9223 21.055 23.0682 20.6985 23.1613 20.3176C23.1857 20.2163 23.2626 20.1394 23.3599 20.111L24.004 19.9206V18.8389L23.3599 18.6485C23.31 18.6367 23.2645 18.6111 23.2286 18.5745C23.1928 18.5379 23.168 18.4919 23.1573 18.4418ZM19.3814 21.8774C18.0039 21.8774 16.8858 20.7592 16.8858 19.3818C16.8858 18.0043 18.0039 16.8861 19.3814 16.8861C20.7589 16.8861 21.8771 18.0043 21.8771 19.3818C21.8771 20.7592 20.7589 21.8774 19.3814 21.8774Z"
          fill="#292D32"
        />
      </g>
      <defs>
        <clipPath id="clip0_19_856">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  subscription: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_805_53)">
        <path
          d="M10.4547 21.9547C10.4547 21.6775 10.5648 21.4115 10.7609 21.2155C10.957 21.0194 11.2229 20.9093 11.5002 20.9093C13.3611 20.9093 15.1803 20.3574 16.7276 19.3235C18.2749 18.2896 19.4809 16.8201 20.1931 15.1008C20.9053 13.3815 21.0916 11.4897 20.7285 9.66446C20.3655 7.83926 19.4693 6.16271 18.1534 4.84681C16.8375 3.53092 15.161 2.63478 13.3358 2.27173C11.5106 1.90867 9.61873 2.095 7.89943 2.80716C6.18012 3.51932 4.71061 4.72532 3.67672 6.27265C2.64283 7.81998 2.09099 9.63914 2.09099 11.5001C2.08808 13.1203 2.50828 14.7131 3.31 16.121L4.48824 14.9428C4.63445 14.7966 4.82071 14.6971 5.02348 14.6568C5.22625 14.6165 5.43642 14.6372 5.62743 14.7163C5.81844 14.7954 5.9817 14.9294 6.09658 15.1012C6.21146 15.2731 6.2728 15.4752 6.27284 15.682L6.27284 19.8638C6.27284 20.1411 6.16269 20.407 5.96663 20.6031C5.77057 20.7991 5.50465 20.9093 5.22738 20.9093L1.04553 20.9093C0.838785 20.9092 0.636699 20.8479 0.464814 20.733C0.29293 20.6181 0.158965 20.4549 0.0798546 20.2639C0.000744349 20.0728 -0.019959 19.8627 0.020362 19.6599C0.060683 19.4571 0.160218 19.2709 0.306383 19.1247L1.77735 17.6495C0.609557 15.8116 -0.00720744 13.6776 6.304e-05 11.5001C6.31394e-05 9.2256 0.674532 7.00217 1.93818 5.11099C3.20183 3.21981 4.99789 1.74581 7.09926 0.875398C9.20063 0.00498325 11.5129 -0.222757 13.7437 0.220977C15.9745 0.664711 18.0236 1.75999 19.632 3.36831C21.2403 4.97662 22.3355 7.02574 22.7793 9.25654C23.223 11.4873 22.9953 13.7996 22.1249 15.901C21.2544 18.0024 19.7804 19.7984 17.8893 21.0621C15.9981 22.3257 13.7747 23.0002 11.5002 23.0002C11.2229 23.0002 10.957 22.89 10.7609 22.694C10.5648 22.4979 10.4547 22.232 10.4547 21.9547Z"
          fill="#132F21"
        />
        <path
          d="M12.0049 17.25C11.7994 17.25 11.6312 17.1895 11.5004 17.0686C11.3695 16.9557 11.3041 16.8147 11.3041 16.6454V15.5691L11.6265 15.8352C10.9817 15.8191 10.4071 15.7465 9.90249 15.6175C9.40724 15.4885 8.98675 15.3394 8.64101 15.1701C8.47282 15.0814 8.35602 14.9726 8.29061 14.8436C8.2252 14.7065 8.20184 14.5695 8.22052 14.4324C8.23921 14.2954 8.29528 14.1785 8.38872 14.0818C8.49151 13.977 8.61765 13.9125 8.76716 13.8883C8.91667 13.856 9.08954 13.8883 9.28577 13.985C9.54741 14.114 9.88847 14.239 10.309 14.3599C10.7388 14.4727 11.2527 14.5292 11.8508 14.5292C12.318 14.5292 12.6964 14.4808 12.9861 14.3841C13.2758 14.2873 13.486 14.1543 13.6168 13.985C13.757 13.8157 13.8271 13.6222 13.8271 13.4046C13.8271 13.2272 13.7804 13.074 13.6869 12.9451C13.5935 12.808 13.4393 12.6911 13.2244 12.5944C13.0095 12.4896 12.7198 12.4049 12.3554 12.3404L10.8696 12.0623C10.0193 11.9011 9.38388 11.631 8.96339 11.2521C8.5429 10.8732 8.33265 10.3774 8.33265 9.76472C8.33265 9.28908 8.46815 8.86584 8.73913 8.49501C9.01011 8.11611 9.38855 7.81379 9.87446 7.58807C10.3604 7.36234 10.9304 7.22932 11.5845 7.18901L11.3041 7.3704V6.35463C11.3041 6.18533 11.3695 6.04425 11.5004 5.93139C11.6312 5.81046 11.7994 5.75 12.0049 5.75C12.2012 5.75 12.3647 5.81046 12.4955 5.93139C12.6357 6.04425 12.7058 6.18533 12.7058 6.35463V7.3704L12.4114 7.17692C12.8132 7.18498 13.2524 7.25351 13.729 7.38249C14.2149 7.51148 14.6307 7.69287 14.9764 7.92666C15.1166 8.0234 15.21 8.13626 15.2567 8.26525C15.3035 8.38617 15.3081 8.5071 15.2708 8.62802C15.2334 8.74089 15.1633 8.83763 15.0605 8.91824C14.9577 8.99886 14.8269 9.04723 14.6681 9.06335C14.5185 9.07142 14.3457 9.02708 14.1494 8.93034C13.8785 8.79329 13.5748 8.68446 13.2384 8.60384C12.902 8.51516 12.5002 8.47082 12.033 8.47082C11.4349 8.47082 10.9631 8.58771 10.6173 8.8215C10.2809 9.04723 10.1127 9.34551 10.1127 9.71635C10.1127 9.99045 10.2155 10.2121 10.4211 10.3814C10.6267 10.5427 10.9771 10.6717 11.4723 10.7684L13.0001 11.0586C13.8972 11.2279 14.5559 11.498 14.9764 11.8688C15.3969 12.2316 15.6072 12.7113 15.6072 13.3078C15.6072 13.7754 15.4717 14.1906 15.2007 14.5534C14.9297 14.9081 14.5559 15.1943 14.0794 15.4119C13.6122 15.6215 13.0655 15.7546 12.4395 15.811L12.7058 15.557V16.6454C12.7058 16.8147 12.6404 16.9557 12.5095 17.0686C12.3787 17.1895 12.2105 17.25 12.0049 17.25Z"
          fill="#132F21"
        />
      </g>
      <defs>
        <clipPath id="clip0_805_53">
          <rect width={23} height={23} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  apiHistory: (
    <svg
      width={23}
      height={23}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 20.4909C11.8271 20.4994 12.138 20.6352 12.3664 20.8696C12.5948 21.1039 12.7226 21.4182 12.7226 21.7455C12.7226 22.0727 12.5948 22.387 12.3664 22.6213C12.138 22.8557 11.8271 22.9915 11.5 23C11.1729 22.9915 10.862 22.8557 10.6336 22.6213C10.4053 22.387 10.2775 22.0727 10.2775 21.7455C10.2775 21.4182 10.4053 21.1039 10.6336 20.8696C10.862 20.6352 11.1729 20.4994 11.5 20.4909ZM5.64548 20.4909C5.9726 20.4994 6.28348 20.6352 6.51186 20.8696C6.74024 21.1039 6.86805 21.4182 6.86805 21.7455C6.86805 22.0727 6.74024 22.387 6.51186 22.6213C6.28348 22.8557 5.9726 22.9915 5.64548 23C5.31836 22.9915 5.00748 22.8557 4.7791 22.6213C4.55072 22.387 4.42291 22.0727 4.42291 21.7455C4.42291 21.4182 4.55072 21.1039 4.7791 20.8696C5.00748 20.6352 5.31836 20.4994 5.64548 20.4909ZM17.3546 20.4909C17.0275 20.4994 16.7166 20.6352 16.4882 20.8696C16.2598 21.1039 16.132 21.4182 16.132 21.7455C16.132 22.0727 16.2598 22.387 16.4882 22.6213C16.7166 22.8557 17.0275 22.9915 17.3546 23C17.6817 22.9915 17.9926 22.8557 18.221 22.6213C18.4493 22.387 18.5771 22.0727 18.5771 21.7455C18.5771 21.4182 18.4493 21.1039 18.221 20.8696C17.9926 20.6352 17.6817 20.4994 17.3546 20.4909Z"
        fill="#132F21"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0818 14.2182C11.0818 14.1073 11.1259 14.0009 11.2043 13.9225C11.2827 13.8441 11.3891 13.8 11.5 13.8C11.6109 13.8 11.7173 13.8441 11.7957 13.9225C11.8741 14.0009 11.9182 14.1073 11.9182 14.2182V20.4909C11.9134 20.5986 11.8672 20.7003 11.7893 20.7747C11.7114 20.8492 11.6078 20.8908 11.5 20.8908C11.3922 20.8908 11.2886 20.8492 11.2107 20.7747C11.1328 20.7003 11.0867 20.5986 11.0818 20.4909V14.2182ZM7.73639 14.2182C7.73639 14.1073 7.78044 14.0009 7.85887 13.9225C7.93729 13.8441 8.04366 13.8 8.15457 13.8C8.26548 13.8 8.37184 13.8441 8.45027 13.9225C8.52869 14.0009 8.57275 14.1073 8.57275 14.2182V17.1455C8.5728 17.2231 8.55119 17.2993 8.51033 17.3653C8.46948 17.4313 8.41101 17.4847 8.3415 17.5193L6.06366 18.6584V20.4909C6.06366 20.6018 6.0196 20.7082 5.94118 20.7866C5.86275 20.865 5.75639 20.9091 5.64548 20.9091C5.53457 20.9091 5.4282 20.865 5.34978 20.7866C5.27135 20.7082 5.22729 20.6018 5.22729 20.4909V18.4C5.22729 18.2415 5.31679 18.0968 5.45855 18.0261L7.73639 16.887V14.2182ZM14.4273 14.2182C14.4273 14.1073 14.4714 14.0009 14.5498 13.9225C14.6282 13.8441 14.7346 13.8 14.8455 13.8C14.9564 13.8 15.0628 13.8441 15.1412 13.9225C15.2196 14.0009 15.2637 14.1073 15.2637 14.2182V16.887L17.5415 18.0261C17.611 18.0608 17.6695 18.1141 17.7103 18.1802C17.7512 18.2462 17.7728 18.3223 17.7727 18.4V20.4909C17.7727 20.6018 17.7287 20.7082 17.6503 20.7866C17.5718 20.865 17.4655 20.9091 17.3546 20.9091C17.2437 20.9091 17.1373 20.865 17.0589 20.7866C16.9804 20.7082 16.9364 20.6018 16.9364 20.4909V18.6584L14.6586 17.5193C14.589 17.4847 14.5306 17.4313 14.4897 17.3653C14.4489 17.2993 14.4272 17.2231 14.4273 17.1455V14.2182Z"
        fill="#132F21"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0695 5.57353C16.062 5.6419 16.0715 5.71106 16.0971 5.77489C16.1227 5.83872 16.1637 5.89524 16.2164 5.93945C16.2691 5.98366 16.3318 6.01419 16.3992 6.02834C16.4665 6.04249 16.5362 6.03982 16.6023 6.02056C16.9826 5.9102 17.3767 5.8543 17.7727 5.85455C20.0807 5.85455 21.9546 7.72842 21.9546 10.0364C21.9546 12.3443 20.0807 14.2182 17.7727 14.2182H4.80911C2.732 14.2182 1.04547 12.5317 1.04547 10.4545C1.04547 8.37744 2.732 6.69091 4.80911 6.69091C5.12358 6.69091 5.42885 6.72938 5.72074 6.80215C5.7912 6.82001 5.8651 6.81916 5.93512 6.79969C6.00515 6.78022 6.06888 6.7428 6.12 6.69113C6.17112 6.63946 6.20786 6.57534 6.22658 6.5051C6.2453 6.43487 6.24536 6.36097 6.22674 6.29071C6.11806 5.87528 6.06325 5.44759 6.06365 5.01818C6.06365 2.24856 8.31222 0 11.0818 0C13.8515 0 16.1 2.24856 16.1 5.01818C16.1 5.20595 16.0896 5.3912 16.0695 5.57353ZM15.2637 7.94545V12.1273C15.2637 12.2382 15.3077 12.3445 15.3861 12.423C15.4646 12.5014 15.5709 12.5455 15.6818 12.5455C15.7927 12.5455 15.8991 12.5014 15.9775 12.423C16.056 12.3445 16.1 12.2382 16.1 12.1273V7.94545C16.1 7.83455 16.056 7.72818 15.9775 7.64976C15.8991 7.57133 15.7927 7.52727 15.6818 7.52727C15.5709 7.52727 15.4646 7.57133 15.3861 7.64976C15.3077 7.72818 15.2637 7.83455 15.2637 7.94545ZM6.90002 12.1273C6.90002 12.2382 6.94407 12.3445 7.0225 12.423C7.10092 12.5014 7.20729 12.5455 7.3182 12.5455C7.42911 12.5455 7.53547 12.5014 7.6139 12.423C7.69232 12.3445 7.73638 12.2382 7.73638 12.1273V10.8727H9.40911V12.1273C9.40911 12.2382 9.45317 12.3445 9.53159 12.423C9.61001 12.5014 9.71638 12.5455 9.82729 12.5455C9.9382 12.5455 10.0446 12.5014 10.123 12.423C10.2014 12.3445 10.2455 12.2382 10.2455 12.1273V9.61818C10.2455 9.5277 10.2161 9.43966 10.1618 9.36727L8.90729 7.69455C8.86834 7.64261 8.81783 7.60045 8.75976 7.57142C8.70169 7.54239 8.63766 7.52727 8.57274 7.52727C8.50782 7.52727 8.44379 7.54239 8.38573 7.57142C8.32766 7.60045 8.27715 7.64261 8.2382 7.69455L6.98365 9.36727C6.92936 9.43966 6.90002 9.5277 6.90002 9.61818V12.1273ZM11.9182 10.4545H14.0091C14.12 10.4545 14.2264 10.4105 14.3048 10.3321C14.3832 10.2536 14.4273 10.1473 14.4273 10.0364V7.94545C14.4273 7.83455 14.3832 7.72818 14.3048 7.64976C14.2264 7.57133 14.12 7.52727 14.0091 7.52727H11.5C11.3891 7.52727 11.2827 7.57133 11.2043 7.64976C11.1259 7.72818 11.0818 7.83455 11.0818 7.94545V12.1273C11.0818 12.2382 11.1259 12.3445 11.2043 12.423C11.2827 12.5014 11.3891 12.5455 11.5 12.5455C11.6109 12.5455 11.7173 12.5014 11.7957 12.423C11.8741 12.3445 11.9182 12.2382 11.9182 12.1273V10.4545Z"
        fill="#132F21"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9182 8.36363H13.5909V9.61818H11.9182V8.36363ZM9.40912 10.0364H7.73639V9.75743L8.57275 8.64256L9.40912 9.75743V10.0364Z"
        fill="#132F21"
      />
    </svg>
  ),
  datePicker: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_164_9)">
        <path
          d="M8 0C3.58887 0 0 3.58887 0 8C0 12.4111 3.58887 16 8 16C12.4111 16 16 12.4111 16 8C16 3.58887 12.4111 0 8 0ZM8 15C4.14013 15 1 11.8599 1 8C1 4.14013 4.14013 1 8 1C11.8599 1 15 4.14013 15 8C15 11.8599 11.8599 15 8 15ZM11.3535 7.6465C11.4 7.6929 11.4368 7.74801 11.462 7.80866C11.4871 7.86932 11.5 7.93434 11.5 8C11.5 8.06566 11.4871 8.13068 11.462 8.19134C11.4368 8.25199 11.4 8.3071 11.3535 8.3535L8.8535 10.8535C8.75588 10.9511 8.62788 11 8.5 11C8.37212 11 8.24412 10.9511 8.1465 10.8535C8.10004 10.8071 8.06319 10.752 8.03804 10.6913C8.01289 10.6307 7.99995 10.5657 7.99995 10.5C7.99995 10.4343 8.01289 10.3693 8.03804 10.3087C8.06319 10.248 8.10004 10.1929 8.1465 10.1465L9.793 8.5H5C4.72388 8.5 4.5 8.27637 4.5 8C4.5 7.72363 4.72388 7.5 5 7.5H9.793L8.1465 5.8535C7.95112 5.65812 7.95112 5.34175 8.1465 5.1465C8.34188 4.95125 8.65825 4.95113 8.8535 5.1465L11.3535 7.6465Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_164_9">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  noData: (
    <svg
      width={68}
      height={75}
      viewBox="0 0 68 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.05664 12.5V73.2143C7.05664 73.6879 7.24478 74.1421 7.57966 74.477C7.91455 74.8119 8.36875 75 8.84235 75H58.8423C59.3159 75 59.7702 74.8119 60.105 74.477C60.4399 74.1421 60.6281 73.6879 60.6281 73.2143V62.5C60.6281 62.0264 60.4399 61.5722 60.105 61.2373C59.7702 60.9024 59.3159 60.7143 58.8423 60.7143C58.3687 60.7143 57.9145 60.9024 57.5797 61.2373C57.2448 61.5722 57.0566 62.0264 57.0566 62.5V71.4286H10.6281V12.5C10.6281 12.0264 10.4399 11.5722 10.105 11.2373C9.77016 10.9024 9.31596 10.7143 8.84235 10.7143C8.36875 10.7143 7.91455 10.9024 7.57966 11.2373C7.24478 11.5722 7.05664 12.0264 7.05664 12.5ZM60.6281 46.4286V19.6429C60.6274 19.1692 60.44 18.715 60.1066 18.3786L42.2495 0.521429C41.9131 0.188058 41.4588 0.000711203 40.9852 0H14.1995C13.7259 0 13.2717 0.188137 12.9368 0.523024C12.6019 0.85791 12.4138 1.31211 12.4138 1.78571C12.4138 2.25932 12.6019 2.71352 12.9368 3.0484C13.2717 3.38329 13.7259 3.57143 14.1995 3.57143H40.2459L57.0566 20.3821V46.4286C57.0566 46.9022 57.2448 47.3564 57.5797 47.6913C57.9145 48.0261 58.3687 48.2143 58.8423 48.2143C59.3159 48.2143 59.7702 48.0261 60.105 47.6913C60.4399 47.3564 60.6281 46.9022 60.6281 46.4286Z"
        fill="#898989"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.8422 21.4286C59.1958 21.4292 59.5417 21.3248 59.8359 21.1286C60.1302 20.9325 60.3596 20.6533 60.495 20.3267C60.6304 20 60.6658 19.6404 60.5966 19.2936C60.5274 18.9468 60.3568 18.6283 60.1065 18.3786L42.2493 0.521424C41.9989 0.272782 41.6806 0.103737 41.3343 0.0355513C40.9881 -0.0326346 40.6294 0.00308311 40.3034 0.138212C39.9774 0.273341 39.6987 0.501848 39.5022 0.794991C39.3058 1.08813 39.2004 1.43282 39.1993 1.78571V19.6429C39.1993 20.1165 39.3875 20.5707 39.7223 20.9055C40.0572 21.2404 40.5114 21.4286 40.985 21.4286H58.8422ZM54.5315 17.8571H42.7707V6.09642L54.5315 17.8571ZM0.435031 6.62142L64.7207 70.9071C65.0635 71.2027 65.5054 71.3577 65.9577 71.341C66.41 71.3242 66.8392 71.1371 67.1592 70.8171C67.4793 70.497 67.6664 70.0678 67.6831 69.6155C67.6998 69.1632 67.5449 68.7213 67.2493 68.3786L2.9636 4.09285C2.62083 3.79731 2.17896 3.64234 1.72667 3.65904C1.27438 3.67575 0.84515 3.8629 0.525117 4.18294C0.205083 4.50297 0.0179323 4.9322 0.00122328 5.38449C-0.0154857 5.83678 0.139484 6.27865 0.435031 6.62142Z"
        fill="#898989"
      />
    </svg>
  ),
  userAvatar: (
    <svg
      width={32}
      height={32}
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_0_3)">
        <g style={{ mixBlendMode: "luminosity" }}>
          <path
            d="M40 20.0195C40 31.0708 31.0456 40.0283 19.9983 40.0283C8.95098 40.0283 0 31.0708 0 20.0195C0 8.96828 8.95436 0.0107422 19.9983 0.0107422C31.0422 0.0107422 40 8.96828 40 20.0195Z"
            fill="white"
          />
        </g>
        <mask
          id="mask0_0_3"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x={10}
          y={10}
          width={20}
          height={20}
        >
          <path d="M30 10H10V30H30V10Z" fill="white" />
        </mask>
        <g mask="url(#mask0_0_3)">
          <path
            d="M20.0014 20.3855C22.8586 20.3855 25.1942 18.0499 25.1942 15.1928C25.1942 12.3356 22.8586 10 20.0014 10C17.1442 10 14.8087 12.3356 14.8087 15.1928C14.8087 18.0499 17.1443 20.3855 20.0014 20.3855ZM28.913 24.5352C28.7769 24.195 28.5955 23.8776 28.3915 23.5828C27.3484 22.0408 25.7384 21.0204 23.9244 20.771C23.6976 20.7483 23.4482 20.7936 23.2668 20.9297C22.3144 21.6326 21.1806 21.9954 20.0014 21.9954C18.8223 21.9954 17.6885 21.6326 16.7361 20.9297C16.5547 20.7936 16.3053 20.7256 16.0785 20.771C14.2645 21.0204 12.6318 22.0408 11.6114 23.5828C11.4073 23.8776 11.2259 24.2177 11.0899 24.5352C11.0219 24.6712 11.0445 24.8299 11.1126 24.966C11.294 25.2835 11.5207 25.601 11.7248 25.873C12.0422 26.3039 12.3824 26.6894 12.7679 27.0522C13.0853 27.3696 13.4481 27.6644 13.811 27.9592C15.6024 29.2971 17.7566 30 19.9788 30C22.201 30 24.3552 29.297 26.1466 27.9592C26.5094 27.6871 26.8722 27.3696 27.1897 27.0522C27.5525 26.6894 27.9153 26.3039 28.2328 25.873C28.4595 25.5783 28.6636 25.2835 28.845 24.966C28.9583 24.8299 28.981 24.6712 28.913 24.5352Z"
            fill="#0E344B"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_0_3">
          <rect width={40} height={41} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  passwordTooltip: (
    <svg
      width={13}
      height={13}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_335_10)">
        <path
          d="M15.5 8C15.5 12.1422 12.1422 15.5 8 15.5C3.85786 15.5 0.5 12.1422 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1422 0.5 15.5 3.85786 15.5 8Z"
          stroke="#FF0000"
        />
        <path
          d="M7.99978 5.3316C8.61343 5.3316 9.11089 4.83413 9.11089 4.22048C9.11089 3.60683 8.61343 3.10938 7.99978 3.10938C7.38613 3.10938 6.88867 3.60683 6.88867 4.22048C6.88867 4.83413 7.38613 5.3316 7.99978 5.3316Z"
          fill="#FF0000"
        />
        <path
          d="M7.11133 6.66406H8.88911V12.8863H7.11133V6.66406Z"
          fill="#FF0000"
        />
      </g>
      <defs>
        <clipPath id="clip0_335_10">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  totalApiCalls: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={15} cy={15} r={15} fill="#E58344" />
      <g clipPath="url(#clip0_879_2845)">
        <path
          d="M16.871 18.1266L16.1343 17.9178C16.0386 17.5437 15.8907 17.1898 15.6992 16.8679L16.0734 16.2008C16.1749 16.0209 16.143 15.7918 15.9951 15.6439L15.4643 15.1131C15.3164 14.9652 15.0901 14.9362 14.9103 15.0377L14.2403 15.4118C13.9155 15.2204 13.5645 15.0696 13.1904 14.9739L12.9844 14.2401C12.9293 14.037 12.7437 13.8978 12.5378 13.8978H11.7866C11.5777 13.8978 11.395 14.037 11.3399 14.2401L11.134 14.9739C10.7627 15.0696 10.406 15.2175 10.084 15.4118L9.41402 15.0377C9.23419 14.9362 9.00506 14.9681 8.86004 15.1131L8.32926 15.6439C8.18134 15.7918 8.14943 16.0209 8.25095 16.2008L8.6251 16.8679C8.43368 17.1927 8.28575 17.5437 8.19004 17.9178L7.45333 18.1266C7.2503 18.1817 7.11108 18.3674 7.11108 18.5733V19.3216C7.11108 19.5304 7.2503 19.7132 7.45333 19.7683L8.18714 19.9742C8.28285 20.3484 8.43077 20.7051 8.6251 21.0271L8.25095 21.6942C8.14943 21.874 8.18134 22.1031 8.32926 22.251L8.86004 22.7818C9.00506 22.9297 9.23419 22.9587 9.41402 22.8572L10.084 22.4831C10.4089 22.6745 10.7627 22.8253 11.134 22.921L11.3399 23.6548C11.395 23.8579 11.5806 23.9971 11.7866 23.9971H12.5378C12.7466 23.9971 12.9293 23.8579 12.9844 23.6548L13.1904 22.921C13.5645 22.8253 13.9184 22.6774 14.2403 22.4831L14.9103 22.8572C15.0901 22.9587 15.3193 22.9268 15.4643 22.7818L15.9951 22.251C16.143 22.1031 16.1749 21.874 16.0734 21.6942L15.6992 21.0271C15.8907 20.7022 16.0415 20.3484 16.1372 19.9742L16.871 19.7683C17.074 19.7132 17.2132 19.5275 17.2132 19.3216V18.5733C17.2103 18.3674 17.074 18.1846 16.871 18.1266ZM12.1578 21.1257C10.957 21.1257 9.9854 20.1511 9.9854 18.9504C9.9854 17.7496 10.957 16.775 12.1578 16.775C13.3615 16.775 14.3331 17.7496 14.3331 18.9504C14.3331 20.1511 13.3615 21.1257 12.1578 21.1257ZM23.5304 20.3861L23.075 20.2584C23.017 20.0293 22.9271 19.8118 22.8082 19.6117L23.0373 19.1998C23.1011 19.0896 23.0808 18.9475 22.988 18.8575L22.6631 18.5327C22.619 18.4886 22.5616 18.4602 22.4998 18.4518C22.438 18.4435 22.3752 18.4556 22.3209 18.4863L21.909 18.7154C21.7089 18.5965 21.4943 18.5066 21.2622 18.4457L21.1346 17.9932C21.1179 17.9331 21.0818 17.8801 21.0321 17.8423C20.9823 17.8046 20.9215 17.7843 20.8591 17.7844H20.395C20.2674 17.7844 20.1543 17.8685 20.1195 17.9932L19.9918 18.4457C19.7627 18.5037 19.5452 18.5965 19.3451 18.7154L18.9332 18.4863C18.8789 18.4556 18.8161 18.4435 18.7543 18.4518C18.6924 18.4602 18.6351 18.4886 18.5909 18.5327L18.2661 18.8575C18.1733 18.9504 18.1559 19.0896 18.2168 19.1998L18.4488 19.6117C18.3287 19.813 18.2388 20.031 18.182 20.2584L17.7266 20.3861C17.6019 20.4209 17.5178 20.534 17.5178 20.6616V21.1228C17.5178 21.2504 17.6019 21.3635 17.7266 21.3983L18.1791 21.5259C18.2371 21.7551 18.3299 21.9755 18.4488 22.1756L18.2168 22.5875C18.153 22.6977 18.1733 22.8398 18.2661 22.9297L18.5909 23.2546C18.6809 23.3445 18.8201 23.3648 18.9332 23.301L19.3451 23.069C19.5452 23.1879 19.7627 23.2778 19.9918 23.3387L20.1195 23.7912C20.1543 23.9159 20.2674 24 20.395 24H20.8591C20.9867 24 21.0998 23.9159 21.1346 23.7912L21.2622 23.3387C21.4914 23.2807 21.7089 23.1879 21.909 23.069L22.3209 23.301C22.4311 23.3648 22.5732 23.3445 22.6631 23.2546L22.988 22.9297C23.0808 22.8369 23.0982 22.6977 23.0373 22.5875L22.8082 22.1756C22.9271 21.9755 23.017 21.758 23.0779 21.5259L23.5304 21.3983C23.6551 21.3635 23.7392 21.2504 23.7392 21.1228V20.6616C23.7392 20.534 23.6551 20.4209 23.5304 20.3861ZM20.6299 22.2307C19.8903 22.2307 19.2928 21.6303 19.2928 20.8936C19.2928 20.1569 19.8903 19.5565 20.6299 19.5565C21.3695 19.5565 21.967 20.1569 21.967 20.8936C21.967 21.6303 21.3695 22.2307 20.6299 22.2307Z"
          fill="white"
        />
        <path
          d="M7.88837 16.7141L7.75495 16.4763C7.53162 16.079 7.60123 15.5714 7.92607 15.2465L8.45685 14.7158C8.55196 14.6205 8.66502 14.545 8.78948 14.4938C8.91395 14.4425 9.04734 14.4164 9.18195 14.417C9.35888 14.417 9.53291 14.4634 9.68373 14.5475L10.0811 14.7709C10.2725 14.6752 10.4697 14.5939 10.6699 14.5272L10.7917 14.0922C10.852 13.8762 10.9813 13.6859 11.1599 13.5502C11.3385 13.4146 11.5565 13.3411 11.7807 13.341H12.5319C12.9902 13.341 13.3992 13.6513 13.521 14.0922L13.6428 14.5272C13.8429 14.5939 14.0402 14.6781 14.2316 14.7738L14.6318 14.5504C14.7827 14.4663 14.9567 14.4199 15.1336 14.4199C15.4092 14.4199 15.6673 14.5272 15.8587 14.7187L16.3895 15.2494C16.5482 15.4083 16.6508 15.6147 16.6816 15.8371C16.7125 16.0595 16.67 16.286 16.5606 16.4821L16.3373 16.8795C16.3634 16.9288 16.3837 16.981 16.4069 17.0303H20.7546C22.1149 17.0303 23.2171 15.9281 23.2171 14.5707C23.2174 13.9503 22.9832 13.3528 22.5615 12.8977C22.1399 12.4427 21.5618 12.1638 20.9432 12.117C20.6212 12.1431 20.3022 12.2388 20.0237 12.3983C19.9802 12.4244 19.9309 12.436 19.8845 12.436C19.8349 12.4365 19.786 12.4235 19.7431 12.3985C19.7002 12.3735 19.6649 12.3374 19.6409 12.2939C19.6222 12.262 19.6101 12.2267 19.6053 12.1901C19.6004 12.1534 19.6029 12.1162 19.6127 12.0806C19.6224 12.0449 19.6391 12.0115 19.6619 11.9824C19.6847 11.9533 19.713 11.9291 19.7453 11.9111C20.1513 11.6761 20.6212 11.5572 21.0882 11.5543C21.1056 11.4383 21.1172 11.3194 21.1172 11.2005C21.1172 9.82565 20.0034 8.71189 18.6315 8.71189C18.0949 8.71189 17.5961 8.88302 17.19 9.17306C16.8565 7.3632 15.2728 6 13.3731 6C11.2297 6 9.4923 7.73735 9.4923 9.88076C9.4923 10.1099 9.5126 10.3361 9.55031 10.5566C9.88676 10.6465 10.2058 10.7857 10.4987 10.98C10.6293 11.067 10.6641 11.2411 10.5771 11.3687C10.5219 11.4499 10.4349 11.4934 10.3421 11.4934C10.2899 11.4934 10.2348 11.4789 10.1855 11.447C10.0347 11.3455 9.87515 11.2643 9.70983 11.1976C9.54161 11.1685 9.37048 11.1511 9.19356 11.1511C7.56932 11.1511 6.25543 12.4679 6.25543 14.0893C6.26123 15.2378 6.92253 16.2327 7.88837 16.7141ZM17.1378 10.1041C16.9812 10.1041 16.8565 9.97937 16.8565 9.82275C16.8565 9.66613 16.9812 9.54141 17.1378 9.54141H18.0862C18.2429 9.54141 18.3676 9.66613 18.3676 9.82275C18.3676 9.97937 18.2429 10.1041 18.0862 10.1041H17.8948V12.2475H18.0862C18.2429 12.2475 18.3676 12.3722 18.3676 12.5288C18.3676 12.6855 18.2429 12.8102 18.0862 12.8102H17.1378C16.9812 12.8102 16.8565 12.6855 16.8565 12.5288C16.8565 12.3722 16.9812 12.2475 17.1378 12.2475H17.3292V10.1041H17.1378ZM14.4578 9.89236C14.4578 9.66033 14.6463 9.4718 14.8784 9.4718H15.7398C16.3315 9.4718 16.8101 9.95327 16.8101 10.5421C16.8101 11.1308 16.3286 11.6123 15.7398 11.6123H15.0205V12.5259C15.0205 12.6826 14.8958 12.8073 14.7392 12.8073C14.5825 12.8073 14.4578 12.6826 14.4578 12.5259V9.89236ZM11.4936 10.6494C11.4936 9.99968 12.0215 9.4747 12.6683 9.4747C13.3151 9.4747 13.8429 10.0026 13.8429 10.6494V12.5288C13.8429 12.6855 13.7182 12.8102 13.5616 12.8102C13.405 12.8102 13.2802 12.6855 13.2802 12.5288V11.6152H12.0534V12.5288C12.0534 12.6855 11.9287 12.8102 11.772 12.8102C11.6154 12.8102 11.4907 12.6855 11.4907 12.5288V10.6494H11.4936Z"
          fill="white"
        />
        <path
          d="M16.2473 10.545C16.2473 10.2636 16.0182 10.0374 15.7398 10.0374H15.0205V11.0525H15.7398C16.0211 11.0525 16.2473 10.8234 16.2473 10.545ZM13.2831 10.6494C13.2831 10.4871 13.2186 10.3314 13.1039 10.2166C12.9891 10.1019 12.8334 10.0374 12.6711 10.0374C12.5088 10.0374 12.3532 10.1019 12.2384 10.2166C12.1236 10.3314 12.0591 10.4871 12.0591 10.6494V11.0525H13.286V10.6494H13.2831Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_879_2845">
          <rect
            width={18}
            height={18}
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  successCalls: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={15} cy={15} r={15} fill="#46C064" />
      <g clipPath="url(#clip0_879_2874)">
        <path
          d="M12.9474 24C12.0767 24 11.3684 23.2917 11.3684 22.421C11.3684 21.5504 12.0767 20.8421 12.9474 20.8421C13.818 20.8421 14.5263 21.5504 14.5263 22.421C14.5263 23.2917 13.818 24 12.9474 24ZM12.9474 21.7895C12.599 21.7895 12.3158 22.0727 12.3158 22.421C12.3158 22.7694 12.599 23.0526 12.9474 23.0526C13.2957 23.0526 13.5789 22.7694 13.5789 22.421C13.5789 22.0727 13.2957 21.7895 12.9474 21.7895ZM17.0526 24C16.182 24 15.4737 23.2917 15.4737 22.421C15.4737 21.5504 16.182 20.8421 17.0526 20.8421C17.9233 20.8421 18.6316 21.5504 18.6316 22.421C18.6316 23.2917 17.9233 24 17.0526 24ZM17.0526 21.7895C16.7043 21.7895 16.421 22.0727 16.421 22.421C16.421 22.7694 16.7043 23.0526 17.0526 23.0526C17.4009 23.0526 17.6842 22.7694 17.6842 22.421C17.6842 22.0727 17.4009 21.7895 17.0526 21.7895Z"
          fill="white"
        />
        <path
          d="M12.9474 21.7895C12.8217 21.7895 12.7013 21.7396 12.6124 21.6507C12.5236 21.5619 12.4737 21.4414 12.4737 21.3158V19.7368C12.4737 19.6112 12.5236 19.4907 12.6124 19.4019C12.7013 19.3131 12.8217 19.2632 12.9474 19.2632C13.073 19.2632 13.1935 19.3131 13.2823 19.4019C13.3711 19.4907 13.4211 19.6112 13.4211 19.7368V21.3158C13.4211 21.4414 13.3711 21.5619 13.2823 21.6507C13.1935 21.7396 13.073 21.7895 12.9474 21.7895ZM17.0526 21.7895C16.927 21.7895 16.8065 21.7396 16.7177 21.6507C16.6289 21.5619 16.5789 21.4414 16.5789 21.3158V19.7368C16.5789 19.6112 16.6289 19.4907 16.7177 19.4019C16.8065 19.3131 16.927 19.2632 17.0526 19.2632C17.1783 19.2632 17.2987 19.3131 17.3876 19.4019C17.4764 19.4907 17.5263 19.6112 17.5263 19.7368V21.3158C17.5263 21.4414 17.4764 21.5619 17.3876 21.6507C17.2987 21.7396 17.1783 21.7895 17.0526 21.7895ZM11.64 17.6842H10.1053C7.84168 17.6842 6 15.8425 6 13.5789C6 11.3154 7.84168 9.47368 10.1053 9.47368C10.1735 9.47368 10.2429 9.47589 10.3137 9.48C10.9301 7.44 12.8368 6 15 6C17.1632 6 19.0696 7.44 19.6863 9.48C19.7571 9.47589 19.8265 9.47368 19.8947 9.47368C22.1583 9.47368 24 11.3154 24 13.5789C24 15.6357 22.4649 17.3852 20.4291 17.6488C20.3045 17.6649 20.1786 17.6309 20.0791 17.5541C19.9797 17.4774 19.9148 17.3643 19.8987 17.2397C19.8826 17.1152 19.9167 16.9893 19.9934 16.8898C20.0701 16.7904 20.1832 16.7254 20.3078 16.7094C21.8725 16.5066 23.0526 15.1611 23.0526 13.5789C23.0526 11.8377 21.636 10.4211 19.8947 10.4211C19.7432 10.4211 19.5821 10.4346 19.4027 10.4631C19.2826 10.4816 19.16 10.4534 19.0601 10.3842C18.9602 10.315 18.8907 10.21 18.8659 10.0911C18.4873 8.26958 16.8616 6.94737 15 6.94737C13.1384 6.94737 11.5124 8.26958 11.1344 10.0911C11.1098 10.2102 11.0402 10.3152 10.9402 10.3845C10.8402 10.4537 10.7174 10.4819 10.5973 10.4631C10.4346 10.4361 10.2701 10.4221 10.1053 10.4211C8.364 10.4211 6.94737 11.8377 6.94737 13.5789C6.94737 15.3202 8.364 16.7368 10.1053 16.7368H11.64C11.7656 16.7368 11.8861 16.7867 11.9749 16.8756C12.0638 16.9644 12.1137 17.0849 12.1137 17.2105C12.1137 17.3362 12.0638 17.4566 11.9749 17.5455C11.8861 17.6343 11.7656 17.6842 11.64 17.6842Z"
          fill="white"
        />
        <path
          d="M8.84209 21.1579C8.71646 21.1579 8.59598 21.108 8.50715 21.0191C8.41831 20.9303 8.36841 20.8098 8.36841 20.6842V16.9831C8.36841 16.8575 8.41831 16.737 8.50715 16.6482C8.59598 16.5594 8.71646 16.5095 8.84209 16.5095C8.96772 16.5095 9.0882 16.5594 9.17704 16.6482C9.26587 16.737 9.31578 16.8575 9.31578 16.9831V20.6842C9.31578 20.8098 9.26587 20.9303 9.17704 21.0191C9.0882 21.108 8.96772 21.1579 8.84209 21.1579Z"
          fill="white"
        />
        <path
          d="M8.84213 23.3684C7.9715 23.3684 7.26318 22.6601 7.26318 21.7895C7.26318 20.9188 7.9715 20.2105 8.84213 20.2105C9.71276 20.2105 10.4211 20.9188 10.4211 21.7895C10.4211 22.6601 9.71276 23.3684 8.84213 23.3684ZM8.84213 21.1579C8.49382 21.1579 8.21055 21.4411 8.21055 21.7895C8.21055 22.1378 8.49382 22.421 8.84213 22.421C9.19045 22.421 9.47371 22.1378 9.47371 21.7895C9.47371 21.4411 9.19045 21.1579 8.84213 21.1579ZM21.1579 21.1579C21.0323 21.1579 20.9118 21.108 20.823 21.0191C20.7341 20.9303 20.6842 20.8098 20.6842 20.6842V16.9831C20.6842 16.8575 20.7341 16.737 20.823 16.6482C20.9118 16.5594 21.0323 16.5095 21.1579 16.5095C21.2836 16.5095 21.404 16.5594 21.4929 16.6482C21.5817 16.737 21.6316 16.8575 21.6316 16.9831V20.6842C21.6316 20.8098 21.5817 20.9303 21.4929 21.0191C21.404 21.108 21.2836 21.1579 21.1579 21.1579Z"
          fill="white"
        />
        <path
          d="M21.1579 23.3684C20.2872 23.3684 19.5789 22.6601 19.5789 21.7895C19.5789 20.9188 20.2872 20.2105 21.1579 20.2105C22.0285 20.2105 22.7368 20.9188 22.7368 21.7895C22.7368 22.6601 22.0285 23.3684 21.1579 23.3684ZM21.1579 21.1579C20.8096 21.1579 20.5263 21.4412 20.5263 21.7895C20.5263 22.1378 20.8096 22.4211 21.1579 22.4211C21.5062 22.4211 21.7895 22.1378 21.7895 21.7895C21.7895 21.4412 21.5062 21.1579 21.1579 21.1579ZM19.1618 16.1716L19.1071 16.1021C18.9015 15.8399 18.7896 15.5164 18.7894 15.1832V15.1822C18.7895 14.8491 18.9011 14.5256 19.1065 14.2633L19.1611 14.1941C19.2811 14.0422 19.2969 13.8319 19.1997 13.6636L18.4149 12.305C18.368 12.2229 18.2973 12.1567 18.2122 12.1153C18.1271 12.0739 18.0314 12.0591 17.9378 12.0729L17.8493 12.0856C17.5183 12.132 17.1812 12.0672 16.8909 11.9015C16.6055 11.7363 16.3835 11.4804 16.2603 11.1745L16.2243 11.0842C16.1892 10.9962 16.1285 10.9208 16.0501 10.8677C15.9717 10.8145 15.8791 10.7861 15.7844 10.7861H14.2156C14.1208 10.7861 14.0283 10.8145 13.9499 10.8677C13.8715 10.9208 13.8108 10.9962 13.7757 11.0842L13.7397 11.1742C13.6166 11.4803 13.3946 11.7363 13.109 11.9015C12.8189 12.0677 12.4817 12.1325 12.1506 12.0856L12.0622 12.0729C11.9685 12.0591 11.8729 12.0738 11.7877 12.1152C11.7026 12.1566 11.6319 12.2228 11.585 12.305L10.8 13.6639C10.7526 13.7459 10.731 13.8402 10.7378 13.9347C10.7446 14.0292 10.7796 14.1194 10.8382 14.1938L10.8726 14.2374C11.0907 14.5154 11.2096 14.8583 11.2105 15.2116C11.2104 15.5268 11.1046 15.8328 10.9099 16.0806L10.8379 16.1722C10.7794 16.2466 10.7446 16.3367 10.7379 16.4311C10.7312 16.5254 10.7529 16.6196 10.8003 16.7015L11.585 18.06C11.632 18.1422 11.7026 18.2083 11.7878 18.2497C11.8729 18.2911 11.9685 18.3059 12.0622 18.2921L12.1528 18.2792C12.4822 18.2326 12.8178 18.2971 13.1065 18.4623C13.3934 18.628 13.6165 18.8851 13.7403 19.1924L13.7753 19.2808C13.8105 19.3689 13.8712 19.4443 13.9497 19.4975C14.0282 19.5506 14.1208 19.579 14.2156 19.5789H15.7844C15.9783 19.5789 16.1523 19.4612 16.2243 19.2812L16.259 19.1949C16.383 18.8863 16.6066 18.6281 16.8944 18.4614C17.1823 18.2969 17.5166 18.2327 17.8449 18.2788L17.9374 18.2921C18.0312 18.3061 18.1269 18.2915 18.2122 18.2501C18.2974 18.2086 18.3681 18.1424 18.4149 18.06L19.1997 16.7015C19.247 16.6195 19.2687 16.5252 19.262 16.4307C19.2552 16.3363 19.2203 16.246 19.1618 16.1716ZM17.1451 14.2775L14.7047 16.7526C14.6572 16.8008 14.6 16.8382 14.5368 16.8623C14.4737 16.8865 14.4061 16.8969 14.3386 16.8927C14.2711 16.8886 14.2053 16.8701 14.1456 16.8384C14.0858 16.8067 14.0336 16.7626 13.9923 16.709L12.8169 15.1813C12.7782 15.132 12.7496 15.0756 12.7329 15.0153C12.7161 14.955 12.7114 14.8919 12.7192 14.8298C12.7269 14.7676 12.7469 14.7077 12.778 14.6533C12.8091 14.5989 12.8507 14.5513 12.9003 14.5131C12.9499 14.4749 13.0066 14.4469 13.0671 14.4307C13.1276 14.4146 13.1907 14.4106 13.2528 14.419C13.3148 14.4274 13.3746 14.448 13.4286 14.4797C13.4826 14.5113 13.5299 14.5534 13.5676 14.6034L14.4117 15.7007L16.4706 13.6124C16.514 13.567 16.566 13.5306 16.6236 13.5055C16.6812 13.4803 16.7432 13.4669 16.806 13.466C16.8689 13.465 16.9313 13.4766 16.9896 13.5C17.0479 13.5234 17.101 13.5582 17.1457 13.6023C17.1905 13.6464 17.226 13.699 17.2502 13.757C17.2744 13.8149 17.2869 13.8772 17.2868 13.94C17.2868 14.0028 17.2742 14.065 17.2499 14.123C17.2256 14.1809 17.19 14.2334 17.1451 14.2775Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_879_2874">
          <rect
            width={18}
            height={18}
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  failedCalls: (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={15} cy={15} r={15} fill="#E20E00" />
      <g clipPath="url(#clip0_879_2873)">
        <path
          d="M12.9474 24C12.0767 24 11.3684 23.2917 11.3684 22.421C11.3684 21.5504 12.0767 20.8421 12.9474 20.8421C13.818 20.8421 14.5263 21.5504 14.5263 22.421C14.5263 23.2917 13.818 24 12.9474 24ZM12.9474 21.7895C12.599 21.7895 12.3158 22.0727 12.3158 22.421C12.3158 22.7694 12.599 23.0526 12.9474 23.0526C13.2957 23.0526 13.5789 22.7694 13.5789 22.421C13.5789 22.0727 13.2957 21.7895 12.9474 21.7895ZM17.0526 24C16.182 24 15.4737 23.2917 15.4737 22.421C15.4737 21.5504 16.182 20.8421 17.0526 20.8421C17.9233 20.8421 18.6316 21.5504 18.6316 22.421C18.6316 23.2917 17.9233 24 17.0526 24ZM17.0526 21.7895C16.7043 21.7895 16.421 22.0727 16.421 22.421C16.421 22.7694 16.7043 23.0526 17.0526 23.0526C17.4009 23.0526 17.6842 22.7694 17.6842 22.421C17.6842 22.0727 17.4009 21.7895 17.0526 21.7895Z"
          fill="white"
        />
        <path
          d="M12.9474 21.7895C12.8217 21.7895 12.7013 21.7396 12.6124 21.6507C12.5236 21.5619 12.4737 21.4414 12.4737 21.3158V19.7368C12.4737 19.6112 12.5236 19.4907 12.6124 19.4019C12.7013 19.3131 12.8217 19.2632 12.9474 19.2632C13.073 19.2632 13.1935 19.3131 13.2823 19.4019C13.3711 19.4907 13.4211 19.6112 13.4211 19.7368V21.3158C13.4211 21.4414 13.3711 21.5619 13.2823 21.6507C13.1935 21.7396 13.073 21.7895 12.9474 21.7895ZM17.0526 21.7895C16.927 21.7895 16.8065 21.7396 16.7177 21.6507C16.6289 21.5619 16.5789 21.4414 16.5789 21.3158V19.7368C16.5789 19.6112 16.6289 19.4907 16.7177 19.4019C16.8065 19.3131 16.927 19.2632 17.0526 19.2632C17.1783 19.2632 17.2987 19.3131 17.3876 19.4019C17.4764 19.4907 17.5263 19.6112 17.5263 19.7368V21.3158C17.5263 21.4414 17.4764 21.5619 17.3876 21.6507C17.2987 21.7396 17.1783 21.7895 17.0526 21.7895ZM11.64 17.6842H10.1053C7.84168 17.6842 6 15.8425 6 13.5789C6 11.3154 7.84168 9.47368 10.1053 9.47368C10.1735 9.47368 10.2429 9.47589 10.3137 9.48C10.9301 7.44 12.8368 6 15 6C17.1632 6 19.0696 7.44 19.6863 9.48C19.7571 9.47589 19.8265 9.47368 19.8947 9.47368C22.1583 9.47368 24 11.3154 24 13.5789C24 15.6357 22.4649 17.3852 20.4291 17.6488C20.3045 17.6649 20.1786 17.6309 20.0791 17.5541C19.9797 17.4774 19.9148 17.3643 19.8987 17.2397C19.8826 17.1152 19.9167 16.9893 19.9934 16.8898C20.0701 16.7904 20.1832 16.7254 20.3078 16.7094C21.8725 16.5066 23.0526 15.1611 23.0526 13.5789C23.0526 11.8377 21.636 10.4211 19.8947 10.4211C19.7432 10.4211 19.5821 10.4346 19.4027 10.4631C19.2826 10.4816 19.16 10.4534 19.0601 10.3842C18.9602 10.315 18.8907 10.21 18.8659 10.0911C18.4873 8.26958 16.8616 6.94737 15 6.94737C13.1384 6.94737 11.5124 8.26958 11.1344 10.0911C11.1098 10.2102 11.0402 10.3152 10.9402 10.3845C10.8402 10.4537 10.7174 10.4819 10.5973 10.4631C10.4346 10.4361 10.2701 10.4221 10.1053 10.4211C8.364 10.4211 6.94737 11.8377 6.94737 13.5789C6.94737 15.3202 8.364 16.7368 10.1053 16.7368H11.64C11.7656 16.7368 11.8861 16.7867 11.9749 16.8756C12.0638 16.9644 12.1137 17.0849 12.1137 17.2105C12.1137 17.3362 12.0638 17.4566 11.9749 17.5455C11.8861 17.6343 11.7656 17.6842 11.64 17.6842Z"
          fill="white"
        />
        <path
          d="M8.84209 21.1579C8.71646 21.1579 8.59598 21.108 8.50715 21.0191C8.41831 20.9303 8.36841 20.8098 8.36841 20.6842V16.9831C8.36841 16.8575 8.41831 16.737 8.50715 16.6482C8.59598 16.5594 8.71646 16.5095 8.84209 16.5095C8.96772 16.5095 9.0882 16.5594 9.17704 16.6482C9.26587 16.737 9.31578 16.8575 9.31578 16.9831V20.6842C9.31578 20.8098 9.26587 20.9303 9.17704 21.0191C9.0882 21.108 8.96772 21.1579 8.84209 21.1579Z"
          fill="white"
        />
        <path
          d="M8.84213 23.3684C7.9715 23.3684 7.26318 22.6601 7.26318 21.7895C7.26318 20.9188 7.9715 20.2105 8.84213 20.2105C9.71276 20.2105 10.4211 20.9188 10.4211 21.7895C10.4211 22.6601 9.71276 23.3684 8.84213 23.3684ZM8.84213 21.1579C8.49382 21.1579 8.21055 21.4411 8.21055 21.7895C8.21055 22.1378 8.49382 22.421 8.84213 22.421C9.19045 22.421 9.47371 22.1378 9.47371 21.7895C9.47371 21.4411 9.19045 21.1579 8.84213 21.1579ZM21.1579 21.1579C21.0323 21.1579 20.9118 21.108 20.823 21.0191C20.7341 20.9303 20.6842 20.8098 20.6842 20.6842V16.9831C20.6842 16.8575 20.7341 16.737 20.823 16.6482C20.9118 16.5594 21.0323 16.5095 21.1579 16.5095C21.2836 16.5095 21.404 16.5594 21.4929 16.6482C21.5817 16.737 21.6316 16.8575 21.6316 16.9831V20.6842C21.6316 20.8098 21.5817 20.9303 21.4929 21.0191C21.404 21.108 21.2836 21.1579 21.1579 21.1579Z"
          fill="white"
        />
        <path
          d="M21.1579 23.3685C20.2872 23.3685 19.5789 22.6601 19.5789 21.7895C19.5789 20.9189 20.2872 20.2106 21.1579 20.2106C22.0285 20.2106 22.7368 20.9189 22.7368 21.7895C22.7368 22.6601 22.0285 23.3685 21.1579 23.3685ZM21.1579 21.1579C20.8096 21.1579 20.5263 21.4412 20.5263 21.7895C20.5263 22.1378 20.8096 22.4211 21.1579 22.4211C21.5062 22.4211 21.7895 22.1378 21.7895 21.7895C21.7895 21.4412 21.5062 21.1579 21.1579 21.1579ZM19.1618 16.1716L19.1071 16.1021C18.9015 15.8399 18.7896 15.5164 18.7894 15.1832C18.7895 14.8501 18.9011 14.5256 19.1065 14.2633L19.1611 14.1941C19.2811 14.0422 19.2969 13.8319 19.1997 13.6636L18.4149 12.3051C18.368 12.2229 18.2973 12.1568 18.2122 12.1154C18.1271 12.0739 18.0314 12.0592 17.9378 12.073L17.8493 12.0856C17.5183 12.132 17.1812 12.0672 16.8909 11.9015C16.6055 11.7364 16.3835 11.4805 16.2603 11.1746L16.2243 11.0842C16.1892 10.9963 16.1285 10.9208 16.0501 10.8677C15.9717 10.8146 15.8791 10.7861 15.7844 10.7861H14.2156C14.1208 10.7861 14.0283 10.8146 13.9499 10.8677C13.8715 10.9208 13.8108 10.9963 13.7757 11.0842L13.7397 11.1742C13.6166 11.4803 13.3946 11.7363 13.109 11.9015C12.8189 12.0677 12.4817 12.1325 12.1506 12.0856L12.0622 12.073C11.9685 12.0591 11.8729 12.0738 11.7877 12.1152C11.7026 12.1566 11.6319 12.2228 11.585 12.3051L10.8 13.6639C10.7526 13.7459 10.731 13.8403 10.7378 13.9347C10.7446 14.0292 10.7796 14.1194 10.8382 14.1938L10.8726 14.2374C11.0907 14.5154 11.2096 14.8583 11.2105 15.2116C11.2104 15.5268 11.1046 15.8328 10.9099 16.0807L10.8379 16.1722C10.7794 16.2466 10.7446 16.3368 10.7379 16.4311C10.7312 16.5254 10.7529 16.6196 10.8003 16.7015L11.585 18.06C11.632 18.1422 11.7026 18.2083 11.7878 18.2498C11.8729 18.2912 11.9685 18.3059 12.0622 18.2921L12.1528 18.2792C12.4822 18.2327 12.8178 18.2971 13.1065 18.4623C13.3934 18.6281 13.6165 18.8851 13.7403 19.1924L13.7753 19.2809C13.8105 19.3689 13.8712 19.4444 13.9497 19.4975C14.0282 19.5506 14.1208 19.579 14.2156 19.579H15.7844C15.9783 19.579 16.1523 19.4612 16.2243 19.2812L16.259 19.195C16.383 18.8864 16.6066 18.6281 16.8944 18.4614C17.1823 18.2969 17.5166 18.2327 17.8449 18.2789L17.9374 18.2921C18.0312 18.3062 18.1269 18.2915 18.2122 18.2501C18.2974 18.2087 18.3681 18.1424 18.4149 18.06L19.1997 16.7015C19.247 16.6195 19.2687 16.5252 19.262 16.4307C19.2552 16.3363 19.2203 16.246 19.1618 16.1716Z"
          fill="white"
        />
        <g clipPath="url(#clip1_879_2873)">
          <path
            d="M13.3792 16.9749C13.2811 16.9806 13.1847 16.948 13.1102 16.884C12.9633 16.7362 12.9633 16.4976 13.1102 16.3498L16.3269 13.1331C16.4797 12.9901 16.7194 12.998 16.8624 13.1508C16.9917 13.289 16.9992 13.5014 16.8801 13.6483L13.6444 16.884C13.5709 16.9471 13.476 16.9797 13.3792 16.9749Z"
            fill="#E20E00"
          />
          <path
            d="M16.5921 16.9749C16.4927 16.9745 16.3974 16.9351 16.3269 16.8651L13.1101 13.6483C12.974 13.4894 12.9926 13.2502 13.1515 13.1141C13.2933 12.9926 13.5025 12.9926 13.6444 13.1141L16.88 16.3308C17.0328 16.4738 17.0407 16.7136 16.8977 16.8664C16.892 16.8725 16.8861 16.8783 16.88 16.884C16.8408 16.9181 16.795 16.9438 16.7455 16.9594C16.696 16.975 16.6438 16.9803 16.5921 16.9749Z"
            fill="#E20E00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_879_2873">
          <rect
            width={18}
            height={18}
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
        <clipPath id="clip1_879_2873">
          <rect
            width={4}
            height={4}
            fill="white"
            transform="translate(13 13)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  quoteLogo: (
    <svg
      width={24}
      height={23}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.524 0.0200195H3.476C1.56 0.0200195 0 1.58002 0 3.49602V15.56C0 17.476 1.56 19.036 3.476 19.036H5.288V22.58C5.288 22.736 5.38 22.876 5.52 22.94C5.572 22.968 5.632 22.98 5.688 22.98C5.78 22.98 5.872 22.948 5.944 22.888L10.596 19.036H20.524C22.44 19.036 24 17.476 24 15.56V3.49602C24 1.58002 22.44 0.0200195 20.524 0.0200195ZM7.292 14.608C7.188 14.608 7.088 14.568 7.008 14.492L5.88 13.36C5.84193 13.3236 5.81164 13.2798 5.79094 13.2313C5.77025 13.1829 5.75958 13.1307 5.75958 13.078C5.75958 13.0253 5.77025 12.9732 5.79094 12.9247C5.81164 12.8762 5.84193 12.8324 5.88 12.796L7.692 10.984H4.724C4.504 10.984 4.324 10.804 4.324 10.584V5.17602C4.324 4.95602 4.504 4.77602 4.724 4.77602H10.916C11.14 4.77602 11.316 4.95602 11.316 5.17602V10.584C11.316 10.688 11.276 10.792 11.2 10.864L7.576 14.492C7.496 14.568 7.396 14.608 7.292 14.608ZM19.676 10.584C19.676 10.688 19.632 10.792 19.556 10.864L15.932 14.492C15.852 14.568 15.752 14.608 15.648 14.608C15.544 14.608 15.444 14.568 15.364 14.492L14.236 13.36C14.1988 13.3235 14.1694 13.28 14.1494 13.2318C14.1295 13.1837 14.1195 13.1321 14.12 13.08C14.12 12.972 14.16 12.872 14.236 12.796L16.048 10.984H13.084C12.86 10.984 12.684 10.804 12.684 10.584V5.17602C12.684 4.95602 12.86 4.77602 13.084 4.77602H19.276C19.496 4.77602 19.676 4.95602 19.676 5.17602V10.584Z"
        fill="#132F21"
      />
    </svg>
  ),
  tableEdit: (
    <svg
      width={28}
      height={28}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={24} height={24} rx={5} fill="#F16D3D" />
      <g clipPath="url(#clip0_917_5112)">
        <path
          d="M15.5 12.0235C15.2235 12.0235 15 12.2475 15 12.5234V16.5235C15 16.799 14.776 17.0234 14.5 17.0234H7.5C7.22398 17.0234 7.00003 16.799 7.00003 16.5235V9.52344C7.00003 9.24795 7.22398 9.02347 7.5 9.02347H11.5C11.7765 9.02347 12 8.79945 12 8.5235C12 8.24748 11.7765 8.02344 11.5 8.02344H7.5C6.67301 8.02344 6 8.69645 6 9.52344V16.5235C6 17.3505 6.67301 18.0235 7.5 18.0235H14.5C15.327 18.0235 16 17.3505 16 16.5235V12.5234C16 12.247 15.7764 12.0235 15.5 12.0235Z"
          fill="white"
        />
        <path
          d="M10.6881 11.5675C10.6533 11.6025 10.6295 11.6468 10.6196 11.695L10.2661 13.4631C10.2496 13.545 10.2756 13.6295 10.3346 13.689C10.3579 13.7122 10.3855 13.7306 10.4158 13.7431C10.4462 13.7556 10.4788 13.7621 10.5116 13.762C10.5276 13.762 10.5441 13.7605 10.5606 13.7571L12.3281 13.4036C12.3771 13.3935 12.4216 13.3701 12.4561 13.335L16.4121 9.37898L14.6446 7.61156L10.6881 11.5675ZM17.6341 6.38908C17.1466 5.90156 16.3536 5.90156 15.8666 6.38908L15.1746 7.08103L16.9421 8.84854L17.6341 8.1565C17.8701 7.92103 18.0001 7.60699 18.0001 7.273C18.0001 6.93902 17.8701 6.625 17.6341 6.38908Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_917_5112">
          <rect
            width={12}
            height={12}
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  tableDelete: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={24} height={24} rx={5} fill="#FF0000" />
      <path
        d="M15.9375 7.5H13.875V7.125C13.875 6.50367 13.3713 6 12.75 6H11.25C10.6287 6 10.125 6.50367 10.125 7.125V7.5H8.0625C7.54474 7.5 7.125 7.91974 7.125 8.4375V9.1875C7.125 9.39462 7.29288 9.5625 7.5 9.5625H16.5C16.7071 9.5625 16.875 9.39462 16.875 9.1875V8.4375C16.875 7.91974 16.4553 7.5 15.9375 7.5ZM10.875 7.125C10.875 6.91828 11.0433 6.75 11.25 6.75H12.75C12.9567 6.75 13.125 6.91828 13.125 7.125V7.5H10.875V7.125ZM7.83666 10.3125C7.8208 10.3125 7.8051 10.3157 7.79053 10.322C7.77595 10.3282 7.76279 10.3373 7.75185 10.3488C7.7409 10.3603 7.73241 10.3739 7.72686 10.3887C7.72132 10.4036 7.71885 10.4194 7.71961 10.4353L8.02898 16.9284C8.05758 17.5294 8.55117 18 9.15258 18H14.8474C15.4488 18 15.9424 17.5294 15.971 16.9284L16.2804 10.4353C16.2811 10.4194 16.2787 10.4036 16.2731 10.3887C16.2676 10.3739 16.2591 10.3603 16.2482 10.3488C16.2372 10.3373 16.224 10.3282 16.2095 10.322C16.1949 10.3157 16.1792 10.3125 16.1633 10.3125H7.83666ZM13.5 11.25C13.5 11.0428 13.6678 10.875 13.875 10.875C14.0822 10.875 14.25 11.0428 14.25 11.25V16.125C14.25 16.3322 14.0822 16.5 13.875 16.5C13.6678 16.5 13.5 16.3322 13.5 16.125V11.25ZM11.625 11.25C11.625 11.0428 11.7928 10.875 12 10.875C12.2072 10.875 12.375 11.0428 12.375 11.25V16.125C12.375 16.3322 12.2072 16.5 12 16.5C11.7928 16.5 11.625 16.3322 11.625 16.125V11.25ZM9.75 11.25C9.75 11.0428 9.91781 10.875 10.125 10.875C10.3322 10.875 10.5 11.0428 10.5 11.25V16.125C10.5 16.3322 10.3322 16.5 10.125 16.5C9.91781 16.5 9.75 16.3322 9.75 16.125V11.25Z"
        fill="white"
      />
    </svg>
  ),
  fileUpload: (
    <svg
      width={50}
      height={38}
      viewBox="0 0 50 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.0682 37.1908H28.3408V26.351H31.886C32.785 26.351 33.3163 25.3294 32.785 24.5938L25.8888 15.0515C25.4495 14.4385 24.5403 14.4385 24.1009 15.0515L17.2047 24.5938C16.6735 25.3294 17.1945 26.351 18.1038 26.351H21.649V37.1908H9.63425C4.27054 36.8946 0 31.8782 0 26.443C0 22.6935 2.0331 19.4242 5.047 17.6567C4.77115 16.9109 4.62812 16.114 4.62812 15.2763C4.62812 11.445 7.72374 8.34941 11.555 8.34941C12.3825 8.34941 13.1794 8.49245 13.9252 8.76829C16.1422 4.06866 20.9236 0.80957 26.4814 0.80957C33.6739 0.819787 39.5995 6.32653 40.2738 13.3453C45.801 14.2955 50 19.414 50 25.2068C50 31.398 45.1778 36.7618 39.0682 37.1908Z"
        fill="#272727"
      />
    </svg>
  ),
  uploadedFileSuccess: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.7143 10.7143V1.125L45.4643 12.5H37.5C37.0264 12.5 36.5722 12.3119 36.2373 11.977C35.9024 11.6421 35.7143 11.1879 35.7143 10.7143ZM37.5 16.0714C36.0792 16.0714 34.7166 15.507 33.7119 14.5024C32.7072 13.4977 32.1428 12.1351 32.1428 10.7143V0H8.92855C7.50775 0 6.14514 0.564412 5.14048 1.56907C4.13582 2.57373 3.57141 3.93634 3.57141 5.35714V44.6429C3.57141 46.0637 4.13582 47.4263 5.14048 48.4309C6.14514 49.4356 7.50775 50 8.92855 50H41.0714C42.4922 50 43.8548 49.4356 44.8595 48.4309C45.8641 47.4263 46.4286 46.0637 46.4286 44.6429V16.0714H37.5Z"
        fill="#272727"
      />
    </svg>
  ),
  challenge: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_78_3717)">
        <mask
          id="mask0_78_3717"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={24}
          height={24}
        >
          <path
            d="M20.0697 11.5385H16.3774L11.7296 16.1863L7.81371 12.2704L12.4615 7.62258V3.93028L16.3918 0H0V24H24V7.60818L20.0697 11.5385Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_78_3717)">
          <path
            d="M18.4616 13.8462C18.4616 11.926 17.8073 10.1571 16.7083 8.74788L16.6556 8.68105C15.13 6.76508 12.7817 5.53854 10.1538 5.53854C5.57413 5.53855 1.84617 9.26651 1.84616 13.8462C1.84616 16.1355 2.7765 18.2115 4.28256 19.7175C5.78865 21.2235 7.86454 22.1539 10.1538 22.1539C14.7336 22.1539 18.4616 18.4259 18.4616 13.8462ZM20.3077 13.8462C20.3077 19.4455 15.7532 24.0001 10.1538 24.0001C7.35358 24.0001 4.81408 22.8598 2.97716 21.0229C1.14021 19.1861 0 16.6465 0 13.8462C5.73464e-06 8.24691 4.55452 3.69239 10.1538 3.69238C13.3697 3.69238 16.2402 5.19567 18.0998 7.53101H18.0998C19.4805 9.26492 20.3077 11.4616 20.3077 13.8462Z"
            fill="black"
          />
        </g>
        <mask
          id="mask1_78_3717"
          style={{
            maskType: "luminance",
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={24}
          height={24}
        >
          <path
            d="M20.0697 11.5385H16.3774L11.7296 16.1863L7.81371 12.2704L12.4615 7.62258V3.93028L16.3918 0H0V24H24V7.60818L20.0697 11.5385Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_78_3717)">
          <path
            d="M14.7693 13.8461C14.7693 11.2971 12.7029 9.23069 10.1539 9.23068C7.60494 9.23068 5.53854 11.2971 5.53854 13.8461C5.53856 16.3951 7.60495 18.4614 10.1539 18.4614C12.7029 18.4614 14.7693 16.3951 14.7693 13.8461ZM16.6155 13.8461C16.6155 17.4147 13.7225 20.3076 10.1539 20.3076C6.58534 20.3076 3.69239 17.4147 3.69238 13.8461C3.69238 10.2775 6.58534 7.38452 10.1539 7.38452C13.7225 7.38453 16.6155 10.2775 16.6155 13.8461Z"
            fill="black"
          />
        </g>
        <path
          d="M15.8836 9.42166L11.7298 13.5755L10.4243 12.2701L14.5782 8.11621L15.8836 9.42166Z"
          fill="black"
        />
        <path
          d="M11.0771 13.8461C11.0771 13.3363 10.6638 12.9231 10.154 12.9231C9.64421 12.9231 9.23093 13.3363 9.23093 13.8461C9.23093 14.3559 9.64421 14.7692 10.154 14.7692C10.6638 14.7692 11.0771 14.3559 11.0771 13.8461ZM12.9232 13.8461C12.9232 15.3755 11.6834 16.6154 10.154 16.6154C8.62461 16.6154 7.38477 15.3755 7.38477 13.8461C7.38477 12.3167 8.6246 11.0769 10.154 11.0769C11.6834 11.0769 12.9232 12.3167 12.9232 13.8461Z"
          fill="black"
        />
        <path
          d="M19.3967 4.60356L23.6448 5.3532L19.3053 9.69261H14.3076V4.69484L18.647 0.355469L19.3967 4.60356ZM16.1538 5.45958V7.84645H18.5406L19.832 6.55505L17.8032 6.19704L17.4451 4.16818L16.1538 5.45958Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_78_3717">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  uploadIcon: (
    <svg
      width={62}
      height={62}
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_15_2219)">
        <path
          d="M6 31C6 19.2149 6 13.3223 9.66117 9.66117C13.3223 6 19.2149 6 31 6C42.785 6 48.6777 6 52.3387 9.66117C56 13.3223 56 19.2149 56 31C56 42.785 56 48.6777 52.3387 52.3387C48.6777 56 42.785 56 31 56C19.2149 56 13.3223 56 9.66117 52.3387C6 48.6777 6 42.785 6 31Z"
          fill="white"
        />
      </g>
      <path
        d="M21 20.3748C19.9645 20.3748 19.125 19.5353 19.125 18.4998C19.125 17.4642 19.9645 16.6248 21 16.6248H41C42.0355 16.6248 42.875 17.4642 42.875 18.4998C42.875 19.5353 42.0355 20.3748 41 20.3748H21Z"
        fill="black"
      />
      <path
        d="M32.875 43.4998C32.875 44.5353 32.0355 45.3748 31 45.3748C29.9645 45.3748 29.125 44.5353 29.125 43.4998V30.5265L24.8258 34.8255C24.0936 35.5578 22.9064 35.5578 22.1742 34.8255C21.4419 34.0933 21.4419 32.9063 22.1742 32.174L29.6742 24.6739C30.0257 24.3223 30.5027 24.1248 31 24.1248C31.4972 24.1248 31.9742 24.3223 32.3257 24.6739L39.8257 32.174C40.558 32.9063 40.558 34.0933 39.8257 34.8255C39.0935 35.5578 37.9065 35.5578 37.1742 34.8255L32.875 30.5265V43.4998Z"
        fill="black"
      />
      <defs>
        <filter
          id="filter0_d_15_2219"
          x={0}
          y={0}
          width={62}
          height={62}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={3} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_2219"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_2219"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  calendarIcon: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2 1.8H15V0.2C15 0.09 14.91 0 14.8 0H13.4C13.29 0 13.2 0.09 13.2 0.2V1.8H6.8V0.2C6.8 0.09 6.71 0 6.6 0H5.2C5.09 0 5 0.09 5 0.2V1.8H0.8C0.3575 1.8 0 2.1575 0 2.6V19.2C0 19.6425 0.3575 20 0.8 20H19.2C19.6425 20 20 19.6425 20 19.2V2.6C20 2.1575 19.6425 1.8 19.2 1.8ZM18.2 18.2H1.8V8.7H18.2V18.2ZM1.8 7V3.6H5V4.8C5 4.91 5.09 5 5.2 5H6.6C6.71 5 6.8 4.91 6.8 4.8V3.6H13.2V4.8C13.2 4.91 13.29 5 13.4 5H14.8C14.91 5 15 4.91 15 4.8V3.6H18.2V7H1.8Z"
        fill="#46C064"
      />
    </svg>
  ),
  undoIcon: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 8C9.85 8 7.45 9 5.6 10.6L2 7V16H11L7.38 12.38C8.77 11.22 10.54 10.5 12.5 10.5C16.04 10.5 19.05 12.81 20.1 16L22.47 15.22C21.08 11.03 17.15 8 12.5 8Z"
        fill="black"
      />
    </svg>
  ),
  redoIcon: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4 10.6C16.55 9 14.15 8 11.5 8C6.85004 8 2.92004 11.03 1.54004 15.22L3.90004 16C4.95004 12.81 7.95004 10.5 11.5 10.5C13.45 10.5 15.23 11.22 16.62 12.38L13 16H22V7L18.4 10.6Z"
        fill="black"
      />
    </svg>
  ),

  moreActionBtn: (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={6} fill="#46C064" />
      <path
        d="M16.1538 18C16.1538 19.0178 16.9821 19.8462 18 19.8462C19.0178 19.8462 19.8461 19.0178 19.8461 18C19.8461 16.9822 19.0178 16.1538 18 16.1538C16.9821 16.1538 16.1538 16.9822 16.1538 18ZM16.1538 24.1538C16.1538 25.1717 16.9821 26 18 26C19.0178 26 19.8461 25.1717 19.8461 24.1538C19.8461 23.136 19.0178 22.3077 18 22.3077C16.9821 22.3077 16.1538 23.136 16.1538 24.1538ZM16.1538 11.8462C16.1538 12.864 16.9821 13.6923 18 13.6923C19.0178 13.6923 19.8461 12.864 19.8461 11.8462C19.8461 10.8283 19.0178 10 18 10C16.9821 10 16.1538 10.8283 16.1538 11.8462Z"
        fill="white"
      />
    </svg>
  ),
  restoreLinkIcon: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3217 8.67929C15.3218 9.86367 15.0346 11.0304 14.4847 12.0794C13.9348 13.1284 13.1387 14.0283 12.1646 14.702C11.1904 15.3757 10.0674 15.803 8.89187 15.9473C7.7163 16.0916 6.52329 15.9485 5.41516 15.5304C4.30704 15.1123 3.31689 14.4315 2.52966 13.5467C1.74243 12.6618 1.18162 11.5991 0.895333 10.4498C0.609049 9.30058 0.605842 8.09903 0.885985 6.94825C1.16613 5.79748 1.72126 4.73184 2.50376 3.84276C2.51794 3.82529 2.53587 3.81124 2.55622 3.80163C2.57657 3.79202 2.59882 3.7871 2.62132 3.78725C2.66561 3.78839 2.7082 3.8045 2.74215 3.83296L3.63696 4.72777C3.66545 4.75735 3.68191 4.79649 3.68311 4.83754C3.68432 4.8786 3.6702 4.91863 3.64349 4.94984C2.79908 5.93878 2.31591 7.18538 2.27325 8.48508C2.2306 9.78478 2.631 11.0604 3.40876 12.1026C4.18651 13.1447 5.29542 13.8916 6.55352 14.2206C7.81162 14.5496 9.14417 14.4411 10.3325 13.9131C11.5209 13.385 12.4945 12.4687 13.0935 11.3145C13.6925 10.1602 13.8814 8.83669 13.6292 7.56098C13.3769 6.28528 12.6986 5.1332 11.7054 4.29379C10.7122 3.45439 9.46314 2.97751 8.16324 2.94142V4.05503C8.16307 4.08361 8.1554 4.11165 8.141 4.13633C8.12659 4.16102 8.10597 4.18149 8.08117 4.19571C8.05638 4.20992 8.02829 4.21738 7.99971 4.21734C7.97113 4.21729 7.94306 4.20975 7.91831 4.19546L4.54809 2.24909C4.52332 2.23496 4.50272 2.21453 4.48839 2.18987C4.47406 2.16521 4.46652 2.13719 4.46652 2.10867C4.46652 2.08015 4.47406 2.05213 4.48839 2.02747C4.50272 2.0028 4.52332 1.98237 4.54809 1.96824L7.91831 0.0218762C7.94313 0.00754489 7.97129 0 7.99995 0C8.02862 0 8.05677 0.00754489 8.0816 0.0218762C8.10628 0.0361237 8.1268 0.0565816 8.14112 0.0812166C8.15544 0.105852 8.16307 0.133806 8.16324 0.162302V1.35755C10.0758 1.40288 11.8949 2.19391 13.2323 3.56183C14.5697 4.92975 15.3195 6.76621 15.3217 8.67929Z"
        fill="#E58344"
      />
    </svg>
  ),
  editIcon: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_78_3520)">
        <path
          d="M13.9545 5.46504L7.71732 11.7022C7.50147 11.918 7.21864 12.052 6.91348 12.0818L4.73271 12.2827H4.65084C4.40522 12.2827 4.16705 12.186 3.99586 12.0074C3.80235 11.8138 3.70559 11.5385 3.72792 11.2631L3.92888 9.08229C3.95865 8.77713 4.09262 8.4943 4.30847 8.27846L10.5307 2.0413L13.9545 5.46504ZM15.3984 1.12582L14.87 0.597377C14.4853 0.214774 13.9648 0 13.4223 0C12.8798 0 12.3593 0.214774 11.9747 0.597377L11.3197 1.25235L14.7434 4.67609L15.3984 4.02111C15.589 3.83208 15.7404 3.60715 15.8436 3.35933C15.9469 3.1115 16.0001 2.84567 16.0001 2.57719C16.0001 2.30871 15.9469 2.04288 15.8436 1.79506C15.7404 1.54723 15.589 1.32231 15.3984 1.13327V1.12582ZM14.5127 13.2131V8.88878C14.5127 8.58362 14.2596 8.33056 13.9545 8.33056C13.6493 8.33056 13.3963 8.58362 13.3963 8.88878V13.2131C13.3963 14.136 12.6445 14.8878 11.7216 14.8878H2.79011C1.86719 14.8878 1.11546 14.136 1.11546 13.2131V4.27417C1.11546 3.35125 1.86719 2.59952 2.79011 2.59952H7.11444C7.4196 2.59952 7.67266 2.34646 7.67266 2.0413C7.67266 1.73614 7.4196 1.48308 7.11444 1.48308H2.79011C1.24943 1.48308 -0.000976562 2.73349 -0.000976562 4.27417V13.2057C-0.000976562 14.7463 1.24943 15.9968 2.79011 15.9968H11.7216C13.2623 15.9968 14.5127 14.7463 14.5127 13.2057V13.2131Z"
          fill="#46C064"
        />
      </g>
      <defs>
        <clipPath id="clip0_78_3520">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  modalClose: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C18.6229 0 24 5.37711 24 12C24 18.6229 18.6229 24 12 24C5.37711 24 0 18.6229 0 12C0 5.37711 5.37711 0 12 0ZM10.8156 12L7.50139 15.3153C7.4237 15.393 7.36207 15.4853 7.32002 15.5868C7.27797 15.6883 7.25633 15.7971 7.25633 15.907C7.25633 16.0168 7.27797 16.1256 7.32002 16.2271C7.36207 16.3287 7.4237 16.4209 7.50139 16.4986C7.57908 16.5763 7.67132 16.6379 7.77283 16.68C7.87434 16.722 7.98314 16.7436 8.09302 16.7436C8.20289 16.7436 8.31169 16.722 8.4132 16.68C8.51471 16.6379 8.60695 16.5763 8.68464 16.4986L12 13.1844L15.3153 16.4986C15.393 16.5763 15.4853 16.6379 15.5868 16.68C15.6883 16.722 15.7971 16.7436 15.907 16.7436C16.0168 16.7436 16.1256 16.722 16.2271 16.68C16.3287 16.6379 16.4209 16.5763 16.4986 16.4986C16.5763 16.4209 16.6379 16.3287 16.68 16.2271C16.722 16.1256 16.7436 16.0168 16.7436 15.907C16.7436 15.7971 16.722 15.6883 16.68 15.5868C16.6379 15.4853 16.5763 15.393 16.4986 15.3153L13.1844 12L16.4986 8.68464C16.5763 8.60695 16.6379 8.51471 16.68 8.4132C16.722 8.31169 16.7436 8.20289 16.7436 8.09302C16.7436 7.98314 16.722 7.87434 16.68 7.77283C16.6379 7.67132 16.5763 7.57908 16.4986 7.50139C16.4209 7.4237 16.3287 7.36207 16.2271 7.32002C16.1256 7.27797 16.0168 7.25633 15.907 7.25633C15.7971 7.25633 15.6883 7.27797 15.5868 7.32002C15.4853 7.36207 15.393 7.4237 15.3153 7.50139L12 10.8156L8.68464 7.50139C8.60695 7.4237 8.51471 7.36207 8.4132 7.32002C8.31169 7.27797 8.20289 7.25633 8.09302 7.25633C7.98314 7.25633 7.87434 7.27797 7.77283 7.32002C7.67132 7.36207 7.57908 7.4237 7.50139 7.50139C7.4237 7.57908 7.36207 7.67132 7.32002 7.77283C7.27797 7.87434 7.25633 7.98314 7.25633 8.09302C7.25633 8.20289 7.27797 8.31169 7.32002 8.4132C7.36207 8.51471 7.4237 8.60695 7.50139 8.68464L10.8156 12Z"
        fill="black"
      />
    </svg>
  ),
  reactiveModalSvg: (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18_2362)">
        <path
          d="M61.287 34.7171C61.2875 39.4547 60.1387 44.1216 57.9392 48.3176C55.7396 52.5136 52.555 56.1133 48.6585 58.808C44.762 61.5028 40.27 63.212 35.5677 63.7891C30.8655 64.3662 26.0934 63.794 21.6609 62.1215C17.2284 60.449 13.2678 57.7262 10.1189 54.1866C6.96996 50.6471 4.72671 46.3964 3.58158 41.7994C2.43644 37.2023 2.42361 32.3961 3.54418 27.793C4.66476 23.1899 6.88529 18.9274 10.0153 15.371C10.072 15.3012 10.1437 15.2449 10.2251 15.2065C10.3065 15.1681 10.3955 15.1484 10.4855 15.149C10.6627 15.1535 10.8331 15.218 10.9689 15.3319L14.5481 18.9111C14.6621 19.0294 14.7279 19.186 14.7327 19.3502C14.7375 19.5144 14.681 19.6745 14.5742 19.7994C11.1966 23.7551 9.26387 28.7415 9.09325 33.9403C8.92264 39.1391 10.5243 44.2415 13.6353 48.4102C16.7463 52.579 21.1819 55.5664 26.2143 56.8823C31.2467 58.1982 36.5769 57.7645 41.3304 55.6522C46.0838 53.54 49.9781 49.8747 52.3741 45.2578C54.7702 40.641 55.5258 35.3467 54.5169 30.2439C53.5079 25.1411 50.7945 20.5328 46.8217 17.1752C42.8489 13.8176 37.8528 11.9101 32.6532 11.7657V16.2201C32.6525 16.3344 32.6218 16.4466 32.5642 16.5453C32.5066 16.6441 32.4241 16.726 32.3249 16.7828C32.2258 16.8397 32.1134 16.8695 31.9991 16.8693C31.8848 16.8692 31.7725 16.839 31.6735 16.7818L18.1926 8.99637C18.0935 8.93986 18.0111 8.85813 17.9538 8.75947C17.8965 8.66082 17.8663 8.54876 17.8663 8.43467C17.8663 8.32058 17.8965 8.20852 17.9538 8.10987C18.0111 8.01122 18.0935 7.92948 18.1926 7.87297L31.6735 0.0875048C31.7728 0.0301796 31.8854 0 32.0001 0C32.1147 0 32.2273 0.0301796 32.3266 0.0875048C32.4253 0.144495 32.5074 0.226326 32.5647 0.324867C32.622 0.423407 32.6525 0.535225 32.6532 0.649207V5.43021C40.3034 5.61153 47.5797 8.77566 52.9293 14.2473C58.279 19.719 61.2782 27.0648 61.287 34.7171Z"
          fill="#46C064"
        />
      </g>
      <defs>
        <clipPath id="clip0_18_2362">
          <rect width={64} height={64} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  rejectChallengeIcon: (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_686_168)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 0C49.661 0 63.9999 14.339 63.9999 32C63.9999 49.661 49.661 63.9999 32 63.9999C14.339 63.9999 0 49.661 0 32C0 14.339 14.339 0 32 0ZM28.8417 32L20.0037 40.8409C19.7965 41.0481 19.6322 41.294 19.52 41.5647C19.4079 41.8354 19.3502 42.1256 19.3502 42.4186C19.3502 42.7116 19.4079 43.0017 19.52 43.2724C19.6322 43.5431 19.7965 43.7891 20.0037 43.9962C20.2109 44.2034 20.4568 44.3678 20.7275 44.4799C20.9982 44.592 21.2884 44.6497 21.5814 44.6497C21.8744 44.6497 22.1645 44.592 22.4352 44.4799C22.7059 44.3678 22.9519 44.2034 23.159 43.9962L32 35.1583L40.8409 43.9962C41.0481 44.2034 41.294 44.3678 41.5647 44.4799C41.8354 44.592 42.1256 44.6497 42.4186 44.6497C42.7116 44.6497 43.0017 44.592 43.2724 44.4799C43.5431 44.3678 43.7891 44.2034 43.9962 43.9962C44.2034 43.7891 44.3678 43.5431 44.4799 43.2724C44.592 43.0017 44.6497 42.7116 44.6497 42.4186C44.6497 42.1256 44.592 41.8354 44.4799 41.5647C44.3678 41.294 44.2034 41.0481 43.9962 40.8409L35.1583 32L43.9962 23.159C44.2034 22.9519 44.3678 22.7059 44.4799 22.4352C44.592 22.1645 44.6497 21.8744 44.6497 21.5814C44.6497 21.2884 44.592 20.9982 44.4799 20.7275C44.3678 20.4568 44.2034 20.2109 43.9962 20.0037C43.7891 19.7965 43.5431 19.6322 43.2724 19.52C43.0017 19.4079 42.7116 19.3502 42.4186 19.3502C42.1256 19.3502 41.8354 19.4079 41.5647 19.52C41.294 19.6322 41.0481 19.7965 40.8409 20.0037L32 28.8417L23.159 20.0037C22.9519 19.7965 22.7059 19.6322 22.4352 19.52C22.1645 19.4079 21.8744 19.3502 21.5814 19.3502C21.2884 19.3502 20.9982 19.4079 20.7275 19.52C20.4568 19.6322 20.2109 19.7965 20.0037 20.0037C19.7965 20.2109 19.6322 20.4568 19.52 20.7275C19.4079 20.9982 19.3502 21.2884 19.3502 21.5814C19.3502 21.8744 19.4079 22.1645 19.52 22.4352C19.6322 22.7059 19.7965 22.9519 20.0037 23.159L28.8417 32Z"
          fill="#FF1C0D"
        />
      </g>
      <defs>
        <clipPath id="clip0_686_168">
          <rect width={64} height={64} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  approveChallengeIcon: (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_686_172)">
        <path
          d="M32 0C14.3547 0 0 14.3547 0 32C0 49.6453 14.3547 64 32 64C49.6453 64 64 49.6453 64 32C64 14.3547 49.6453 0 32 0ZM48.2187 25.2187L30.8853 42.552C30.6383 42.8005 30.3445 42.9977 30.0209 43.1323C29.6974 43.2668 29.3504 43.3361 29 43.3361C28.6496 43.3361 28.3026 43.2668 27.9791 43.1323C27.6555 42.9977 27.3617 42.8005 27.1147 42.552L18.448 33.8853C18.2004 33.6377 18.004 33.3438 17.87 33.0203C17.736 32.6968 17.6671 32.3501 17.6671 32C17.6671 31.6499 17.736 31.3031 17.87 30.9797C18.004 30.6562 18.2004 30.3623 18.448 30.1147C18.6956 29.8671 18.9895 29.6707 19.313 29.5367C19.6365 29.4027 19.9832 29.3337 20.3333 29.3337C20.6835 29.3337 21.0302 29.4027 21.3537 29.5367C21.6772 29.6707 21.9711 29.8671 22.2187 30.1147L29 36.896L44.448 21.448C44.948 20.948 45.6262 20.6671 46.3333 20.6671C47.0405 20.6671 47.7186 20.948 48.2187 21.448C48.7187 21.948 48.9996 22.6262 48.9996 23.3333C48.9996 24.0405 48.7187 24.7186 48.2187 25.2187Z"
          fill="#46C064"
        />
      </g>
      <defs>
        <clipPath id="clip0_686_172">
          <rect width={64} height={64} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  addUserPlus: (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
        stroke="#46C064"
      />
      <path d="M12.3549 9H5.64526H12.3549Z" fill="#46C064" />
      <path d="M12.3549 9H5.64526" stroke="#46C064" strokeLinecap="round" />
      <path d="M9 5.64481L9 12.3545L9 5.64481Z" fill="#46C064" />
      <path d="M9 5.64481L9 12.3545" stroke="#46C064" strokeLinecap="round" />
    </svg>
  ),
  inactiveChallegeButton: (
    <svg
      width={28}
      height={28}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={6} fill="#FF1C0D" />
      <g clipPath="url(#clip0_88_4975)">
        <path
          d="M18 10C13.58 10 10 13.58 10 18C10 22.42 13.58 26 18 26C22.42 26 26 22.42 26 18C26 13.58 22.42 10 18 10ZM11.6 18C11.6 14.464 14.464 11.6 18 11.6C19.48 11.6 20.836 12.108 21.92 12.948L12.948 21.92C12.108 20.836 11.6 19.48 11.6 18ZM18 24.4C16.52 24.4 15.164 23.892 14.08 23.052L23.052 14.08C23.892 15.164 24.4 16.52 24.4 18C24.4 21.536 21.536 24.4 18 24.4Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_88_4975">
          <rect
            width={16}
            height={16}
            fill="white"
            transform="translate(10 10)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  inactiveOptionSvg: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_85_4882)">
        <path
          d="M7.99998 0C3.58001 0 0 3.58001 0 7.99998C0 12.42 3.58001 16 7.99998 16C12.42 16 16 12.42 16 7.99998C16 3.57997 12.42 0 7.99998 0ZM1.60001 7.99998C1.60001 4.464 4.464 1.59997 8.00002 1.59997C9.48003 1.59997 10.836 2.10799 11.92 2.94799L2.94799 11.92C2.10799 10.836 1.60001 9.47999 1.60001 7.99998ZM7.99998 14.4C6.51997 14.4 5.16397 13.892 4.08 13.052L13.052 4.08C13.892 5.16401 14.4 6.52001 14.4 7.99998C14.4 11.536 11.536 14.4 7.99998 14.4Z"
          fill="#E58344"
        />
      </g>
      <defs>
        <clipPath id="clip0_85_4882">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  cantEditIcon: (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M62.5624 45.2496L40.7124 8.41211C36.7874 1.78711 27.2124 1.78711 23.2749 8.41211L1.43745 45.2496C-2.57505 51.9996 2.29995 60.5496 10.1499 60.5496H53.8499C61.6999 60.5496 66.5749 51.9996 62.5624 45.2496ZM31.9999 52.3996C29.4124 52.3996 27.3124 50.2996 27.3124 47.7121C27.3124 45.1246 29.4124 43.0246 31.9999 43.0246C34.5874 43.0246 36.6874 45.1246 36.6874 47.7121C36.6874 50.2996 34.5874 52.3996 31.9999 52.3996ZM36.8124 22.5621L36.2374 36.1121C36.1374 38.4496 34.1624 40.2621 31.8249 40.1621C29.6249 40.0746 27.8624 38.3121 27.7749 36.1121L27.1999 22.5621C27.0624 19.8996 29.1124 17.6371 31.7624 17.4996C34.4249 17.3621 36.6874 19.4121 36.8249 22.0621C36.8249 22.2371 36.8249 22.3996 36.8124 22.5621Z"
        fill="#FC9502"
      />
    </svg>
  ),
  shareIcon: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_561_170)">
        <path
          d="M12.6875 10.375C11.7612 10.375 10.945 10.8307 10.4323 11.5236L5.99969 9.25387C6.07328 9.00303 6.125 8.74306 6.125 8.46875C6.125 8.09669 6.04872 7.74297 5.91694 7.41762L10.5558 4.62612C11.0721 5.232 11.8309 5.625 12.6875 5.625C14.2384 5.625 15.5 4.36341 15.5 2.8125C15.5 1.26159 14.2384 0 12.6875 0C11.1366 0 9.875 1.26159 9.875 2.8125C9.875 3.16991 9.94859 3.50894 10.0707 3.82369L5.41797 6.62337C4.90216 6.0355 4.15428 5.65625 3.3125 5.65625C1.76159 5.65625 0.5 6.91784 0.5 8.46875C0.5 10.0197 1.76159 11.2812 3.3125 11.2812C4.25406 11.2812 5.08409 10.8122 5.59484 10.0998L10.0128 12.3622C9.93147 12.6248 9.875 12.8984 9.875 13.1875C9.875 14.7384 11.1366 16 12.6875 16C14.2384 16 15.5 14.7384 15.5 13.1875C15.5 11.6366 14.2384 10.375 12.6875 10.375Z"
          fill="#E58344"
        />
      </g>
      <defs>
        <clipPath id="clip0_561_170">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  bannerLibrary: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4761 2.66602H1.52383C0.682308 2.66602 0 3.34828 0 4.1898V19.8089C0 20.6503 0.682308 21.3326 1.52383 21.3326H22.4761C23.3177 21.3326 24 20.6503 24 19.8088V4.1898C24 3.34828 23.3177 2.66602 22.4761 2.66602ZM22.4761 4.1898V15.2721L19.4731 12.5418C19.0217 12.1315 18.3276 12.1479 17.8963 12.5795L14.8571 15.6183L8.86438 8.46025C8.4114 7.9193 7.58169 7.91398 7.1219 8.44845L1.52383 14.9544V4.1898H22.4761ZM16 8.1898C16 7.03246 16.9378 6.09455 18.0952 6.09455C19.2526 6.09455 20.1904 7.03246 20.1904 8.1898C20.1904 9.34714 19.2526 10.285 18.0952 10.285C16.9379 10.285 16 9.34714 16 8.1898Z"
        fill="#292D32"
      />
    </svg>
  ),
  deleteBanner: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={20} height={20} rx={6} fill="#FF1C0D" />
      <g clipPath="url(#clip0_972_14703)">
        <path
          d="M13.0161 6.01786H6.98394C6.6952 6.01838 6.41844 6.13331 6.21427 6.33748C6.0101 6.54164 5.89517 6.81841 5.89465 7.10714V7.36071C5.89479 7.40803 5.91365 7.45337 5.94711 7.48683C5.98057 7.52029 6.02591 7.53914 6.07322 7.53929H13.9268C13.9741 7.53914 14.0195 7.52029 14.0529 7.48683C14.0864 7.45337 14.1052 7.40803 14.1054 7.36071V7.10714C14.1048 6.81841 13.9899 6.54164 13.7857 6.33748C13.5816 6.13331 13.3048 6.01838 13.0161 6.01786ZM11.45 5.66071V5.54643C11.45 5.40151 11.3924 5.26252 11.29 5.16005C11.1875 5.05757 11.0485 5 10.9036 5H9.04822C8.90339 5.00028 8.76457 5.05794 8.66215 5.16036C8.55974 5.26277 8.50208 5.40159 8.5018 5.54643V5.66071H11.45ZM6.42322 7.89643L6.91608 14.1036C6.93627 14.3472 7.04705 14.5744 7.22656 14.7404C7.40607 14.9063 7.64126 14.999 7.88572 15H12.0786C12.323 14.999 12.5582 14.9063 12.7377 14.7404C12.9173 14.5744 13.028 14.3472 13.0482 14.1036L13.5429 7.89643H6.42322ZM11.3679 11.0607C11.3732 9.69464 11.3839 8.33036 11.3839 8.33036C11.384 8.30702 11.3887 8.28392 11.3978 8.2624C11.4068 8.24088 11.42 8.22135 11.4366 8.20493C11.4531 8.18851 11.4728 8.17552 11.4944 8.16671C11.516 8.15789 11.5392 8.15343 11.5625 8.15357H11.5643C11.6116 8.15418 11.6568 8.1735 11.6899 8.20729C11.723 8.24108 11.7414 8.28661 11.7411 8.33393C11.725 10.3732 11.7107 13.4607 11.7339 13.7571C11.7413 13.7836 11.7425 13.8115 11.7374 13.8385C11.7322 13.8655 11.7209 13.891 11.7044 13.913C11.6878 13.9349 11.6663 13.9527 11.6417 13.965C11.6171 13.9774 11.59 13.9838 11.5625 13.9839C11.5386 13.9837 11.515 13.9788 11.4929 13.9696C11.3572 13.9125 11.3572 13.9125 11.3679 11.0607ZM9.80358 8.33214C9.80358 8.28478 9.8224 8.23936 9.85588 8.20587C9.88937 8.17238 9.93479 8.15357 9.98215 8.15357C10.0295 8.15357 10.0749 8.17238 10.1084 8.20587C10.1419 8.23936 10.1607 8.28478 10.1607 8.33214V13.8054C10.1607 13.8527 10.1419 13.8981 10.1084 13.9316C10.0749 13.9651 10.0295 13.9839 9.98215 13.9839C9.93479 13.9839 9.88937 13.9651 9.85588 13.9316C9.8224 13.8981 9.80358 13.8527 9.80358 13.8054V8.33214ZM8.21608 8.33214C8.21608 8.28478 8.2349 8.23936 8.26838 8.20587C8.30187 8.17238 8.34729 8.15357 8.39465 8.15357C8.44201 8.15357 8.48743 8.17238 8.52092 8.20587C8.55441 8.23936 8.57322 8.28478 8.57322 8.33214V13.8054C8.57322 13.8527 8.55441 13.8981 8.52092 13.9316C8.48743 13.9651 8.44201 13.9839 8.39465 13.9839C8.34729 13.9839 8.30187 13.9651 8.26838 13.9316C8.2349 13.8981 8.21608 13.8527 8.21608 13.8054V8.33214Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_972_14703">
          <rect
            width={10}
            height={10}
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  checkMarkIcon: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1161_847)">
        <path
          d="M10 0C4.48583 0 0 4.48583 0 10C0 15.5142 4.48583 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48583 15.5142 0 10 0ZM15.0683 7.88083L9.65167 13.2975C9.57446 13.3752 9.48265 13.4368 9.38154 13.4788C9.28043 13.5209 9.17201 13.5425 9.0625 13.5425C8.95299 13.5425 8.84457 13.5209 8.74346 13.4788C8.64234 13.4368 8.55054 13.3752 8.47333 13.2975L5.765 10.5892C5.68763 10.5118 5.62626 10.4199 5.58438 10.3189C5.54251 10.2178 5.52096 10.1094 5.52096 10C5.52096 9.89058 5.54251 9.78223 5.58438 9.68114C5.62626 9.58006 5.68763 9.4882 5.765 9.41083C5.84237 9.33346 5.93422 9.27209 6.03531 9.23022C6.1364 9.18834 6.24475 9.16679 6.35417 9.16679C6.46358 9.16679 6.57193 9.18834 6.67302 9.23022C6.77411 9.27209 6.86596 9.33346 6.94333 9.41083L9.0625 11.53L13.89 6.7025C14.0463 6.54624 14.2582 6.45846 14.4792 6.45846C14.7001 6.45846 14.9121 6.54624 15.0683 6.7025C15.2246 6.85876 15.3124 7.07069 15.3124 7.29167C15.3124 7.51265 15.2246 7.72458 15.0683 7.88083Z"
          fill="#46C064"
        />
      </g>
      <defs>
        <clipPath id="clip0_1161_847">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  checkBoxIcon: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1187_589)">
        <path
          d="M10 17.9999C11.497 17.9999 12.854 17.6499 14.07 16.9469C15.274 16.269 16.269 15.2739 16.9469 14.0699C17.6499 12.842 17.9999 11.485 17.9999 10C17.9999 8.50303 17.6499 7.14605 16.9469 5.93007C16.2757 4.72101 15.279 3.72431 14.07 3.05311C12.854 2.35012 11.497 2.00013 10 2.00013C8.51505 2.00013 7.15807 2.35012 5.93009 3.05311C4.72603 3.73092 3.73095 4.72601 3.05313 5.93007C2.35014 7.14605 2.00015 8.50303 2.00015 10C2.00015 11.485 2.35014 12.842 3.05313 14.0699C3.73761 15.2689 4.7311 16.2624 5.93009 16.9469C7.15807 17.6499 8.51505 17.9999 10 17.9999ZM10 19.9999C8.23848 20.0106 6.50607 19.5504 4.9821 18.6669C3.47041 17.7865 2.2131 16.5289 1.33316 15.0169C0.449777 13.4933 -0.0104213 11.7612 0.000179073 10C0.000179073 8.18703 0.444172 6.51506 1.33316 4.98208C2.21093 3.47308 3.46955 2.22102 4.9831 1.35114C6.50313 0.456983 8.23654 -0.00979632 10 0.000155877C11.813 0.000155877 13.485 0.450149 15.0179 1.35014C16.5317 2.22142 17.7849 3.48158 18.6479 5.00008C19.5499 6.53206 19.9999 8.19903 19.9999 10C19.9999 11.801 19.5499 13.474 18.6499 15.0169C17.7763 16.5341 16.5171 17.7933 14.9999 18.6669C13.483 19.5516 11.7561 20.012 10 19.9999Z"
          fill="#D6D6D6"
        />
      </g>
      <defs>
        <clipPath id="clip0_1187_589">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  emptyBanners: (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.4602 4.44336H2.53972C1.13718 4.44336 0 5.58047 0 6.98301V33.0148C0 34.4172 1.13718 35.5543 2.53972 35.5543H37.4602C38.8628 35.5543 40 34.4172 40 33.0147V6.98301C40 5.58047 38.8629 4.44336 37.4602 4.44336ZM37.4602 6.98301V25.4534L32.4551 20.903C31.7028 20.2191 30.546 20.2465 29.8273 20.9658L24.7618 26.0305L14.774 14.1004C14.019 13.1988 12.6361 13.19 11.8698 14.0807L2.53972 24.9239V6.98301H37.4602ZM26.6667 13.6497C26.6667 11.7208 28.2297 10.1576 30.1586 10.1576C32.0876 10.1576 33.6507 11.7208 33.6507 13.6497C33.6507 15.5786 32.0877 17.1417 30.1586 17.1417C28.2298 17.1417 26.6667 15.5786 26.6667 13.6497Z"
        fill="#939598"
      />
    </svg>
  ),
  activateChallengeForUser: (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1446_725)">
        <circle cx={32} cy={32} r={30} stroke="#46C064" strokeWidth={4} />
        <g clipPath="url(#clip1_1446_725)">
          <path
            d="M46.267 20.4069C45.2922 19.4321 43.712 19.4321 42.7372 20.4069L25.8506 37.2995L20.2561 31.7049C19.2813 30.7301 17.701 30.7301 16.7262 31.7049C15.7514 32.6797 15.7514 34.26 16.7262 35.2348L24.0827 42.5913C24.8879 43.3965 26.1352 43.554 27.1161 42.9788C27.1524 42.9545 27.1887 42.9364 27.219 42.9122C27.3583 42.8213 27.4915 42.7124 27.6125 42.5913L46.267 23.9368C47.2418 22.962 47.2418 21.3817 46.267 20.4069Z"
            fill="#46C064"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1446_725">
          <rect width={64} height={64} fill="white" />
        </clipPath>
        <clipPath id="clip1_1446_725">
          <rect
            width={31}
            height={31}
            fill="white"
            transform="translate(16 16)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  questionBank: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1336_2728)">
        <path
          d="M12 0C5.36761 0 0 5.367 0 12C0 18.6323 5.367 24 12 24C18.6324 24 24 18.633 24 12C24 5.36761 18.633 0 12 0ZM11.6449 17.6165C10.9657 17.6165 10.4445 17.0479 10.4445 16.4002C10.4445 15.7368 10.9815 15.184 11.6449 15.184C12.3084 15.184 12.8611 15.7368 12.8611 16.4002C12.8611 17.0478 12.3241 17.6165 11.6449 17.6165ZM13.4456 11.472C12.5768 12.1512 12.561 12.6251 12.561 13.4464C12.561 13.7466 12.403 14.0941 11.6291 14.0941C10.9814 14.0941 10.7603 13.8571 10.7603 13.0358C10.7603 11.6774 11.3606 11.0297 11.8186 10.6349C12.3399 10.1925 13.2245 9.70294 13.2245 8.85C13.2245 8.12334 12.5926 7.77586 11.8028 7.77586C10.1917 7.77586 10.5392 8.99217 9.6862 8.99217C9.25974 8.99217 8.73848 8.70778 8.73848 8.0918C8.73848 7.23886 9.7178 5.97516 11.8502 5.97516C13.872 5.97516 15.2147 7.09669 15.2147 8.58145C15.2147 10.0662 13.872 11.1403 13.4456 11.472Z"
          fill="#292D32"
        />
      </g>
      <defs>
        <clipPath id="clip0_1336_2728">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  emptyCheckbox: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1331_1430)">
        <path
          d="M12 21.5999C13.7964 21.5999 15.4248 21.1799 16.884 20.3363C18.3288 19.5228 19.5228 18.3287 20.3363 16.8839C21.1799 15.4104 21.5999 13.782 21.5999 12C21.5999 10.2036 21.1799 8.57526 20.3363 7.11608C19.5309 5.66521 18.3348 4.46917 16.884 3.66373C15.4248 2.82014 13.7964 2.40015 12 2.40015C10.2181 2.40015 8.58968 2.82014 7.11611 3.66373C5.67124 4.47711 4.47714 5.67121 3.66376 7.11608C2.82017 8.57526 2.40018 10.2036 2.40018 12C2.40018 13.782 2.82017 15.4104 3.66376 16.8839C4.48513 18.3227 5.67732 19.5149 7.11611 20.3363C8.58968 21.1799 10.2181 21.5999 12 21.5999ZM12 23.9998C9.88618 24.0128 7.80728 23.4605 5.97852 22.4002C4.16449 21.3438 2.65572 19.8346 1.59979 18.0203C0.539733 16.1919 -0.0125055 14.1134 0.000214888 12C0.000214888 9.82444 0.533007 7.81807 1.59979 5.9785C2.65312 4.1677 4.16346 2.66523 5.97972 1.62136C7.80376 0.54838 9.88384 -0.0117556 12 0.000187052C14.1756 0.000187052 16.182 0.540179 18.0215 1.62016C19.838 2.66571 21.3419 4.1779 22.3775 6.0001C23.4599 7.83847 23.9998 9.83884 23.9998 12C23.9998 14.1612 23.4599 16.1687 22.3799 18.0203C21.3316 19.8409 19.8205 21.3519 17.9999 22.4002C16.1796 23.4619 14.1073 24.0144 12 23.9998Z"
          fill="#D6D6D6"
        />
      </g>
      <defs>
        <clipPath id="clip0_1331_1430">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  dragHandle: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 6C9.10457 6 10 5.10457 10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4C6 5.10457 6.89543 6 8 6Z"
        fill="#939598"
      />
      <path
        d="M8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14Z"
        fill="#939598"
      />
      <path
        d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z"
        fill="#939598"
      />
      <path
        d="M16 6C17.1046 6 18 5.10457 18 4C18 2.89543 17.1046 2 16 2C14.8954 2 14 2.89543 14 4C14 5.10457 14.8954 6 16 6Z"
        fill="#939598"
      />
      <path
        d="M16 14C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10C14.8954 10 14 10.8954 14 12C14 13.1046 14.8954 14 16 14Z"
        fill="#939598"
      />
      <path
        d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z"
        fill="#939598"
      />
    </svg>
  ),
  correctOption: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1331_1351)">
        <path
          d="M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM18.082 9.457L11.582 15.957C11.4893 16.0502 11.3792 16.1241 11.2579 16.1746C11.1365 16.2251 11.0064 16.251 10.875 16.251C10.7436 16.251 10.6135 16.2251 10.4921 16.1746C10.3708 16.1241 10.2607 16.0502 10.168 15.957L6.918 12.707C6.82516 12.6142 6.75151 12.5039 6.70126 12.3826C6.65101 12.2613 6.62515 12.1313 6.62515 12C6.62515 11.8687 6.65101 11.7387 6.70126 11.6174C6.75151 11.4961 6.82516 11.3858 6.918 11.293C7.01084 11.2002 7.12107 11.1265 7.24237 11.0763C7.36368 11.026 7.4937 11.0001 7.625 11.0001C7.7563 11.0001 7.88632 11.026 8.00762 11.0763C8.12893 11.1265 8.23915 11.2002 8.332 11.293L10.875 13.836L16.668 8.043C16.8555 7.85549 17.1098 7.75015 17.375 7.75015C17.6402 7.75015 17.8945 7.85549 18.082 8.043C18.2695 8.23051 18.3748 8.48482 18.3748 8.75C18.3748 9.01518 18.2695 9.26949 18.082 9.457Z"
          fill="#46C064"
        />
      </g>
      <defs>
        <clipPath id="clip0_1331_1351">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  upload: (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1336_2299)">
        <path
          d="M21.2002 13.6445C20.9878 13.6445 20.784 13.7289 20.6338 13.8791C20.4836 14.0293 20.3993 14.233 20.3993 14.4454V17.1806C20.3993 17.8252 20.1432 18.4435 19.6873 18.8994C19.2315 19.3552 18.6132 19.6113 17.9685 19.6113H4.0326C3.38792 19.6113 2.76964 19.3552 2.31378 18.8994C1.85793 18.4435 1.60183 17.8252 1.60183 17.1806V14.4454C1.60183 14.233 1.51745 14.0293 1.36724 13.8791C1.21704 13.7289 1.01333 13.6445 0.800913 13.6445C0.588498 13.6445 0.384782 13.7289 0.234582 13.8791C0.0843817 14.0293 0 14.233 0 14.4454V17.1806C0.00106018 18.2498 0.426262 19.2748 1.18229 20.0309C1.93832 20.7869 2.96341 21.2121 4.0326 21.2132H17.9685C19.0377 21.2121 20.0628 20.7869 20.8188 20.0309C21.5748 19.2748 22 18.2498 22.0011 17.1806V14.4454C22.0011 14.233 21.9167 14.0293 21.7665 13.8791C21.6163 13.7289 21.4126 13.6445 21.2002 13.6445Z"
          fill="white"
        />
        <path
          d="M6.99763 6.71539L10.2013 3.51173V15.4053C10.2013 15.6177 10.2857 15.8214 10.4359 15.9716C10.5861 16.1218 10.7898 16.2062 11.0022 16.2062C11.2146 16.2062 11.4183 16.1218 11.5685 15.9716C11.7187 15.8214 11.8031 15.6177 11.8031 15.4053V3.52375L15.0068 6.7274C15.0812 6.80182 15.1695 6.86084 15.2667 6.90111C15.364 6.94139 15.4682 6.96211 15.5734 6.96211C15.6786 6.96211 15.7829 6.94139 15.8801 6.90111C15.9773 6.86084 16.0656 6.80182 16.1401 6.7274C16.2145 6.65299 16.2735 6.56465 16.3138 6.46742C16.354 6.3702 16.3748 6.26599 16.3748 6.16076C16.3748 6.05552 16.354 5.95131 16.3138 5.85409C16.2735 5.75686 16.2145 5.66852 16.1401 5.59411L11.5708 1.0249C11.4595 0.916907 11.3212 0.840834 11.1704 0.804647C11.0408 0.780786 10.9073 0.788331 10.7812 0.826652C10.6551 0.864972 10.54 0.932952 10.4456 1.0249L5.87635 5.5821C5.7492 5.7351 5.68354 5.92995 5.69216 6.1287C5.70078 6.32745 5.78306 6.51589 5.92298 6.65731C6.0629 6.79873 6.25045 6.88301 6.4491 6.89375C6.64775 6.90448 6.84328 6.8409 6.99763 6.71539Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1336_2299">
          <rect width={22} height={22} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  filterButton: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={0.5}
        y={0.5}
        width={49}
        height={49}
        rx={9.5}
        fill="white"
        stroke="#46C064"
      />
      <g clipPath="url(#clip0_1436_1127)">
        <path
          d="M35.428 13.043H14.1083C13.9239 13.0426 13.7429 13.0932 13.5854 13.1892C13.4279 13.2852 13.3 13.4227 13.2157 13.5868C13.1303 13.7532 13.0924 13.9399 13.1063 14.1264C13.1203 14.3129 13.1854 14.492 13.2946 14.6438L21.1053 25.6466C21.1079 25.6504 21.1107 25.6539 21.1134 25.6577C21.3971 26.041 21.5507 26.505 21.5515 26.9818V35.9523C21.5507 36.0838 21.5758 36.2142 21.6256 36.3359C21.6753 36.4577 21.7487 36.5684 21.8414 36.6616C21.9341 36.7549 22.0443 36.829 22.1657 36.8795C22.2872 36.93 22.4174 36.9559 22.5489 36.9559C22.6841 36.9559 22.8175 36.9289 22.9422 36.8772L27.3312 35.2036C27.7245 35.0837 27.9856 34.7126 27.9856 34.2657V26.9818C27.9863 26.505 28.1398 26.041 28.4235 25.6577C28.4261 25.6539 28.4289 25.6504 28.4315 25.6466L36.242 14.6433C36.3512 14.4916 36.4163 14.3126 36.4302 14.1262C36.4442 13.9398 36.4063 13.7531 36.3209 13.5869C36.2366 13.4228 36.1086 13.2852 35.951 13.1892C35.7935 13.0932 35.6125 13.0426 35.428 13.043ZM27.4447 24.9386C27.0085 25.5307 26.7725 26.2464 26.7712 26.9818V34.1182L22.7653 35.6455V26.9818C22.764 26.2464 22.5279 25.5306 22.0915 24.9386L14.5088 14.2569H35.0278L27.4447 24.9386Z"
          fill="#46C064"
        />
      </g>
      <defs>
        <clipPath id="clip0_1436_1127">
          <rect
            width={23.913}
            height={23.913}
            fill="white"
            transform="translate(13.043 13.043)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  filterCheckbox: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1436_1195)">
        <path
          d="M13.6 0H2.4C1.08 0 0 1.08 0 2.4V13.6C0 14.92 1.08 16 2.4 16H13.6C14.92 16 16 14.92 16 13.6V2.4C16 1.08 14.92 0 13.6 0ZM11.568 6.568L7.568 10.568C7.408 10.72 7.208 10.8 7 10.8C6.792 10.8 6.592 10.72 6.432 10.568L4.432 8.568C4.12 8.256 4.12 7.744 4.432 7.432C4.744 7.12 5.256 7.12 5.568 7.432L7 8.872L10.432 5.432C10.744 5.12 11.256 5.12 11.568 5.432C11.88 5.744 11.88 6.256 11.568 6.568Z"
          fill="#E0E0E0"
        />
      </g>
      <defs>
        <clipPath id="clip0_1436_1195">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  filterCrossIcon: (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1436_1228)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99999 0C12.4152 0 16 3.58474 16 7.99999C16 12.4152 12.4152 16 7.99999 16C3.58474 16 0 12.4152 0 7.99999C0 3.58474 3.58474 0 7.99999 0ZM7.21041 7.99999L5.00093 10.2102C4.94913 10.262 4.90804 10.3235 4.88001 10.3912C4.85198 10.4589 4.83755 10.5314 4.83755 10.6046C4.83755 10.6779 4.85198 10.7504 4.88001 10.8181C4.90804 10.8858 4.94913 10.9473 5.00093 10.9991C5.05272 11.0509 5.11421 11.0919 5.18189 11.12C5.24956 11.148 5.32209 11.1624 5.39534 11.1624C5.46859 11.1624 5.54113 11.148 5.6088 11.12C5.67648 11.0919 5.73797 11.0509 5.78976 10.9991L7.99999 8.78957L10.2102 10.9991C10.262 11.0509 10.3235 11.0919 10.3912 11.12C10.4589 11.148 10.5314 11.1624 10.6046 11.1624C10.6779 11.1624 10.7504 11.148 10.8181 11.12C10.8858 11.0919 10.9473 11.0509 10.9991 10.9991C11.0509 10.9473 11.0919 10.8858 11.12 10.8181C11.148 10.7504 11.1624 10.6779 11.1624 10.6046C11.1624 10.5314 11.148 10.4589 11.12 10.3912C11.0919 10.3235 11.0509 10.262 10.9991 10.2102L8.78957 7.99999L10.9991 5.78976C11.0509 5.73797 11.0919 5.67648 11.12 5.6088C11.148 5.54113 11.1624 5.46859 11.1624 5.39534C11.1624 5.32209 11.148 5.24956 11.12 5.18189C11.0919 5.11421 11.0509 5.05272 10.9991 5.00093C10.9473 4.94913 10.8858 4.90804 10.8181 4.88001C10.7504 4.85198 10.6779 4.83755 10.6046 4.83755C10.5314 4.83755 10.4589 4.85198 10.3912 4.88001C10.3235 4.90804 10.262 4.94913 10.2102 5.00093L7.99999 7.21041L5.78976 5.00093C5.73797 4.94913 5.67648 4.90804 5.6088 4.88001C5.54113 4.85198 5.46859 4.83755 5.39534 4.83755C5.32209 4.83755 5.24956 4.85198 5.18189 4.88001C5.11421 4.90804 5.05272 4.94913 5.00093 5.00093C4.94913 5.05272 4.90804 5.11421 4.88001 5.18189C4.85198 5.24956 4.83755 5.32209 4.83755 5.39534C4.83755 5.46859 4.85198 5.54113 4.88001 5.6088C4.90804 5.67648 4.94913 5.73797 5.00093 5.78976L7.21041 7.99999Z"
          fill="#FF0000"
        />
      </g>
      <defs>
        <clipPath id="clip0_1436_1228">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  editQuestionIcon: (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={6} fill="#46C064" />
      <path
        d="M19.6982 11.2616L19.9382 11.0213C21.3786 9.65957 23.6193 9.65957 24.9797 11.0213C26.3401 12.383 26.3401 14.7059 24.9797 16.0676L24.7396 16.3079L19.6982 11.2616ZM12.0159 18.9512C11.6158 19.3517 11.2957 19.9124 11.1357 20.4731L10.0153 25.0388C9.93531 25.4393 10.1754 25.9199 10.5755 26H10.8956L15.3769 24.8786C15.9371 24.7184 16.4972 24.4781 16.8973 23.9975L12.0159 18.9512ZM18.4978 12.383L13.1362 17.7497L18.1777 22.796L23.5393 17.4293L18.4978 12.383Z"
        fill="white"
      />
    </svg>
  ),
  viewQuestionIcon: (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={6} fill="#E58344" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4314 17.9994C14.4314 16.0325 16.0312 14.432 18.0003 14.432C19.9672 14.432 21.567 16.0324 21.567 17.9994C21.567 19.9667 19.9672 21.5665 18.0003 21.5665C16.0312 21.5665 14.4314 19.9667 14.4314 17.9994ZM10.0923 17.659C9.96923 17.8816 9.96923 18.1171 10.0923 18.3399C11.69 21.209 14.7199 22.9913 18.0003 22.9913C21.2784 22.9913 24.3084 21.209 25.9061 18.3399C26.0313 18.1171 26.0313 17.8816 25.9061 17.659C24.3084 14.7899 21.2784 13.0078 18.0003 13.0078C14.7199 13.0078 11.69 14.7899 10.0923 17.659ZM18.0003 15.6011C16.6763 15.6011 15.6005 16.6768 15.6005 17.9994C15.6005 19.3219 16.6762 20.3976 18.0003 20.3976C19.3221 20.3976 20.3979 19.3219 20.3979 17.9994C20.3979 16.6768 19.3221 15.6011 18.0003 15.6011Z"
        fill="white"
      />
    </svg>
  ),
  deleteQuestionIcon: (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={6} fill="#FF1C0D" />
      <path
        d="M22.8259 11.6286H13.1745C12.7125 11.6294 12.2697 11.8133 11.943 12.14C11.6164 12.4666 11.4325 12.9094 11.4316 13.3714V13.7771C11.4319 13.8528 11.462 13.9254 11.5156 13.9789C11.5691 14.0325 11.6416 14.0626 11.7174 14.0629H24.2831C24.3588 14.0626 24.4313 14.0325 24.4849 13.9789C24.5384 13.9254 24.5686 13.8528 24.5688 13.7771V13.3714C24.568 12.9094 24.3841 12.4666 24.0574 12.14C23.7307 11.8133 23.2879 11.6294 22.8259 11.6286ZM20.3202 11.0571V10.8743C20.3202 10.6424 20.2281 10.42 20.0641 10.2561C19.9002 10.0921 19.6778 10 19.4459 10H16.4774C16.2456 10.0005 16.0235 10.0927 15.8596 10.2566C15.6958 10.4204 15.6035 10.6425 15.6031 10.8743V11.0571H20.3202ZM12.2774 14.6343L13.0659 24.5657C13.0982 24.9555 13.2755 25.3191 13.5627 25.5846C13.8499 25.8501 14.2262 25.9983 14.6174 26H21.3259C21.7171 25.9983 22.0934 25.8501 22.3806 25.5846C22.6678 25.3191 22.845 24.9555 22.8774 24.5657L23.6688 14.6343H12.2774ZM20.1888 19.6971C20.1974 17.5114 20.2145 15.3286 20.2145 15.3286C20.2146 15.2912 20.2222 15.2543 20.2366 15.2198C20.2511 15.1854 20.2722 15.1542 20.2987 15.1279C20.3252 15.1016 20.3567 15.0808 20.3913 15.0667C20.4258 15.0526 20.4629 15.0455 20.5002 15.0457H20.5031C20.5788 15.0467 20.651 15.0776 20.704 15.1317C20.757 15.1857 20.7865 15.2586 20.7859 15.3343C20.7602 18.5971 20.7374 23.5371 20.7745 24.0114C20.7863 24.0538 20.7882 24.0984 20.78 24.1416C20.7718 24.1849 20.7537 24.2256 20.7272 24.2608C20.7006 24.2959 20.6663 24.3244 20.627 24.3441C20.5876 24.3638 20.5442 24.3741 20.5002 24.3743C20.4619 24.3739 20.4241 24.3661 20.3888 24.3514C20.1716 24.26 20.1716 24.26 20.1888 19.6971ZM17.6859 15.3314C17.6859 15.2557 17.716 15.183 17.7696 15.1294C17.8232 15.0758 17.8959 15.0457 17.9716 15.0457C18.0474 15.0457 18.1201 15.0758 18.1737 15.1294C18.2273 15.183 18.2574 15.2557 18.2574 15.3314V24.0886C18.2574 24.1643 18.2273 24.237 18.1737 24.2906C18.1201 24.3442 18.0474 24.3743 17.9716 24.3743C17.8959 24.3743 17.8232 24.3442 17.7696 24.2906C17.716 24.237 17.6859 24.1643 17.6859 24.0886V15.3314ZM15.1459 15.3314C15.1459 15.2557 15.176 15.183 15.2296 15.1294C15.2832 15.0758 15.3559 15.0457 15.4316 15.0457C15.5074 15.0457 15.5801 15.0758 15.6337 15.1294C15.6873 15.183 15.7174 15.2557 15.7174 15.3314V24.0886C15.7174 24.1643 15.6873 24.237 15.6337 24.2906C15.5801 24.3442 15.5074 24.3743 15.4316 24.3743C15.3559 24.3743 15.2832 24.3442 15.2296 24.2906C15.176 24.237 15.1459 24.1643 15.1459 24.0886V15.3314Z"
        fill="white"
      />
    </svg>
  ),
  uploadedFile: (
    <svg
      width={50}
      height={50}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6685 32.1693C13.6685 31.3389 13.0924 30.8438 12.0757 30.8438C11.6606 30.8438 11.3795 30.8847 11.2324 30.9239V33.5881C11.4065 33.6273 11.6206 33.6403 11.9156 33.6403C12.9992 33.6403 13.6685 33.0929 13.6685 32.1693ZM19.9618 30.8716C19.5066 30.8716 19.2124 30.911 19.0383 30.9517V36.8521C19.2125 36.8929 19.4936 36.8929 19.7478 36.8929C21.5947 36.906 22.7992 35.8894 22.7992 33.7352C22.8123 31.862 21.7146 30.8716 19.9618 30.8716Z"
        fill="#E58344"
      />
      <path
        d="M31.6537 0H11.5717C8.63786 0 6.25007 2.38945 6.25007 5.32159V24.9999V27.1444L6.25 40.1493L6.25005 42.2936L6.25007 44.6783C6.25007 47.6137 8.63786 49.9999 11.5717 49.9999H38.9727C41.9046 49.9999 44.2928 47.6136 44.2928 44.6783V12.5948L31.6537 0ZM38.9727 46.7409H11.5717C10.4357 46.7409 9.51064 45.8158 9.51064 44.6783V42.2936H41.4393C42.6236 42.2936 43.5838 41.3344 43.5838 40.1493V27.1444C43.5838 25.9593 42.6236 24.9999 41.4393 24.9999H9.51064V5.32159C9.51064 4.18727 10.4358 3.26223 11.5717 3.26223L30.4344 3.24252V10.2149C30.4344 12.2514 32.0869 13.9054 34.125 13.9054L40.9551 13.8858L41.032 44.6782C41.032 45.8158 40.1086 46.7409 38.9727 46.7409Z"
        fill="#E58344"
      />
    </svg>
  ),
  deleteUploadedFile: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0319 2.03571H3.96763C3.39016 2.03675 2.83663 2.26661 2.4283 2.67495C2.01996 3.08329 1.7901 3.63681 1.78906 4.21429V4.72143C1.78935 4.81606 1.82706 4.90674 1.89398 4.97365C1.9609 5.04057 2.05157 5.07829 2.14621 5.07857H17.8533C17.948 5.07829 18.0387 5.04057 18.1056 4.97365C18.1725 4.90674 18.2102 4.81606 18.2105 4.72143V4.21429C18.2095 3.63681 17.9796 3.08329 17.5713 2.67495C17.1629 2.26661 16.6094 2.03675 16.0319 2.03571ZM12.8998 1.32143V1.09286C12.8998 0.803013 12.7846 0.525041 12.5797 0.32009C12.3747 0.11514 12.0968 0 11.8069 0H8.09621C7.80654 0.000566316 7.52889 0.115888 7.32406 0.320716C7.11924 0.525544 7.00391 0.803187 7.00335 1.09286V1.32143H12.8998ZM2.84621 5.79286L3.83192 18.2071C3.8723 18.6944 4.09386 19.1488 4.45288 19.4807C4.81189 19.8126 5.28228 19.9979 5.77121 20H14.1569C14.6458 19.9979 15.1162 19.8126 15.4752 19.4807C15.8343 19.1488 16.0558 18.6944 16.0962 18.2071L17.0855 5.79286H2.84621ZM12.7355 12.1214C12.7462 9.38929 12.7676 6.66071 12.7676 6.66071C12.7678 6.61403 12.7772 6.56785 12.7953 6.5248C12.8133 6.48176 12.8397 6.4427 12.8729 6.40986C12.906 6.37701 12.9454 6.35104 12.9886 6.33341C13.0318 6.31579 13.0781 6.30686 13.1248 6.30714H13.1283C13.223 6.30837 13.3133 6.34699 13.3795 6.41458C13.4458 6.48216 13.4826 6.57322 13.4819 6.66786C13.4498 10.7464 13.4212 16.9214 13.4676 17.5143C13.4824 17.5673 13.4848 17.623 13.4745 17.677C13.4643 17.7311 13.4417 17.782 13.4085 17.8259C13.3753 17.8698 13.3324 17.9055 13.2832 17.9301C13.234 17.9547 13.1798 17.9676 13.1248 17.9679C13.0769 17.9673 13.0297 17.9576 12.9855 17.9393C12.7141 17.825 12.7141 17.825 12.7355 12.1214ZM9.60692 6.66429C9.60692 6.56957 9.64455 6.47872 9.71152 6.41175C9.7785 6.34477 9.86934 6.30714 9.96406 6.30714C10.0588 6.30714 10.1496 6.34477 10.2166 6.41175C10.2836 6.47872 10.3212 6.56957 10.3212 6.66429V17.6107C10.3212 17.7054 10.2836 17.7963 10.2166 17.8633C10.1496 17.9302 10.0588 17.9679 9.96406 17.9679C9.86934 17.9679 9.7785 17.9302 9.71152 17.8633C9.64455 17.7963 9.60692 17.7054 9.60692 17.6107V6.66429ZM6.43192 6.66429C6.43192 6.56957 6.46955 6.47872 6.53652 6.41175C6.6035 6.34477 6.69434 6.30714 6.78906 6.30714C6.88378 6.30714 6.97462 6.34477 7.0416 6.41175C7.10858 6.47872 7.14621 6.56957 7.14621 6.66429V17.6107C7.14621 17.7054 7.10858 17.7963 7.0416 17.8633C6.97462 17.9302 6.88378 17.9679 6.78906 17.9679C6.69434 17.9679 6.6035 17.9302 6.53652 17.8633C6.46955 17.7963 6.43192 17.7054 6.43192 17.6107V6.66429Z"
        fill="#FF1C0D"
      />
    </svg>
  ),
  uploadSuccess: (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1454_1981)">
        <circle cx={32} cy={32} r={30} stroke="#46C064" strokeWidth={4} />
        <g clipPath="url(#clip1_1454_1981)">
          <path
            d="M46.268 20.4069C45.2932 19.4321 43.7129 19.4321 42.7381 20.4069L25.8516 37.2995L20.2571 31.7049C19.2823 30.7301 17.702 30.7301 16.7272 31.7049C15.7524 32.6797 15.7524 34.26 16.7272 35.2348L24.0836 42.5913C24.8889 43.3965 26.1362 43.554 27.117 42.9788C27.1534 42.9545 27.1897 42.9364 27.22 42.9122C27.3592 42.8213 27.4924 42.7124 27.6135 42.5913L46.268 23.9368C47.2428 22.962 47.2428 21.3817 46.268 20.4069Z"
            fill="#46C064"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1454_1981">
          <rect width={64} height={64} fill="white" />
        </clipPath>
        <clipPath id="clip1_1454_1981">
          <rect
            width={31}
            height={31}
            fill="white"
            transform="translate(16 16)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  uploadSuccessMessage: (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1467_7269)">
        <path
          d="M10.5 0C16.299 0 21 4.70101 21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0ZM10.5 1.3125C5.42588 1.3125 1.3125 5.42588 1.3125 10.5C1.3125 15.5741 5.42588 19.6875 10.5 19.6875C15.5741 19.6875 19.6875 15.5741 19.6875 10.5C19.6875 5.42588 15.5741 1.3125 10.5 1.3125Z"
          fill="#46C064"
        />
        <g clipPath="url(#clip1_1467_7269)">
          <path
            d="M14.7867 7.27866C14.5037 6.99565 14.0449 6.99565 13.7619 7.27866L8.85933 12.183L7.23511 10.5587C6.9521 10.2757 6.49331 10.2757 6.2103 10.5587C5.92729 10.8417 5.92729 11.3005 6.2103 11.5835L8.34604 13.7193C8.57983 13.9531 8.94194 13.9988 9.22671 13.8318C9.23726 13.8248 9.2478 13.8195 9.25659 13.8125C9.29702 13.7861 9.33569 13.7544 9.37085 13.7193L14.7867 8.30347C15.0697 8.02046 15.0697 7.56167 14.7867 7.27866Z"
            fill="#46C064"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1467_7269">
          <rect width={21} height={21} fill="white" />
        </clipPath>
        <clipPath id="clip1_1467_7269">
          <rect width={9} height={9} fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  ),
  uploadErrorMessage: (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1467_7279)">
        <path
          d="M10.5 0C16.299 0 21 4.70101 21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0ZM10.5 1.3125C5.42588 1.3125 1.3125 5.42588 1.3125 10.5C1.3125 15.5741 5.42588 19.6875 10.5 19.6875C15.5741 19.6875 19.6875 15.5741 19.6875 10.5C19.6875 5.42588 15.5741 1.3125 10.5 1.3125Z"
          fill="#FF1C0D"
        />
        <rect
          x={7.44922}
          y={6.55078}
          width={9.70711}
          height={1.07857}
          rx={0.539284}
          transform="rotate(45 7.44922 6.55078)"
          fill="#FF1C0D"
        />
        <rect
          x={6.68555}
          y={13.4141}
          width={9.70711}
          height={1.07857}
          rx={0.539284}
          transform="rotate(-45 6.68555 13.4141)"
          fill="#FF1C0D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1467_7279">
          <rect width={21} height={21} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  quizIcon: (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1331_783)">
        <path
          d="M8.01562 19.0781C8.01562 20.2431 8.96002 21.1875 10.125 21.1875H13.875C15.04 21.1875 15.9844 20.2431 15.9844 19.0781V17.8125H8.01562V19.0781ZM10.8281 24H13.1719C13.9485 24 14.5781 23.3704 14.5781 22.5938H9.42188C9.42188 23.3704 10.0515 24 10.8281 24ZM23.2969 7.03125H21.8906C21.5023 7.03125 21.1875 7.34606 21.1875 7.73438C21.1875 8.12269 21.5023 8.4375 21.8906 8.4375H23.2969C23.6852 8.4375 24 8.12269 24 7.73438C24 7.34606 23.6852 7.03125 23.2969 7.03125ZM2.10938 8.4375C2.49769 8.4375 2.8125 8.12269 2.8125 7.73438C2.8125 7.34606 2.49769 7.03125 2.10938 7.03125H0.703125C0.314812 7.03125 0 7.34606 0 7.73438C0 8.12269 0.314812 8.4375 0.703125 8.4375H2.10938ZM21.5375 5.02833L22.8589 4.54734C23.2238 4.41455 23.4119 4.01105 23.2791 3.64612C23.1463 3.2812 22.7428 3.09309 22.3779 3.22589L21.0565 3.70688C20.6916 3.83967 20.5035 4.24317 20.6362 4.60809C20.769 4.97302 21.1726 5.16113 21.5375 5.02833ZM2.46253 10.4404L1.14112 10.9214C0.776203 11.0542 0.588094 11.4577 0.720891 11.8226C0.853687 12.1875 1.25719 12.3757 1.62211 12.2429L2.94352 11.7619C3.30844 11.6291 3.49655 11.2256 3.36375 10.8607C3.23095 10.4957 2.82741 10.3076 2.46253 10.4404ZM22.8589 10.9214L21.5375 10.4404C21.1726 10.3076 20.7691 10.4957 20.6363 10.8607C20.5035 11.2256 20.6916 11.629 21.0565 11.7619L22.3779 12.2429C22.7429 12.3757 23.1463 12.1875 23.2792 11.8226C23.412 11.4577 23.2238 11.0542 22.8589 10.9214ZM2.94347 3.70692L1.62206 3.22594C1.25714 3.09314 0.853688 3.28125 0.720844 3.64617C0.588 4.01109 0.776156 4.41455 1.14108 4.54739L2.46248 5.02838C2.82741 5.16117 3.23086 4.97306 3.3637 4.60814C3.49655 4.24322 3.30839 3.83972 2.94347 3.70692ZM12 0C7.73527 0 4.26562 3.46964 4.26562 7.73438C4.26562 9.72511 5.02045 11.6162 6.39103 13.0592C7.27448 13.9894 7.8232 15.1581 7.97353 16.4062H16.0265C16.1768 15.158 16.7255 13.9894 17.609 13.0592C18.9795 11.6162 19.7344 9.72511 19.7344 7.73438C19.7344 3.46964 16.2647 0 12 0ZM12 12.1875C11.6117 12.1875 11.2969 11.8727 11.2969 11.4844C11.2969 11.0961 11.6117 10.7812 12 10.7812C12.3883 10.7812 12.7031 11.0961 12.7031 11.4844C12.7031 11.8727 12.3883 12.1875 12 12.1875ZM13.0652 7.68033C12.9563 7.74408 12.7031 7.92469 12.7031 8.22389V8.67188C12.7031 9.06019 12.3883 9.375 12 9.375C11.6117 9.375 11.2969 9.06019 11.2969 8.67188V8.22389C11.2969 7.51162 11.6922 6.85481 12.3544 6.46697C12.5695 6.34097 12.7031 6.10814 12.7031 5.85942C12.7031 5.47172 12.3877 5.1563 12 5.1563C11.6123 5.1563 11.2969 5.47172 11.2969 5.85942C11.2969 6.24773 10.9821 6.56255 10.5938 6.56255C10.2054 6.56255 9.89062 6.24773 9.89062 5.85942C9.89062 4.69631 10.8369 3.75005 12 3.75005C13.1631 3.75005 14.1094 4.69631 14.1094 5.85942C14.1094 6.6053 13.7092 7.30303 13.0652 7.68033Z"
          fill="#292D32"
        />
      </g>
      <defs>
        <clipPath id="clip0_1331_783">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  expandIcon: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.13337 4.74163L9.99951 12.6077L17.8656 4.74163C18.1005 4.50956 18.4177 4.37986 18.7479 4.38087C19.0781 4.38187 19.3945 4.51349 19.628 4.74698C19.8615 4.98047 19.9931 5.29686 19.9941 5.62707C19.9951 5.95727 19.8654 6.27446 19.6334 6.50936L10.8834 15.2594C10.649 15.4938 10.331 15.6255 9.99951 15.6255C9.668 15.6255 9.35006 15.4938 9.11564 15.2594L0.365639 6.50936C0.13357 6.27446 0.00387594 5.95727 0.00487725 5.62707C0.00588048 5.29686 0.137497 4.98047 0.370989 4.74698C0.604479 4.51349 0.920874 4.38187 1.25108 4.38087C1.58128 4.37987 1.89847 4.50956 2.13337 4.74163Z"
        fill="black"
      />
    </svg>
  ),
  collapseIcon: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8666 15.2584L10.0005 7.39228L2.13436 15.2584C1.89946 15.4904 1.58227 15.6201 1.25206 15.6191C0.921861 15.6181 0.605467 15.4865 0.371976 15.253C0.138485 15.0195 0.00686745 14.7031 0.00586509 14.3729C0.00486272 14.0427 0.134557 13.7255 0.366626 13.4906L9.11663 4.74064C9.35105 4.50623 9.66898 4.37454 10.0005 4.37454C10.332 4.37454 10.6499 4.50623 10.8844 4.74064L19.6344 13.4906C19.8664 13.7255 19.9961 14.0427 19.9951 14.3729C19.9941 14.7031 19.8625 15.0195 19.629 15.253C19.3955 15.4865 19.0791 15.6181 18.7489 15.6191C18.4187 15.6201 18.1015 15.4904 17.8666 15.2584Z"
        fill="black"
      />
    </svg>
  ),
  dropDownIcon: (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.69336 10C7.69336 11.2723 8.72874 12.3077 10.0011 12.3077C11.2734 12.3077 12.3087 11.2723 12.3087 10C12.3087 8.72769 11.2734 7.69231 10.0011 7.69231C8.72874 7.69231 7.69336 8.72769 7.69336 10ZM7.69336 17.6923C7.69336 18.9646 8.72874 20 10.0011 20C11.2734 20 12.3087 18.9646 12.3087 17.6923C12.3087 16.42 11.2734 15.3846 10.0011 15.3846C8.72874 15.3846 7.69336 16.42 7.69336 17.6923ZM7.69336 2.30769C7.69336 3.58 8.72874 4.61538 10.0011 4.61538C11.2734 4.61538 12.3087 3.58 12.3087 2.30769C12.3087 1.03538 11.2734 0 10.0011 0C8.72874 0 7.69336 1.03538 7.69336 2.30769Z"
        fill="#E58344"
      />
    </svg>
  ),
  publishIcon: (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1265_14152)">
        <path
          d="M61.5563 0.102118C61.526 0.111743 61.494 0.0984928 61.464 0.109618L1.46403 22.6096C0.806656 22.8569 0.341656 23.4519 0.261031 24.1514C0.180406 24.8509 0.497281 25.5356 1.08316 25.9256L14.2373 34.6939L19.0495 54.8014C19.0622 54.8542 19.0947 54.8964 19.1115 54.9471C19.544 56.2662 21.2052 56.685 22.1989 55.6912L31.6122 46.278L46.0832 55.9256C47.1317 56.6287 48.5772 56.1039 48.9268 54.8801L63.9268 2.38012C64.3295 0.967118 63.0032 -0.362382 61.5563 0.102118ZM23.6107 38.2414C23.3002 38.5559 23.2067 38.8107 23.0978 39.2072C23.0964 39.2146 23.0932 39.2215 23.0918 39.2287L20.9995 46.8364L18.0185 34.3797L47.0592 14.467L23.6107 38.2414ZM12.5757 51.415C11.8433 50.6826 10.6567 50.6825 9.92428 51.415L0.549281 60.79C-0.183094 61.5224 -0.183094 62.709 0.549281 63.4414C1.28178 64.1739 2.46816 64.1739 3.20066 63.4414L12.5757 54.0664C13.308 53.334 13.308 52.1474 12.5757 51.415Z"
          fill="#E58344"
        />
        <path
          d="M12.5757 40.1646C11.8433 39.4322 10.6567 39.4321 9.92428 40.1646L0.549281 49.5396C-0.183094 50.2719 -0.183094 51.4586 0.549281 52.1909C1.28178 52.9234 2.46816 52.9234 3.20066 52.1909L12.5757 42.8159C13.308 42.0836 13.308 40.8969 12.5757 40.1646Z"
          fill="#E58344"
        />
      </g>
      <defs>
        <clipPath id="clip0_1265_14152">
          <rect width={64} height={64} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};

export default icons;
